// This file is parsed by revEditorService. Please do not remove comment tokens around AutoCorrectList obj.
window.revEditor = window.revEditor || {};
window.revEditor.AutoCorrectList =
/*parser:begin*/{
    "ninties":"nineties",
    "alot":"a lot",
    "avengence":"a vengeance",
    "abondon":"abandon",
    "adbandon":"abandon",
    "abandonned":"abandoned",
    "abondoned":"abandoned",
    "abondoning":"abandoning",
    "abondons":"abandons",
    "abreviate":"abbreviate",
    "abreviated":"abbreviated",
    "abreviation":"abbreviation",
    "aberation":"aberration",
    "abilties":"abilities",
    "abilty":"ability",
    "aborigene":"aborigine",
    "abortificant":"abortifacient",
    "baout":"about",
    "absail":"abseil",
    "absailing":"abseiling",
    "absense":"absence",
    "absolutly":"absolutely",
    "asorbed":"absorbed",
    "absorbsion":"absorption",
    "absorbtion":"absorption",
    "abundacies":"abundances",
    "abundancies":"abundances",
    "abundunt":"abundant",
    "abutts":"abuts",
    "acadmic":"academic",
    "accademic":"academic",
    "acedemic":"academic",
    "acadamy":"academy",
    "accademy":"academy",
    "accelleration":"acceleration",
    "acceptible":"acceptable",
    "acceptence":"acceptance",
    "accessable":"accessible",
    "accension":"accession",
    "accidentaly":"accidentally",
    "accidently":"accidentally",
    "acclimitization":"acclimatization",
    "accomadate":"accommodate",
    "accomdate":"accommodate",
    "accomodate":"accommodate",
    "acommodate":"accommodate",
    "accomadated":"accommodated",
    "accomodated":"accommodated",
    "accomadates":"accommodates",
    "accomodates":"accommodates",
    "accomadating":"accommodating",
    "accomodating":"accommodating",
    "accomadation":"accommodation",
    "accomodation":"accommodation",
    "accomadations":"accommodations",
    "accomodations":"accommodations",
    "accompanyed":"accompanied",
    "acomplish":"accomplish",
    "acomplished":"accomplished",
    "acomplishment":"accomplishment",
    "acomplishments":"accomplishments",
    "accoring":"according",
    "acording":"according",
    "acordingly":"accordingly",
    "accordeon":"accordion",
    "accordian":"accordion",
    "accrediation":"accreditation",
    "accredidation":"accreditation",
    "acuracy":"accuracy",
    "acccused":"accused",
    "accussed":"accused",
    "acused":"accused",
    "acustom":"accustom",
    "acustommed":"accustomed",
    "acheive":"achieve",
    "achive":"achieve",
    "acheived":"achieved",
    "achived":"achieved",
    "acheivement":"achievement",
    "acheivment":"achievement",
    "achievment":"achievement",
    "achivement":"achievement",
    "acheivements":"achievements",
    "acheivments":"achievements",
    "achievments":"achievements",
    "achivements":"achievements",
    "acheives":"achieves",
    "acheiving":"achieving",
    "acknowldeged":"acknowledged",
    "acknowledgeing":"acknowledging",
    "accoustic":"acoustic",
    "acquaintence":"acquaintance",
    "acquiantence":"acquaintance",
    "aquaintance":"acquaintance",
    "aquiantance":"acquaintance",
    "acquaintences":"acquaintances",
    "acquiantences":"acquaintances",
    "aquainted":"acquainted",
    "accquainted":"acquainted ",
    "adquire":"acquire",
    "aquire":"acquire",
    "adquired":"acquired",
    "aquired":"acquired",
    "adquires":"acquires",
    "adquiring":"acquiring",
    "aquiring":"acquiring",
    "aquisition":"acquisition",
    "acquited":"acquitted",
    "aquitted":"acquitted",
    "accross":"across",
    "activly":"actively",
    "activites":"activities",
    "actualy":"actually",
    "addtion":"addition",
    "additonal":"additional",
    "addtional":"additional",
    "additinally":"additionally",
    "additionaly":"additionally",
    "additonally":"additionally",
    "addres":"address",
    "adres":"address",
    "adress":"address",
    "addresable":"addressable",
    "adresable":"addressable",
    "adressable":"addressable",
    "addresed":"addressed",
    "adressed":"addressed",
    "addressess":"addresses",
    "addresing":"addressing",
    "adresing":"addressing",
    "adressing":"addressing",
    "adecuate":"adequate",
    "adequit":"adequate",
    "adherance":"adherence",
    "adhearing":"adhering",
    "adminstered":"administered",
    "adminstrate":"administrate",
    "adminstration":"administration",
    "admininistrative":"administrative",
    "adminstrative":"administrative",
    "adminstrator":"administrator",
    "admissability":"admissibility",
    "admissable":"admissible",
    "addmission":"admission",
    "admited":"admitted",
    "admitedly":"admittedly",
    "adolecent":"adolescent",
    "addopt":"adopt",
    "addopted":"adopted",
    "addoptive":"adoptive",
    "adavanced":"advanced",
    "adventrous":"adventurous",
    "advesary":"adversary",
    "advertisment":"advertisement",
    "advertisments":"advertisements",
    "adviced":"advised",
    "aeriel":"aerial",
    "aeriels":"aerials",
    "areodynamics":"aerodynamics",
    "asthetic":"aesthetic",
    "asthetical":"aesthetical",
    "asthetically":"aesthetically",
    "afair":"affair",
    "affilate":"affiliate",
    "affilliate":"affiliate",
    "affort":"afford",
    "afficionado":"aficionado",
    "afficianados":"aficionados",
    "afficionados":"aficionados",
    "aforememtioned":"aforementioned",
    "agian":"again",
    "agin":"again",
    "agina":"again",
    "againnst":"against",
    "agains":"against",
    "agaisnt":"against",
    "aganist":"against",
    "agianst":"against",
    "aginst":"against",
    "agravate":"aggravate",
    "aggaravates":"aggravates",
    "agregate":"aggregate",
    "agregates":"aggregates",
    "agression":"aggression",
    "aggresive":"aggressive",
    "agressive":"aggressive",
    "agressively":"aggressively",
    "agressor":"aggressor",
    "agrieved":"aggrieved",
    "agre":"agree",
    "aggreed":"agreed",
    "agred":"agreed",
    "agreing":"agreeing",
    "aggreement":"agreement",
    "agreeement":"agreement",
    "agreemnt":"agreement",
    "agricuture":"agriculture",
    "airbourne":"airborne",
    "aicraft":"aircraft",
    "aircaft":"aircraft",
    "aircrafts":"aircraft",
    "airrcraft":"aircraft",
    "aiport":"airport",
    "airporta":"airports",
    "albiet":"albeit",
    "alchohol":"alcohol",
    "alchol":"alcohol",
    "alcohal":"alcohol",
    "alochol":"alcohol",
    "alchoholic":"alcoholic",
    "alcholic":"alcoholic",
    "alcoholical":"alcoholic",
    "algebraical":"algebraic",
    "algoritm":"algorithm",
    "algorhitms":"algorithms",
    "algoritms":"algorithms",
    "alientating":"alienating",
    "allign":"align",
    "alligned":"aligned",
    "aledge":"allege",
    "alege":"allege",
    "alledge":"allege",
    "aledged":"alleged",
    "aleged":"alleged",
    "alledged":"alleged",
    "alledgedly":"allegedly",
    "allegedely":"allegedly",
    "allegedy":"allegedly",
    "allegely":"allegedly",
    "aledges":"alleges",
    "alledges":"alleges",
    "alegience":"allegiance",
    "allegence":"allegiance",
    "allegience":"allegiance",
    "alliviate":"alleviate",
    "allopone":"allophone",
    "allopones":"allophones",
    "alotted":"allotted",
    "alowed":"allowed",
    "alowing":"allowing",
    "alltime":"all-time",
    "alusion":"allusion",
    "almsot":"almost",
    "alomst":"almost",
    "allready":"already",
    "alreayd":"already",
    "aready":"already",
    "alsot":"also",
    "aslo":"also",
    "alternitives":"alternatives",
    "allthough":"although",
    "altho":"although",
    "althought":"although",
    "altough":"although",
    "alltogether":"altogether",
    "alwasy":"always",
    "alwyas":"always",
    "amalgomated":"amalgamated",
    "amatuer":"amateur",
    "amerliorate":"ameliorate",
    "ammend":"amend",
    "ammended":"amended",
    "admendment":"amendment",
    "amendmant":"amendment",
    "ammendment":"amendment",
    "ammendments":"amendments",
    "amercia":"America",
    "amunition":"ammunition",
    "amoung":"among",
    "amung":"among",
    "amoungst":"amongst",
    "ammount":"amount",
    "ammused":"amused",
    "analagous":"analogous",
    "analogeous":"analogous",
    "analitic":"analytic",
    "anarchim":"anarchism",
    "anarchistm":"anarchism",
    "ansestors":"ancestors",
    "ancestory":"ancestry",
    "ancilliary":"ancillary",
    "adn":"and",
    "anbd":"and",
    "androgenous":"androgynous",
    "androgeny":"androgyny",
    "anihilation":"annihilation",
    "aniversary":"anniversary",
    "annouced":"announced",
    "anounced":"announced",
    "anouncement":"announcement",
    "anual":"annual",
    "annualy":"annually",
    "annuled":"annulled",
    "anulled":"annulled",
    "annoint":"anoint",
    "annointed":"anointed",
    "annointing":"anointing",
    "annoints":"anoints",
    "anomolies":"anomalies",
    "anomolous":"anomalous",
    "anomoly":"anomaly",
    "anonimity":"anonymity",
    "anohter":"another",
    "anwsered":"answered",
    "antartic":"antarctic",
    "anthropolgist":"anthropologist",
    "anthropolgy":"anthropology",
    "anthromorphization":"anthropomorphization",
    "anyother":"any other",
    "anytying":"anything",
    "anyhwere":"anywhere",
    "appart":"apart",
    "aparment":"apartment",
    "appartment":"apartment",
    "appartments":"apartments",
    "apenines":"apennines",
    "appenines":"apennines",
    "apolegetics":"apologetics",
    "appologies":"apologies",
    "appology":"apology",
    "aparent":"apparent",
    "apparant":"apparent",
    "apparantly":"apparently",
    "appealling":"appealing",
    "appeareance":"appearance",
    "appearence":"appearance",
    "apperance":"appearance",
    "appereance":"appearance",
    "apprearance":"appearance",
    "appearences":"appearances",
    "apperances":"appearances",
    "appereances":"appearances",
    "aplication":"application",
    "applicaiton":"application",
    "applicaitons":"applications",
    "aplied":"applied",
    "apprieciate":"appreciate",
    "aprehensive":"apprehensive",
    "approachs":"approaches",
    "appropiate":"appropriate",
    "appropraite":"appropriate",
    "appropropiate":"appropriate",
    "apropriate":"appropriate",
    "approproximate":"approximate",
    "aproximate":"approximate",
    "approxamately":"approximately",
    "approxiately":"approximately",
    "approximitely":"approximately",
    "aproximately":"approximately",
    "april":"April",
    "aquaduct":"aqueduct",
    "arbitarily":"arbitrarily",
    "abritrary":"arbitrary",
    "arbitary":"arbitrary",
    "archaelogists":"archeologists",
    "archaelogy":"archeology",
    "archiac":"archaic",
    "archeaologist":"archeologist",
    "archeaologists":"archeologists",
    "archaoelogy":"archeology",
    "archaology":"archeology",
    "archtype":"archetype",
    "archtypes":"archetypes",
    "archimedian":"archimedean",
    "archetect":"architect",
    "archictect":"architect",
    "architecht":"architect",
    "archetects":"architects",
    "archetectural":"architectural",
    "architectual":"architectural",
    "archetecturally":"architecturally",
    "architechturally":"architecturally",
    "archetecture":"architecture",
    "architechture":"architecture",
    "architechtures":"architectures",
    "argubly":"arguably",
    "arguement":"argument",
    "arguements":"arguments",
    "armamant":"armament",
    "amature":"armature",
    "armistace":"armistice",
    "arised":"arose",
    "aroud":"around",
    "arround":"around",
    "arund":"around",
    "aranged":"arranged",
    "arangement":"arrangement",
    "arrangment":"arrangement",
    "arrangments":"arrangements",
    "erested":"arrested",
    "arival":"arrival",
    "arogant":"arrogant",
    "arogent":"arrogant",
    "artical":"article",
    "artice":"article",
    "articel":"article",
    "artifical":"artificial",
    "artifically":"artificially",
    "artillary":"artillery",
    "asfar":"as far",
    "aswell":"as well",
    "asetic":"ascetic",
    "aisian":"asian",
    "asside":"aside",
    "spects":"aspects",
    "asphyxation":"asphyxiation",
    "assasin":"assassin",
    "assasinate":"assassinate",
    "assisnate":"assassinate",
    "assasinated":"assassinated",
    "assasined":"assassinated",
    "assasinates":"assassinates",
    "assasination":"assassination",
    "assassintation":"assassination",
    "assosication":"assassination",
    "assasinations":"assassinations",
    "assasins":"assassins",
    "asssassans":"assassins",
    "assualt":"assault",
    "assualted":"assaulted",
    "assemple":"assemble",
    "assertation":"assertion",
    "asign":"assign",
    "assit":"assist",
    "assitant":"assistant",
    "assoicate":"associate",
    "asociated":"associated",
    "assoicated":"associated",
    "assoicates":"associates",
    "assocation":"association",
    "asume":"assume",
    "asteriod":"asteroid",
    "assymetric":"asymmetric",
    "assymetrical":"asymmetrical",
    "athiesm":"atheism",
    "athiest":"atheist",
    "atheistical":"atheistic",
    "athenean":"athenian",
    "atheneans":"athenians",
    "attrocities":"atrocities",
    "atain":"attain",
    "attaindre":"attainder",
    "attemp":"attempt",
    "attemt":"attempt",
    "attemped":"attempted",
    "attemted":"attempted",
    "atempting":"attempting",
    "attemting":"attempting",
    "attemts":"attempts",
    "attendence":"attendance",
    "attendent":"attendant",
    "attendents":"attendants",
    "attened":"attended",
    "attension":"attention",
    "attitide":"attitude",
    "atorney":"attorney",
    "atribute":"attribute",
    "atributed":"attributed",
    "attributred":"attributed",
    "atributes":"attributes",
    "audeince":"audience",
    "august":"August",
    "austrailia":"Australia",
    "austrailian":"Australian",
    "auther":"author",
    "autor":"author",
    "authorative":"authoritative",
    "authoritive":"authoritative",
    "authorites":"authorities",
    "authoritiers":"authorities",
    "authrorities":"authorities",
    "authorithy":"authority",
    "autority":"authority",
    "authobiographic":"autobiographic",
    "authobiography":"autobiography",
    "autochtonous":"autochthonous",
    "autoctonous":"autochthonous",
    "auromated":"automated",
    "automaticly":"automatically",
    "automibile":"automobile",
    "automonomous":"autonomous",
    "auxillaries":"auxiliaries",
    "auxilliaries":"auxiliaries",
    "auxilary":"auxiliary",
    "auxillary":"auxiliary",
    "auxilliary":"auxiliary",
    "availablity":"availability",
    "availaible":"available",
    "availble":"available",
    "availiable":"available",
    "availible":"available",
    "avalable":"available",
    "avaliable":"available",
    "avilable":"available",
    "avalance":"avalanche",
    "averageed":"averaged",
    "avation":"aviation",
    "awared":"awarded",
    "awya":"away",
    "ackward":"awkward",
    "bakc":"back",
    "bcak":"back",
    "backgorund":"background",
    "backrounds":"backgrounds",
    "banannas":"bananas",
    "bandwith":"bandwidth",
    "bankrupcy":"bankruptcy",
    "banruptcy":"bankruptcy",
    "basicaly":"basically",
    "basicly":"basically",
    "cattleship":"battleship",
    "beachead":"beachhead",
    "beatiful":"beautiful",
    "beautyfull":"beautiful",
    "becamae":"became",
    "baceause":"because",
    "beacuse":"because",
    "becasue":"because",
    "beccause":"because",
    "becouse":"because",
    "becuase":"because",
    "becames":"becomes",
    "becomeing":"becoming",
    "becomming":"becoming",
    "bedore":"before",
    "befoer":"before",
    "beggin":"begin",
    "begginer":"beginner",
    "begginers":"beginners",
    "beggining":"beginning",
    "begining":"beginning",
    "beginnig":"beginning",
    "begginings":"beginnings",
    "beggins":"begins",
    "behavour":"behavior",
    "beng":"being",
    "beleagured":"beleaguered",
    "beligum":"belgium",
    "beleif":"belief",
    "beleive":"believe",
    "belive":"believe",
    "beleived":"believed",
    "belived":"believed",
    "beleives":"believes",
    "belives":"believes",
    "beleiving":"believing",
    "belligerant":"belligerent",
    "bellweather":"bellwether",
    "bemusemnt":"bemusement",
    "benificial":"beneficial",
    "beneficary":"beneficiary",
    "benifit":"benefit",
    "benifits":"benefits",
    "bergamont":"bergamot",
    "bernouilli":"Bernoulli",
    "beseige":"besiege",
    "beseiged":"besieged",
    "beseiging":"besieging",
    "beastiality":"bestiality",
    "betwen":"between",
    "beween":"between",
    "bewteen":"between",
    "inbetween":"between",
    "vetween":"between",
    "bilateraly":"bilaterally",
    "billingualism":"bilingualism",
    "binominal":"binomial",
    "bizzare":"bizarre",
    "blaim":"blame",
    "blaimed":"blamed",
    "blessure":"blessing",
    "blitzkreig":"Blitzkrieg",
    "bodydbuilder":"bodybuilder",
    "bombardement":"bombardment",
    "bombarment":"bombardment",
    "bonnano":"Bonanno",
    "bondary":"boundary",
    "boundry":"boundary",
    "boaut":"bout",
    "brasillian":"Brazilian",
    "breakthough":"breakthrough",
    "breakthroughts":"breakthroughs",
    "brethen":"brethren",
    "bretheren":"brethren",
    "breif":"brief",
    "breifly":"briefly",
    "briliant":"brilliant",
    "brillant":"brilliant",
    "brimestone":"brimstone",
    "britian":"Britain",
    "brittish":"British",
    "broacasted":"broadcast",
    "broadacasting":"broadcasting",
    "broady":"broadly",
    "borke":"broke",
    "buddah":"Buddha",
    "buddist":"Buddhist",
    "bouyancy":"buoyancy",
    "buoancy":"buoyancy",
    "bouyant":"buoyant",
    "boyant":"buoyant",
    "beaurocracy":"bureaucracy",
    "beaurocratic":"bureaucratic",
    "burried":"buried",
    "buring":"burying",
    "buisness":"business",
    "busineses":"business",
    "busness":"business",
    "bussiness":"business",
    "buisnessman":"businessman",
    "ceasar":"Caesar",
    "casion":"caisson",
    "caluclate":"calculate",
    "caluculate":"calculate",
    "calulate":"calculate",
    "caluclated":"calculated",
    "caluculated":"calculated",
    "calulated":"calculated",
    "caculater":"calculator",
    "calculater":"calculator",
    "calulater":"calculator",
    "calculs":"calculus",
    "calander":"calendar",
    "calenders":"calendars",
    "calaber":"caliber",
    "caligraphy":"calligraphy",
    "cambrige":"Cambridge",
    "camoflage":"camouflage",
    "campain":"campaign",
    "campains":"campaigns",
    "candadate":"candidate",
    "candiate":"candidate",
    "candidiate":"candidate",
    "cannister":"canister",
    "cannisters":"canisters",
    "cannnot":"cannot",
    "cannonical":"canonical",
    "caperbility":"capability",
    "capible":"capable",
    "capetown":"Cape Town",
    "captial":"capital",
    "captued":"captured",
    "capturd":"captured",
    "carcas":"carcass",
    "carreer":"career",
    "carrers":"careers",
    "carefull":"careful",
    "carribbean":"Caribbean",
    "carribean":"Caribbean",
    "careing":"caring",
    "carmalite":"Carmelite",
    "carnege":"carnage",
    "carnige":"carnage",
    "carnagie":"Carnegie",
    "carnigie":"Carnegie",
    "carnagie-mellon":"Carnegie-Mellon",
    "carnigie-mellon":"Carnegie-Mellon",
    "carniverous":"carnivorous",
    "carthagian":"Carthaginian",
    "cartilege":"cartilage",
    "cartilidge":"cartilage",
    "carthographer":"cartographer",
    "cartdridge":"cartridge",
    "cartrige":"cartridge",
    "casette":"cassette",
    "cassawory":"cassowary",
    "cassowarry":"cassowary",
    "casulaties":"casualties",
    "causalities":"casualties",
    "casulaty":"casualty",
    "catagories":"categories",
    "catergorize":"categorize",
    "catagorized":"categorized",
    "catergorized":"categorized",
    "catagory":"category",
    "catapillar":"caterpillar",
    "catapiller":"caterpillar",
    "catepillar":"caterpillar",
    "caterpilar":"caterpillar",
    "caterpiller":"caterpillar",
    "catterpilar":"caterpillar",
    "catterpillar":"caterpillar",
    "catapillars":"caterpillars",
    "catapillers":"caterpillars",
    "catepillars":"caterpillars",
    "caterpilars":"caterpillars",
    "caterpillers":"caterpillars",
    "catterpilars":"caterpillars",
    "catterpillars":"caterpillars",
    "cathlic":"catholic",
    "catholocism":"catholicism",
    "cataline":"Catiline",
    "cacuses":"caucuses",
    "cellpading":"cellpadding",
    "celcius":"Celsius",
    "cemetaries":"cemeteries",
    "cementary":"cemetery",
    "cemetarey":"cemetery",
    "cemetary":"cemetery",
    "censur":"censor",
    "sensure":"censure",
    "cencus":"census",
    "cententenial":"centennial",
    "centruies":"centuries",
    "centruy":"century",
    "cerimonial":"ceremonial",
    "cerimonies":"ceremonies",
    "cerimonious":"ceremonious",
    "cerimony":"ceremony",
    "ceromony":"ceremony",
    "ceratin":"certain",
    "certian":"certain",
    "certainity":"certainty",
    "cervial":"cervical",
    "chariman":"chairman",
    "challange":"challenge",
    "challege":"challenge",
    "challanged":"challenged",
    "chalenging":"challenging",
    "champange":"Champagne",
    "changable":"changeable",
    "carachter":"character",
    "charachter":"character",
    "chracter":"character",
    "charactor":"character ",
    "charactersistic":"characteristic",
    "charistics":"characteristics",
    "caracterized":"characterized",
    "charaterized":"characterized",
    "cahracters":"characters",
    "charachters":"characters",
    "charactors":"characters",
    "carismatic":"charismatic",
    "charasmatic":"charismatic",
    "chasr":"chaser",
    "chemcial":"chemical",
    "chemcially":"chemically",
    "chemicaly":"chemically",
    "chemestry":"chemistry",
    "cheif":"chief",
    "cheifs":"chiefs",
    "childbird":"childbirth",
    "childen":"children",
    "choosen":"chosen",
    "chuch":"church",
    "curch":"church",
    "churchs":"churches",
    "cincinatti":"Cincinnati",
    "cincinnatti":"Cincinnati",
    "circut":"circuit",
    "ciricuit":"circuit",
    "curcuit":"circuit",
    "circulaton":"circulation",
    "circumsicion":"circumcision",
    "civillian":"civilian",
    "claimes":"claims",
    "clas":"class",
    "clasic":"classic",
    "clasical":"classical",
    "clasically":"classically",
    "claer":"clear",
    "clera":"clear",
    "cleareance":"clearance",
    "claerer":"clearer",
    "claerly":"clearly",
    "clincial":"clinical",
    "clinicaly":"clinically",
    "caost":"coast",
    "coctail":"cocktail",
    "cognizent":"cognizant",
    "co-incided":"coincided",
    "coincedentally":"coincidentally",
    "colaborations":"collaborations",
    "collaberative":"collaborative",
    "colateral":"collateral",
    "collegue":"colleague",
    "collegues":"colleagues",
    "collecton":"collection",
    "colelctive":"collective",
    "collonies":"colonies",
    "colonizators":"colonizers",
    "collonade":"colonnade",
    "collony":"colony ",
    "collosal":"colossal",
    "cmo":"com",
    "combanations":"combinations",
    "combinatins":"combinations",
    "combusion":"combustion",
    "comback":"comeback",
    "commedic":"comedic",
    "confortable":"comfortable",
    "comming":"coming",
    "comander":"commander",
    "comando":"commando",
    "comandos":"commandos",
    "commandoes":"commandos",
    "commemmorate":"commemorate",
    "commmemorated":"commemorated",
    "comemmorates":"commemorates",
    "commemmorating":"commemorating",
    "comemoretion":"commemoration",
    "commemerative":"commemorative",
    "commerorative":"commemorative",
    "commerical":"commercial",
    "commericial":"commercial",
    "commerically":"commercially",
    "commericially":"commercially",
    "comision":"commission",
    "comission":"commission",
    "commision":"commission",
    "comisioned":"commissioned",
    "comissioned":"commissioned",
    "commisioned":"commissioned",
    "comisioner":"commissioner",
    "comissioner":"commissioner",
    "commisioner":"commissioner",
    "comisioning":"commissioning",
    "comissioning":"commissioning",
    "commisioning":"commissioning",
    "comisions":"commissions",
    "comissions":"commissions",
    "commisions":"commissions",
    "committment":"commitment",
    "committments":"commitments",
    "comited":"committed",
    "comitted":"committed",
    "commited":"committed",
    "cornmitted":"committed",
    "comittee":"committee",
    "commitee":"committee",
    "committe":"committee",
    "comiting":"committing",
    "comitting":"committing",
    "commiting":"committing",
    "commongly":"commonly",
    "commonweath":"commonwealth",
    "comminication":"communication",
    "communciation":"communication",
    "communiation":"communication",
    "commuications":"communications",
    "commuinications":"communications",
    "communites":"communities",
    "comany":"company",
    "comapany":"company",
    "comprable":"comparable",
    "comparitive":"comparative",
    "comparitively":"comparatively",
    "comparision":"comparison",
    "comparisions":"comparisons",
    "compatabilities":"compatibilities",
    "compatablities":"compatibilities",
    "compatiblities":"compatibilities",
    "compability":"compatibility",
    "compatability":"compatibility",
    "compatablity":"compatibility",
    "compatiblity":"compatibility",
    "compatable":"compatible",
    "compatiable":"compatible",
    "compensantion":"compensation",
    "competance":"competence",
    "competant":"competent",
    "compitent":"competent",
    "competion":"competition",
    "competitiion":"competition",
    "compeitions":"competitions",
    "competative":"competitive",
    "competive":"competitive",
    "competiveness":"competitiveness",
    "copmetitors":"competitors",
    "complier":"compiler",
    "completedthe":"completed the",
    "completelyl":"completely",
    "completetion":"completion",
    "componant":"component",
    "comphrehensive":"comprehensive",
    "comprimise":"compromise",
    "compulsary":"compulsory",
    "compulsery":"compulsory",
    "cmoputer":"computer",
    "coputer":"computer",
    "computarized":"computerized",
    "concieted":"conceited",
    "concieved":"conceived",
    "consentrate":"concentrate",
    "consentrated":"concentrated",
    "consentrates":"concentrates",
    "consept":"concept",
    "consern":"concern",
    "conserned":"concerned",
    "conserning":"concerning",
    "comdemnation":"condemnation",
    "condamned":"condemned",
    "condemmed":"condemned",
    "condidtion":"condition",
    "condidtions":"conditions",
    "conditionsof":"conditions of",
    "confidental":"confidential",
    "confidentally":"confidentially",
    "confids":"confides",
    "configureable":"configurable",
    "coform":"conform",
    "congradulations":"congratulations",
    "congresional":"congressional",
    "conjecutre":"conjecture",
    "conjuction":"conjunction",
    "conected":"connected",
    "conneticut":"Connecticut",
    "conection":"connection",
    "conived":"connived",
    "cannotation":"connotation",
    "cannotations":"connotations",
    "conotations":"connotations",
    "conquerd":"conquered",
    "conqured":"conquered",
    "conquerer":"conqueror",
    "conquerers":"conquerors",
    "concious":"conscious",
    "consious":"conscious",
    "conciously":"consciously",
    "conciousness":"consciousness",
    "consciouness":"consciousness",
    "consiciousness":"consciousness",
    "consicousness":"consciousness",
    "consectutive":"consecutive",
    "concensus":"consensus",
    "conesencus":"consensus",
    "conscent":"consent",
    "consequeseces":"consequences",
    "consenquently":"consequently",
    "consequentually":"consequently",
    "conservitive":"conservative",
    "concider":"consider",
    "consdider":"consider",
    "concidered":"considered",
    "consdidered":"considered",
    "consdiered":"considered",
    "considerd":"considered",
    "consideres":"considered",
    "concidering":"considering",
    "conciders":"considers",
    "consistant":"consistent",
    "consistantly":"consistently",
    "consolodate":"consolidate",
    "consolodated":"consolidated",
    "consonent":"consonant",
    "consonents":"consonants",
    "consorcium":"consortium",
    "conspiracys":"conspiracies",
    "conspiriator":"conspirator",
    "constatn":"constant",
    "constanly":"constantly",
    "constarnation":"consternation",
    "consituencies":"constituencies",
    "consituency":"constituency",
    "constituant":"constituent",
    "constituants":"constituents",
    "consituted":"constituted",
    "consitution":"constitution",
    "constituion":"constitution",
    "costitution":"constitution",
    "consitutional":"constitutional",
    "constituional":"constitutional",
    "constaints":"constraints",
    "consttruction":"construction",
    "constuction":"construction",
    "contruction":"construction",
    "consulant":"consultant",
    "consumate":"consummate",
    "consumated":"consummated",
    "containes":"contains",
    "countains":"contains",
    "contaiminate":"contaminate",
    "contemporaneus":"contemporaneous",
    "contamporaries":"contemporaries",
    "contamporary":"contemporary",
    "contempoary":"contemporary",
    "contempory":"contemporary",
    "contendor":"contender",
    "contigent":"contingent",
    "constinually":"continually",
    "contined":"continued",
    "continueing":"continuing",
    "continous":"continuous",
    "continously":"continuously",
    "contibute":"contribute ",
    "contibuted":"contributed ",
    "contibutes":"contributes ",
    "contritutions":"contributions",
    "contributer":"contributor",
    "contributers":"contributors",
    "controll":"control",
    "controled":"controlled",
    "controling":"controlling",
    "controlls":"controls",
    "contravercial":"controversial",
    "controvercial":"controversial",
    "controversal":"controversial",
    "controvertial":"controversial",
    "controveries":"controversies",
    "contraversy":"controversy",
    "controvercy":"controversy",
    "controversey":"controversy",
    "controvery":"controversy",
    "conveinent":"convenient",
    "convienient":"convenient",
    "convential":"conventional",
    "convertion":"conversion",
    "coverted":"converted",
    "convertables":"convertibles",
    "conveyer":"conveyor",
    "conviced":"convinced",
    "coorperation":"cooperation",
    "coordiantion":"coordination",
    "copywrite":"copyright",
    "coridal":"cordial",
    "corparate":"corporate",
    "coorperations":"corporations",
    "corperations":"corporations",
    "correcters":"correctors",
    "corrispond":"correspond",
    "corrisponded":"corresponded",
    "correspondant":"correspondent",
    "corrispondant":"correspondent",
    "correspondants":"correspondents",
    "corrispondants":"correspondents",
    "correponding":"corresponding",
    "correposding":"corresponding",
    "corrisponding":"corresponding",
    "corrisponds":"corresponds",
    "corridoors":"corridors",
    "corosion":"corrosion",
    "coudl":"could",
    "sould":"could",
    "coucil":"council",
    "councelor":"councilor",
    "councellor":"councilor",
    "councelors":"councilors",
    "councellors":"councilors",
    "counries":"countries",
    "countires":"countries",
    "countrie's":"countries",
    "ocuntries":"countries",
    "ocuntry":"country",
    "coururier":"courier",
    "convenant":"covenant",
    "cpoy":"coy",
    "creaeted":"created",
    "creedence":"credence",
    "criterias":"criteria",
    "critereon":"criterion",
    "crtical":"critical",
    "critisize":"criticize",
    "critisized":"criticized",
    "crticised":"criticized",
    "critisizes":"criticizes",
    "critising":"criticizing",
    "critisising":"criticizing",
    "critisizing":"criticizing",
    "critisism":"criticism",
    "critisisms":"criticisms",
    "critized":"criticized",
    "critizing":"criticizing",
    "criticists":"critics",
    "crockodiles":"crocodiles",
    "crowm":"crown",
    "crucifiction":"crucifixion",
    "crusies":"cruises",
    "crystalisation":"crystallization",
    "crystalization":"crystallization",
    "culiminating":"culminating",
    "cumulatative":"cumulative",
    "currenly":"currently",
    "ciriculum":"curriculum",
    "curriculem":"curriculum",
    "cxan":"cyan",
    "cyclinder":"cylinder",
    "dacquiri":"daiquiri",
    "dalmation":"dalmatian",
    "dammage":"damage",
    "dardenelles":"Dardanelles",
    "daugher":"daughter",
    "dael":"deal",
    "debateable":"debatable",
    "decieved":"deceived",
    "december":"December",
    "decideable":"decidable",
    "deside":"decide",
    "decidely":"decidedly",
    "ecidious":"deciduous",
    "decison":"decision",
    "descision":"decision",
    "descisions":"decisions",
    "decomissioned":"decommissioned",
    "decomposit":"decompose",
    "decomposited":"decomposed",
    "decomposits":"decomposes",
    "decompositing":"decomposing",
    "decress":"decrees",
    "defendent":"defendant",
    "defendents":"defendants",
    "deffensively":"defensively",
    "definance":"defiance",
    "deffine":"define",
    "deffined":"defined",
    "definining":"defining",
    "definate":"definite",
    "definit":"definite",
    "definately":"definitely",
    "definatly":"definitely",
    "definetly":"definitely",
    "definitly":"definitely",
    "definiton":"definition",
    "defintion":"definition",
    "degrate":"degrade",
    "dieties":"deities",
    "diety":"deity",
    "delagates":"delegates",
    "deliberatly":"deliberately",
    "delerious":"delirious",
    "delusionally":"delusively",
    "devels":"delves",
    "damenor":"demeanor",
    "demenor":"demeanor",
    "demorcracy":"democracy",
    "demographical":"demographic",
    "demolision":"demolition",
    "demostration":"demonstration",
    "denegrating":"denigrating",
    "densly":"densely",
    "deparment":"department",
    "deparmental":"departmental",
    "deparments":"departments",
    "dependance":"dependence",
    "dependancy":"dependency",
    "dependant":"dependent",
    "despict":"depict",
    "derivitive":"derivative",
    "deriviated":"derived",
    "dirived":"derived",
    "derogitory":"derogatory",
    "decendant":"descendant",
    "decendent":"descendant",
    "decendants":"descendants",
    "decendents":"descendants",
    "descendands":"descendants",
    "decribe":"describe",
    "discribe":"describe",
    "decribed":"described",
    "descibed":"described",
    "discribed":"described",
    "decribes":"describes",
    "descriibes":"describes",
    "discribes":"describes",
    "decribing":"describing",
    "discribing":"describing",
    "descripton":"description",
    "descripters":"descriptors",
    "dessicated":"desiccated",
    "desgined":"designed",
    "dessigned":"designed",
    "desigining":"designing",
    "desireable":"desirable",
    "desktiop":"desktop",
    "dispair":"despair",
    "desparate":"desperate",
    "despiration":"desperation",
    "dispicable":"despicable",
    "dispite":"despite",
    "destablized":"destabilized",
    "desinations":"destinations",
    "desitned":"destined",
    "destory":"destroy",
    "desctruction":"destruction",
    "distruction":"destruction",
    "distructive":"destructive",
    "detatched":"detached",
    "detailled":"detailed",
    "dectect":"detect",
    "deteriate":"deteriorate",
    "deteoriated":"deteriorated",
    "deterioriating":"deteriorating",
    "determinining":"determining",
    "detremental":"detrimental",
    "devasted":"devastated",
    "devestated":"devastated",
    "devestating":"devastating",
    "devistating":"devastating",
    "develope":"develop",
    "developped":"developed",
    "delevopment":"development",
    "developement":"development",
    "develpment":"development",
    "devolopement":"development",
    "divice":"device",
    "diablical":"diabolical",
    "diamons":"diamonds",
    "dichtomy":"dichotomy",
    "didnt":"didn't",
    "diferent":"different",
    "diferrent":"different",
    "differnt":"different",
    "diffrent":"different",
    "differentiatiations":"differentiations",
    "dificulties":"difficulties",
    "difficulity":"difficulty",
    "dificulty":"difficulty",
    "delapidated":"dilapidated",
    "dimention":"dimension",
    "dimentional":"dimensional",
    "dimesnional":"dimensional",
    "dimenions":"dimensions",
    "dimentions":"dimensions",
    "diminuitive":"diminutive",
    "dimunitive":"diminutive",
    "diosese":"diocese",
    "diphtong":"diphthong",
    "dipthong":"diphthong",
    "diphtongs":"diphthongs",
    "dipthongs":"diphthongs",
    "diplomancy":"diplomacy",
    "driectly":"directly",
    "disagreeed":"disagreed",
    "dissagreement":"disagreement",
    "dissapear":"disappear",
    "dissappear":"disappear",
    "dissapearance":"disappearance",
    "disapeared":"disappeared",
    "disappearred":"disappeared",
    "dissapeared":"disappeared",
    "dissapearing":"disappearing",
    "dissapears":"disappears",
    "dissappears":"disappears",
    "dissappointed":"disappointed",
    "disapointing":"disappointing",
    "disaproval":"disapproval",
    "dissarray":"disarray",
    "diaster":"disaster",
    "disasterous":"disastrous",
    "disatrous":"disastrous",
    "disiplined":"disciplined",
    "unconfortability":"discomfort",
    "diconnects":"disconnects",
    "dicover":"discover",
    "disover":"discover",
    "dicovered":"discovered",
    "dicovering":"discovering",
    "dicovers":"discovers",
    "dicovery":"discovery",
    "descuss":"discuss",
    "dicussed":"discussed",
    "disenchanged":"disenchanted",
    "desintegrated":"disintegrated",
    "desintegration":"disintegration",
    "disobediance":"disobedience",
    "dissobediance":"disobedience",
    "dissobedience":"disobedience",
    "disobediant":"disobedient",
    "dissobediant":"disobedient",
    "dissobedient":"disobedient",
    "desorder":"disorder",
    "desoriented":"disoriented",
    "disparingly":"disparagingly",
    "dispence":"dispense",
    "dispenced":"dispensed",
    "dispencing":"dispensing",
    "unplease":"displease",
    "dispostion":"disposition",
    "disproportiate":"disproportionate",
    "disputandem":"disputandum",
    "disatisfaction":"dissatisfaction",
    "disatisfied":"dissatisfied",
    "disemination":"dissemination",
    "disolved":"dissolved",
    "disctinction":"distinction",
    "distiction":"distinction",
    "disctinctive":"distinctive",
    "distingish":"distinguish",
    "distingished":"distinguished",
    "distingquished":"distinguished",
    "distingishes":"distinguishes",
    "distingishing":"distinguishing",
    "ditributed":"distributed",
    "distrubution":"distribution",
    "disricts":"districts",
    "diversed":"diverse",
    "devide":"divide",
    "devided":"divided",
    "divison":"division",
    "divisons":"divisions",
    "docrines":"doctrines",
    "doctines":"doctrines",
    "doccument":"document",
    "documenatry":"documentary",
    "doccumented":"documented",
    "doccuments":"documents",
    "doens":"does",
    "doesnt":"doesn't",
    "dosen't":"doesn't",
    "doign":"doing",
    "donig":"doing",
    "dominent":"dominant",
    "dominiant":"dominant",
    "dominaton":"domination",
    "doulbe":"double",
    "doub":"doubt",
    "dowloads":"downloads",
    "deram":"dram",
    "dramtic":"dramatic",
    "draftman":"draftsman",
    "draughtman":"draftsman",
    "dravadian":"Dravidian",
    "dreasm":"dreams",
    "drnik":"drink",
    "drummless":"drumless",
    "druming":"drumming",
    "dupicate":"duplicate",
    "durig":"during",
    "durring":"during",
    "duting":"during",
    "dieing":"dying",
    "eahc":"each",
    "ealier":"earlier",
    "earlies":"earliest",
    "eearly":"early",
    "earnt":"earned",
    "ecclectic":"eclectic",
    "electic":"eclectic",
    "eclispe":"eclipse",
    "ecomonic":"economic",
    "eceonomy":"economy",
    "eles":"eels",
    "effeciency":"efficiency",
    "efficency":"efficiency",
    "effecient":"efficient",
    "efficent":"efficient",
    "effeciently":"efficiently",
    "efficently":"efficiently",
    "effulence":"effluence",
    "efford":"effort",
    "effords":"efforts",
    "aggregious":"egregious",
    "eigth":"eighth",
    "eiter":"either",
    "ellected":"elected",
    "elction":"election",
    "electon":"election",
    "electrial":"electrical",
    "electricly":"electrically",
    "electricty":"electricity",
    "eletricity":"electricity",
    "elementay":"elementary",
    "elimentary":"elementary",
    "elphant":"elephant",
    "elicided":"elicited",
    "eligable":"eligible",
    "eleminated":"eliminated",
    "eleminating":"eliminating",
    "alse":"else",
    "esle":"else",
    "eminate":"emanate",
    "eminated":"emanated",
    "embargos":"embargoes",
    "embarass":"embarrass",
    "embarras":"embarrass",
    "embarassed":"embarrassed",
    "embarrased":"embarrassed",
    "embarassing":"embarrassing",
    "embarrasing":"embarrassing",
    "embarassment":"embarrassment",
    "embarrasment":"embarrassment",
    "embezelled":"embezzled",
    "emblamatic":"emblematic",
    "imigrant":"emigrant",
    "emmigrated":"emigrated",
    "imigrated":"emigrated",
    "imigration":"emigration",
    "emminent":"eminent",
    "imanent":"eminent",
    "iminent":"eminent",
    "emminently":"eminently",
    "emmisaries":"emissaries",
    "emmisarries":"emissaries",
    "emmisarry":"emissary",
    "emmisary":"emissary",
    "emision":"emission",
    "emition":"emission",
    "emmision":"emission",
    "emmisions":"emissions",
    "emited":"emitted",
    "emmited":"emitted",
    "emmitted":"emitted",
    "emiting":"emitting",
    "emmiting":"emitting",
    "emmitting":"emitting",
    "emphsis":"emphasis",
    "emphaised":"emphasized",
    "emphysyma":"emphysema",
    "emperical":"empirical",
    "empirial":"empirical",
    "imploys":"employs",
    "enameld":"enameled",
    "encouraing":"encouraging",
    "encryptiion":"encryption",
    "encylopedia":"encyclopedia",
    "endevors":"endeavors",
    "endevor":"endeavor",
    "endevour":"endeavor",
    "endig":"ending",
    "endolithes":"endoliths",
    "enforceing":"enforcing",
    "engagment":"engagement",
    "engeneer":"engineer",
    "engieneer":"engineer",
    "engeneering":"engineering",
    "engieneers":"engineers",
    "enlish":"English",
    "enchancement":"enhancement",
    "enlargment":"enlargement",
    "enlargments":"enlargements",
    "emnity":"enmity",
    "enourmous":"enormous",
    "enourmously":"enormously",
    "ensconsed":"ensconced",
    "entaglements":"entanglements",
    "intertaining":"entertaining",
    "enteratinment":"entertainment",
    "enthusiatic":"enthusiastic",
    "entitlied":"entitled",
    "entitity":"entity",
    "entrepeneur":"entrepreneur",
    "entrepeneurs":"entrepreneurs",
    "intrusted":"entrusted",
    "inumerable":"enumerable",
    "enviorment":"environment",
    "enviornment":"environment",
    "enviroment":"environment",
    "enviormental":"environmental",
    "enviornmental":"environmental",
    "enviromental":"environmental",
    "enviornmentalist":"environmentalist",
    "enviromentalist":"environmentalist",
    "enviormentally":"environmentally",
    "enviornmentally":"environmentally",
    "enviromentally":"environmentally",
    "enviorments":"environments",
    "enviornments":"environments",
    "enviroments":"environments",
    "envrionments":"environments",
    "epsiode":"episode",
    "epidsodes":"episodes",
    "equitorial":"equatorial",
    "equilibium":"equilibrium",
    "equilibrum":"equilibrium",
    "equippment":"equipment",
    "equiped":"equipped",
    "equialent":"equivalent",
    "equivelant":"equivalent",
    "equivelent":"equivalent",
    "equivilant":"equivalent",
    "equivilent":"equivalent",
    "equivlalent":"equivalent",
    "eratic":"erratic",
    "eratically":"erratically",
    "eraticly":"erratically",
    "errupted":"erupted",
    "especialy":"especially",
    "expecially":"especially",
    "essense":"essence",
    "esential":"essential",
    "essencial":"essential",
    "essentail":"essential",
    "essentual":"essential",
    "essesital":"essential",
    "essentialy":"essentially",
    "estabishes":"establishes",
    "establising":"establishing",
    "esitmated":"estimated",
    "ect":"etc",
    "ethnocentricm":"ethnocentrism",
    "europian":"European",
    "eurpean":"European",
    "eurpoean":"European",
    "europians":"Europeans",
    "eventhough":"even though",
    "evenhtually":"eventually",
    "eventally":"eventually",
    "eventially":"eventually",
    "eventualy":"eventually",
    "eveyr":"every",
    "everytime":"every time",
    "everthing":"everything",
    "everyting":"everything",
    "evidentally":"evidently",
    "efel":"evil",
    "envolutionary":"evolutionary",
    "exerbate":"exacerbate",
    "exerbated":"exacerbated",
    "excact":"exact",
    "exagerate":"exaggerate",
    "exagerrate":"exaggerate",
    "exagerated":"exaggerated",
    "exagerrated":"exaggerated",
    "exagerates":"exaggerates",
    "exagerrates":"exaggerates",
    "exagerating":"exaggerating",
    "exagerrating":"exaggerating",
    "exhalted":"exalted",
    "examinated":"examined",
    "exemple":"example",
    "exmaple":"example",
    "excedded":"exceeded",
    "exeedingly":"exceedingly",
    "excell":"excel",
    "excellance":"excellence",
    "excelent":"excellent",
    "excellant":"excellent",
    "exelent":"excellent",
    "exellent":"excellent",
    "excells":"excels",
    "exept":"except",
    "exeptional":"exceptional",
    "exerpt":"excerpt",
    "exerpts":"excerpts",
    "excange":"exchange",
    "exchanching":"exchanging",
    "exicting":"exciting",
    "exludes":"excludes",
    "exculsivly":"exclusively",
    "excecute":"execute",
    "excecuted":"executed",
    "exectued":"executed",
    "excecutes":"executes",
    "excecuting":"executing",
    "excecution":"execution",
    "exection":"execution",
    "exampt":"exempt",
    "excercise":"exercise",
    "exersize":"exercise",
    "exerciese":"exercises",
    "execising":"exercising",
    "extered":"exerted",
    "exhibtion":"exhibition",
    "exibition":"exhibition",
    "exibitions":"exhibitions",
    "exliled":"exiled",
    "excisted":"existed",
    "existance":"existence",
    "existince":"existence",
    "existant":"existent",
    "exonorate":"exonerate",
    "exoskelaton":"exoskeleton",
    "exapansion":"expansion",
    "expatriot":"expatriate",
    "expeced":"expected",
    "expeditonary":"expeditionary",
    "expiditions":"expeditions",
    "expell":"expel",
    "expells":"expels",
    "experiance":"experience",
    "expierence":"experience",
    "experianced":"experienced",
    "expeiments":"experiments",
    "expalin":"explain",
    "explaning":"explaining",
    "explaination":"explanation",
    "explictly":"explicitly",
    "explotation":"exploitation",
    "exploititive":"exploitative",
    "exressed":"expressed",
    "expropiated":"expropriated",
    "expropiation":"expropriation",
    "extention":"extension",
    "extentions":"extensions",
    "exerternal":"external",
    "exinct":"extinct",
    "extint":"extinct",
    "extradiction":"extradition",
    "extrordinarily":"extraordinarily",
    "extrordinary":"extraordinary",
    "extraterrestial":"extraterrestrial",
    "extraterrestials":"extraterrestrials",
    "extravagent":"extravagant",
    "extemely":"extremely",
    "extrememly":"extremely",
    "extremly":"extremely",
    "extermist":"extremist",
    "extremeophile":"extremophile",
    "faciliate":"facilitate",
    "facillitate":"facilitate",
    "faciliated":"facilitated",
    "faciliates":"facilitates",
    "facilites":"facilities",
    "fatc":"fact",
    "farenheit":"Fahrenheit",
    "familliar":"familiar",
    "familes":"families",
    "fimilies":"families",
    "famoust":"famous",
    "fanatism":"fanaticism",
    "facinated":"fascinated",
    "facist":"fascist",
    "favotrable":"favorable",
    "favoutrable":"favorable",
    "feasable":"feasible",
    "febuary":"February",
    "feburary":"February",
    "february":"February",
    "fedreally":"federally",
    "fiel":"feel",
    "fertily":"fertility",
    "ficticious":"fictitious",
    "fictious":"fictitious",
    "fiercly":"fiercely",
    "fightings":"fighting",
    "filiament":"filament",
    "fianlly":"finally",
    "finaly":"finally",
    "finacial":"financial",
    "financialy":"financially",
    "fidn":"find",
    "fianite":"finite",
    "fisionable":"fissionable",
    "flamable":"flammable",
    "flawess":"flawless",
    "fleed":"fled",
    "flemmish":"Flemish",
    "glight":"flight",
    "firts":"flirts",
    "fluorish":"flourish",
    "florescent":"fluorescent",
    "flourescent":"fluorescent",
    "flourine":"fluorine",
    "foucs":"focus",
    "follwoing":"following",
    "folowing":"following",
    "formalhaut":"Fomalhaut",
    "fontrier":"fontier",
    "foootball":"football",
    "forbad":"forbade",
    "forbiden":"forbidden",
    "forhead":"forehead",
    "foriegn":"foreign",
    "formost":"foremost",
    "forunner":"forerunner",
    "forsaw":"foresaw",
    "forseeable":"foreseeable",
    "fortelling":"foretelling",
    "foreward":"foreword",
    "forfiet":"forfeit",
    "formallize":"formalize",
    "formallized":"formalized",
    "formaly":"formally",
    "fomed":"formed",
    "fromed":"formed",
    "formelly":"formerly",
    "formidible":"formidable",
    "fourties":"forties",
    "fourty":"forty",
    "foward":"forward",
    "faught":"fought",
    "fougth":"fought",
    "foudn":"found",
    "foundaries":"foundries",
    "foundary":"foundry",
    "fouth":"fourth",
    "fransiscan":"Franciscan",
    "fransiscans":"Franciscans",
    "frequentily":"frequently",
    "friday":"Friday",
    "freind":"friend",
    "freindly":"friendly",
    "firends":"friends",
    "fomr":"from",
    "frome":"from",
    "froniter":"frontier",
    "fufill":"fulfill",
    "fullfill":"fulfill",
    "fufilled":"fulfilled",
    "fulfiled":"fulfilled",
    "fullfilled":"fulfilled",
    "fucntion":"function",
    "funtion":"function",
    "fucntioning":"functioning",
    "fundametal":"fundamental",
    "fundametals":"fundamentals",
    "funguses":"fungi",
    "furuther":"further",
    "futher":"further",
    "futhermore":"furthermore",
    "futhroc":"futhark",
    "galatic":"galactic",
    "galations":"Galatians",
    "gallaxies":"galaxies",
    "galvinized":"galvanized",
    "gae":"game",
    "gameboy":"Game Boy",
    "ganes":"games",
    "ghandi":"Gandhi",
    "ganster":"gangster",
    "gardai":"garda? ",
    "garnison":"garrison",
    "geneological":"genealogical",
    "geneologies":"genealogies",
    "geneology":"genealogy",
    "generaly":"generally",
    "ganerate":"generate",
    "generatting":"generating",
    "genialia":"genitalia",
    "geographicial":"geographical",
    "geometrician":"geometer",
    "geometricians":"geometers",
    "guilia":"Giulia",
    "guilio":"Giulio",
    "guiseppe":"Giuseppe",
    "gnawwed":"gnawed",
    "godess":"goddess",
    "godesses":"goddesses",
    "godounov":"Godunov",
    "gogin":"going",
    "goign":"going",
    "gonig":"going",
    "oging":"going",
    "gothenberg":"Gothenburg",
    "gottleib":"Gottlieb",
    "goverance":"governance",
    "govement":"government",
    "govenment":"government",
    "govenrment":"government",
    "goverment":"government",
    "governmnet":"government",
    "govorment":"government",
    "govornment":"government",
    "govermental":"governmental",
    "govormental":"governmental",
    "gouvener":"governor",
    "governer":"governor",
    "gracefull":"graceful",
    "grafitti":"graffiti",
    "grammer":"grammar",
    "gramatically":"grammatically",
    "grammaticaly":"grammatically",
    "greatful":"grateful",
    "greatfully":"gratefully",
    "gratuitious":"gratuitous",
    "gerat":"great",
    "graet":"great",
    "grat":"great",
    "gridles":"griddles",
    "greif":"grief",
    "gropu":"group",
    "grwo":"grow",
    "guaduloupe":"Guadalupe",
    "guadulupe":"Guadalupe",
    "gunanine":"guanine",
    "gauarana":"guaran?",
    "garantee":"guarantee",
    "gaurantee":"guarantee",
    "gaurentee":"guarantee",
    "guarentee":"guarantee",
    "gurantee":"guarantee",
    "garanteed":"guaranteed",
    "gauranteed":"guaranteed",
    "gaurenteed":"guaranteed",
    "guarenteed":"guaranteed",
    "guranteed":"guaranteed",
    "garantees":"guarantees",
    "gaurantees":"guarantees",
    "gaurentees":"guarantees",
    "guarentees":"guarantees",
    "gurantees":"guarantees",
    "gaurd":"guard",
    "guatamala":"Guatemala",
    "guatamalan":"Guatemalan",
    "guerilla":"guerrilla",
    "guerrila":"guerrilla",
    "guerillas":"guerrillas",
    "guerrilas":"guerrillas",
    "guidence":"guidance",
    "guiness":"Guinness",
    "guttaral":"guttural",
    "gutteral":"guttural",
    "habaeus":"habeas",
    "habeus":"habeas",
    "habsbourg":"Habsburg",
    "hemorrage":"hemorrhage",
    "haemorrage":"hemorrhage",
    "hallowean":"Hallowe'en",
    "ahppen":"happen",
    "hapen":"happen",
    "hapened":"happened",
    "happend":"happened",
    "happended":"happened",
    "happenned":"happened",
    "hapening":"happening",
    "harras":"harass",
    "harased":"harassed",
    "harrased":"harassed",
    "harrassed":"harassed",
    "harrasses":"harassed",
    "harases":"harasses",
    "harrases":"harasses",
    "harrasing":"harassing",
    "harrassing":"harassing",
    "harasment":"harassment",
    "harassement":"harassment",
    "harrasment":"harassment",
    "harrassment":"harassment",
    "harasments":"harassments",
    "harrasments":"harassments",
    "harrassments":"harassments",
    "hasnt":"hasn't",
    "ahev":"have",
    "ahve":"have",
    "haev":"have",
    "hvae":"have",
    "hvea":"have",
    "hvaing":"having",
    "headquarer":"headquarter",
    "headquater":"headquarter",
    "headquatered":"headquartered",
    "headquaters":"headquarters",
    "healthercare":"healthcare",
    "heathy":"healthy",
    "heared":"heard",
    "herad":"heard",
    "haviest":"heaviest",
    "heidelburg":"Heidelberg",
    "hieght":"height",
    "helment":"helmet",
    "halp":"help",
    "helpped":"helped",
    "helpfull":"helpful",
    "hemmorhage":"hemorrhage",
    "heridity":"heredity",
    "hertiage":"heritage",
    "inheritage":"heritage",
    "heroe":"hero",
    "heros":"heroes",
    "hertzs":"hertz",
    "hesistant":"hesitant",
    "heterogenous":"heterogeneous",
    "hierachical":"hierarchical",
    "hierarcical":"hierarchical",
    "hierachies":"hierarchies",
    "heirarchy":"hierarchy",
    "hierachy":"hierarchy",
    "hierarcy":"hierarchy",
    "hieroglph":"hieroglyph",
    "heiroglyphics":"hieroglyphics",
    "hieroglphs":"hieroglyphs",
    "heigher":"higher",
    "higer":"higher",
    "higest":"highest",
    "higway":"highway",
    "hillarious":"hilarious",
    "himselv":"himself",
    "hismelf":"himself",
    "hinderance":"hindrance",
    "hinderence":"hindrance",
    "hindrence":"hindrance",
    "hipopotamus":"hippopotamus",
    "histocompatability":"histocompatibility",
    "historicians":"historians",
    "hsitorians":"historians",
    "hstory":"history",
    "hitsingles":"hit singles",
    "hosited":"hoisted",
    "holliday":"holiday",
    "homogeneize":"homogenize",
    "homogeneized":"homogenized",
    "honory":"honorary",
    "hounour":"honor",
    "horrifing":"horrifying",
    "hospitible":"hospitable",
    "housr":"hours",
    "howver":"however",
    "huminoid":"humanoid",
    "humer":"humor",
    "humoural":"humoral",
    "humerous":"humorous",
    "humurous":"humorous",
    "husban":"husband",
    "hydogen":"hydrogen",
    "hydropile":"hydrophile",
    "hydropilic":"hydrophilic",
    "hydropobe":"hydrophobe",
    "hydropobic":"hydrophobic",
    "hygeine":"hygiene",
    "hypocracy":"hypocrisy",
    "hypocrasy":"hypocrisy",
    "hypocricy":"hypocrisy",
    "hypocrit":"hypocrite",
    "hypocrits":"hypocrites",
    "i":"I",
    "i'd":"I'd",
    "i'll":"I'll",
    "i'm":"I'm",
    "i've":"I've",
    "iconclastic":"iconoclastic",
    "diea":"idea",
    "idaeidae":"idea",
    "idaes":"ideas",
    "idesa":"ideas",
    "identicial":"identical",
    "indentical":"identical",
    "identifers":"identifiers",
    "idealogies":"ideologies",
    "idealogy":"ideology",
    "idiosyncracy":"idiosyncrasy",
    "ideosyncratic":"idiosyncratic",
    "illiegal":"illegal",
    "illegimacy":"illegitimacy",
    "illegitmate":"illegitimate",
    "illess":"illness",
    "ilness":"illness",
    "ilogical":"illogical",
    "illution":"illusion",
    "imagenary":"imaginary",
    "imaginery":"imaginary",
    "imagin":"imagine",
    "inbalance":"imbalance",
    "inbalanced":"imbalanced",
    "immitate":"imitate",
    "immitated":"imitated",
    "immitating":"imitating",
    "immitator":"imitator",
    "emmediately":"immediately",
    "imediately":"immediately",
    "immediatley":"immediately",
    "immediatly":"immediately",
    "immidately":"immediately",
    "immidiately":"immediately",
    "imense":"immense",
    "inmigrant":"immigrant",
    "inmigrants":"immigrants",
    "immunosupressant":"immunosuppressant",
    "inpeach":"impeach",
    "impecabbly":"impeccably",
    "impedence":"impedance",
    "impliment":"implement",
    "implimented":"implemented",
    "implamenting":"implementing",
    "inpolite":"impolite",
    "importamt":"important",
    "emprisoned":"imprisoned",
    "imprioned":"imprisoned",
    "imprisonned":"imprisoned",
    "inprisonment":"imprisonment",
    "improvments":"improvements",
    "inproving":"improving",
    "improvision":"improvisation",
    "inspite":"in spite",
    "inablility":"inability",
    "inaccessable":"inaccessible",
    "inadiquate":"inadequate",
    "inadquate":"inadequate",
    "inadvertant":"inadvertent",
    "inadvertantly":"inadvertently",
    "inappropiate":"inappropriate",
    "inagurated":"inaugurated",
    "inaugures":"inaugurates",
    "inaguration":"inauguration",
    "incarcirated":"incarcerated",
    "incidentially":"incidentally",
    "incidently":"incidentally",
    "includ":"include",
    "includng":"including",
    "incuding":"including",
    "inlcuding":"including",
    "incompatabilities":"incompatibilities",
    "incompatablities":"incompatibilities",
    "incompatiblities":"incompatibilities",
    "incompatability":"incompatibility",
    "incompatablity":"incompatibility",
    "incompatiblity":"incompatibility",
    "incompatable":"incompatible",
    "incomptable":"incompatible",
    "incompetance":"incompetence",
    "incompetant":"incompetent",
    "incomptetent":"incompetent",
    "imcomplete":"incomplete",
    "inconsistant":"inconsistent",
    "incoroporated":"incorporated",
    "incorportaed":"incorporated",
    "incorprates":"incorporates",
    "incorperation":"incorporation",
    "incorruptable":"incorruptible",
    "inclreased":"increased",
    "increadible":"incredible",
    "incredable":"incredible",
    "incramentally":"incrementally",
    "incunabla":"incunabula",
    "indefinately":"indefinitely",
    "indefinitly":"indefinitely",
    "indepedence":"independence",
    "independance":"independence",
    "independece":"independence",
    "indipendence":"independence",
    "independant":"independent",
    "independendet":"independent",
    "indipendent":"independent",
    "indpendent":"independent",
    "indepedantly":"independently",
    "independantly":"independently",
    "indipendently":"independently",
    "indpendently":"independently",
    "indite":"indict",
    "indictement":"indictment",
    "indigineous":"indigenous",
    "indespensable":"indispensable",
    "indespensible":"indispensable",
    "indispensible":"indispensable",
    "indisputible":"indisputable",
    "indisputibly":"indisputably",
    "individualy":"individually",
    "indviduals":"individuals",
    "enduce":"induce",
    "indulgue":"indulge",
    "indutrial":"industrial",
    "inudstry":"industry",
    "inefficienty":"inefficiently",
    "unequalities":"inequalities",
    "inevatible":"inevitable",
    "inevitible":"inevitable",
    "inevititably":"inevitably",
    "infalability":"infallibility",
    "infallable":"infallible",
    "infrantryman":"infantryman",
    "infectuous":"infectious",
    "infered":"inferred",
    "infilitrate":"infiltrate",
    "infilitrated":"infiltrated",
    "infilitration":"infiltration",
    "infinit":"infinite",
    "enflamed":"inflamed",
    "inflamation":"inflammation",
    "influented":"influenced",
    "influencial":"influential",
    "infomation":"information",
    "informtion":"information",
    "infrigement":"infringement",
    "ingenius":"ingenious",
    "ingreediants":"ingredients",
    "inhabitans":"inhabitants",
    "inherantly":"inherently",
    "inheritence":"inheritance",
    "inital":"initial",
    "intial":"initial",
    "initally":"initially",
    "intially":"initially",
    "initation":"initiation",
    "initiaitive":"initiative",
    "inocence":"innocence",
    "innoculated":"inoculated",
    "insectiverous":"insectivorous",
    "insensative":"insensitive",
    "inseperable":"inseparable",
    "insistance":"insistence",
    "instatance":"instance",
    "instade":"instead",
    "institue":"institute",
    "insitution":"institution",
    "instutionalized":"institutionalized",
    "insitutions":"institutions",
    "instuction":"instruction",
    "intrument":"instrument",
    "intrumental":"instrumental",
    "instuments":"instruments",
    "intruments":"instruments",
    "insurence":"insurance",
    "intergrated":"integrated",
    "intergration":"integration",
    "intelectual":"intellectual",
    "inteligence":"intelligence",
    "inteligent":"intelligent",
    "intented":"intended",
    "interbread":"interbreed",
    "interchangable":"interchangeable",
    "interchangably":"interchangeably",
    "intercontinetal":"intercontinental",
    "intrest":"interest",
    "interferance":"interference",
    "interfereing":"interfering",
    "interm":"interim",
    "interrim":"interim",
    "intenational":"international",
    "interational":"international",
    "internation":"international",
    "interpet":"interpret",
    "intepretation":"interpretation",
    "intepretator":"interpreter",
    "intered":"interred",
    "interrugum":"interregnum",
    "interelated":"interrelated",
    "interupt":"interrupt",
    "intevene":"intervene",
    "intervines":"intervenes",
    "inot":"into",
    "inctroduce":"introduce",
    "inctroduced":"introduced",
    "intrduced":"introduced",
    "introdued":"introduced",
    "intruduced":"introduced",
    "itnroduced":"introduced",
    "instutions":"intuitions",
    "intutive":"intuitive",
    "intutively":"intuitively",
    "inventer":"inventor",
    "invertibrates":"invertebrates",
    "investingate":"investigate",
    "involvment":"involvement",
    "ironicly":"ironically",
    "irelevent":"irrelevant",
    "irrelevent":"irrelevant",
    "irreplacable":"irreplaceable",
    "iresistable":"irresistible",
    "iresistible":"irresistible",
    "irresistable":"irresistible",
    "iresistably":"irresistibly",
    "iresistibly":"irresistibly",
    "irresistably":"irresistibly",
    "iritable":"irritable",
    "iritated":"irritated",
    "isnt":"isn't",
    "israelies":"Israelis",
    "issueing":"issuing",
    "ihaca":"Ithaca",
    "ive":"I've",
    "jaques":"jacques",
    "janurary":"January",
    "januray":"January",
    "january":"January",
    "japanes":"Japanese",
    "jeapardy":"jeopardy",
    "jewlery":"jewelry",
    "jewllery":"jewelry",
    "johanine":"Johannine",
    "jospeh":"Joseph",
    "jouney":"journey",
    "journied":"journeyed",
    "journies":"journeys",
    "juadaism":"Judaism",
    "juadism":"Judaism",
    "judical":"judicial",
    "juducial":"judicial",
    "judisuary":"judiciary",
    "july":"July",
    "june":"June",
    "iunior":"junior",
    "juristiction":"jurisdiction",
    "juristictions":"jurisdictions",
    "jstu":"just",
    "jsut":"just",
    "kindergarden":"kindergarten",
    "klenex":"kleenex",
    "knive":"knife",
    "knifes":"knives",
    "knwo":"know",
    "konw":"know",
    "kwno":"know",
    "nkow":"know",
    "nkwo":"know",
    "knowlege":"knowledge",
    "knowlegeable":"knowledgeable",
    "knwos":"knows",
    "konws":"knows",
    "knbbi":"Knubbi",
    "labled":"labeled",
    "labratory":"laboratory",
    "layed":"laid",
    "laguage":"language",
    "laguages":"languages",
    "larg":"large",
    "largst":"largest",
    "larrry":"larry",
    "lavae":"larvae",
    "lastr":"last",
    "lsat":"last",
    "lattitude":"latitude",
    "launchs":"launch",
    "launhed":"launched",
    "labatory":"lavatory",
    "lazyness":"laziness",
    "leage":"league",
    "leran":"learn",
    "lerans":"learns",
    "lefted":"left",
    "legitamate":"legitimate",
    "legitmate":"legitimate",
    "leibnitz":"leibniz",
    "liesure":"leisure",
    "lenght":"length",
    "leathal":"lethal",
    "levle":"level",
    "levetate":"levitate",
    "levetated":"levitated",
    "levetates":"levitates",
    "levetating":"levitating",
    "liasion":"liaison",
    "liason":"liaison",
    "liasons":"liaisons",
    "libell":"libel",
    "lible":"libel",
    "libitarianisn":"libertarianism",
    "libary":"library",
    "lybia":"Libya",
    "liscense":"license",
    "lisence":"license",
    "lisense":"license",
    "leutenant":"lieutenant",
    "lieuenant":"lieutenant",
    "liftime":"lifetime",
    "lightyear":"light year",
    "lightyears":"light years",
    "liek":"like",
    "liuke":"like",
    "liekd":"liked",
    "likelyhood":"likelihood",
    "lukid":"likud",
    "lmits":"limits",
    "libguistic":"linguistic",
    "libguistics":"linguistics",
    "linnaena":"linnaean",
    "lippizaner":"lipizzaner",
    "liquify":"liquefy",
    "listners":"listeners",
    "literaly":"literally",
    "litterally":"literally",
    "litature":"literature",
    "literture":"literature",
    "littel":"little",
    "lieved":"lived",
    "livley":"lively",
    "lonelyness":"loneliness",
    "lonley":"lonely",
    "lonly":"lonely",
    "longitudonal":"longitudinal",
    "lotharingen":"lothringen",
    "loev":"love",
    "lveo":"love",
    "lvoe":"love",
    "lieing":"lying",
    "maching":"machine",
    "mackeral":"mackerel",
    "magasine":"magazine",
    "magincian":"magician",
    "magnificient":"magnificent",
    "magolia":"magnolia",
    "mailny":"mainly",
    "mantained":"maintained",
    "maintinaing":"maintaining",
    "maintainance":"maintenance",
    "maintainence":"maintenance",
    "maintance":"maintenance",
    "maintenence":"maintenance",
    "majoroty":"majority",
    "marjority":"majority",
    "amke":"make",
    "mkae":"make",
    "mkea":"make",
    "makse":"makes",
    "mkaes":"makes",
    "amking":"making",
    "mkaing":"making",
    "malcom":"Malcolm",
    "maltesian":"Maltese",
    "mamal":"mammal",
    "mamalian":"mammalian",
    "managable":"manageable",
    "managment":"management",
    "manouver":"maneuver",
    "manuever":"maneuver",
    "manuver":"maneuver",
    "manoeuverability":"maneuverability",
    "manouverability":"maneuverability",
    "manouverable":"maneuverable",
    "manouvers":"maneuvers",
    "manuevers":"maneuvers",
    "manisfestations":"manifestations",
    "maneouvre":"maneuver",
    "maneouvred":"maneuvered",
    "maneouvres":"maneuvers",
    "maneouvring":"maneuvering",
    "manufature":"manufacture",
    "manufacturedd":"manufactured",
    "manufatured":"manufactured",
    "manufaturing":"manufacturing",
    "maked":"marked",
    "marketting":"marketing",
    "markes":"marks",
    "marmelade":"marmalade",
    "mariage":"marriage",
    "marrage":"marriage",
    "marraige":"marriage",
    "marryied":"married",
    "marrtyred":"martyred",
    "massmedia":"mass media",
    "massachussets":"Massachusetts",
    "massachussetts":"Massachusetts",
    "masterbation":"masturbation",
    "materalists":"materialist",
    "mathmatically":"mathematically",
    "mathematican":"mathematician",
    "mathmatician":"mathematician",
    "matheticians":"mathematicians",
    "mathmaticians":"mathematicians",
    "mathamatics":"mathematics",
    "mathematicas":"mathematics",
    "mccarthyst":"mccarthyist",
    "meaninng":"meaning",
    "mchanics":"mechanics",
    "medacine":"medicine",
    "mediciney":"mediciny",
    "medeival":"medieval",
    "medevial":"medieval",
    "medievel":"medieval",
    "mediterainnean":"mediterranean",
    "mediteranean":"Mediterranean",
    "meerkrat":"meerkat",
    "memeber":"member",
    "membranaphone":"membranophone",
    "momento":"memento",
    "rememberable":"memorable",
    "menally":"mentally",
    "maintioned":"mentioned",
    "mercentile":"mercantile",
    "mechandise":"merchandise",
    "messenging":"messaging",
    "messanger":"messenger",
    "metalic":"metallic",
    "metalurgic":"metallurgic",
    "metalurgical":"metallurgical",
    "metalurgy":"metallurgy",
    "metamorphysis":"metamorphosis",
    "methaphor":"metaphor",
    "metaphoricial":"metaphorical",
    "methaphors":"metaphors",
    "mataphysical":"metaphysical",
    "meterologist":"meteorologist",
    "meterology":"meteorology",
    "michagan":"Michigan",
    "micoscopy":"microscopy",
    "midwifes":"midwives",
    "mileau":"milieu",
    "mileu":"milieu",
    "melieux":"milieux",
    "miliary":"military",
    "miliraty":"military",
    "millitary":"military",
    "miltary":"military",
    "milennia":"millennia",
    "millenia":"millennia",
    "millenial":"millennial",
    "millenialism":"millennialism",
    "milennium":"millennium",
    "millenium":"millennium",
    "milion":"million",
    "millon":"million",
    "millioniare":"millionaire",
    "millepede":"millipede",
    "minerial":"mineral",
    "minature":"miniature",
    "minumum":"minimum",
    "minstries":"ministries",
    "ministery":"ministry",
    "minstry":"ministry",
    "miniscule":"minuscule",
    "mirrorred":"mirrored",
    "miscelaneous":"miscellaneous",
    "miscellanious":"miscellaneous",
    "miscellanous":"miscellaneous",
    "mischeivous":"mischievous",
    "mischevious":"mischievous",
    "mischievious":"mischievous",
    "misdameanor":"misdemeanor",
    "misdemenor":"misdemeanor",
    "misdameanors":"misdemeanors",
    "misdemenors":"misdemeanors",
    "misfourtunes":"misfortunes",
    "mysogynist":"misogynist",
    "mysogyny":"misogyny",
    "misile":"missile",
    "missle":"missile",
    "missonary":"missionary",
    "missisipi":"Mississippi",
    "missisippi":"Mississippi",
    "misouri":"Missouri",
    "mispell":"misspell",
    "mispelled":"misspelled",
    "mispelling":"misspelling",
    "mythraic":"Mithraic",
    "missen":"mizzen",
    "modle":"model",
    "moderm":"modem",
    "mosture":"moisture",
    "moleclues":"molecules",
    "moent":"moment",
    "monestaries":"monasteries",
    "monestary":"monastery",
    "monday":"Monday",
    "moeny":"money",
    "monickers":"monikers",
    "monolite":"monolithic",
    "montypic":"monotypic",
    "montnana":"Montana",
    "mounth":"month",
    "monts":"months",
    "monserrat":"Montserrat",
    "mroe":"more",
    "omre":"more",
    "morisette":"Morissette",
    "morrisette":"Morissette",
    "morroccan":"moroccan",
    "morrocco":"morocco",
    "morroco":"morocco",
    "morgage":"mortgage",
    "mortage":"mortgage",
    "motiviated":"motivated",
    "montanous":"mountainous",
    "montains":"mountains",
    "movment":"movement",
    "movei":"movie",
    "mucuous":"mucous",
    "multicultralism":"multiculturalism",
    "multipled":"multiplied",
    "multiplers":"multipliers",
    "muncipalities":"municipalities",
    "muncipality":"municipality",
    "munnicipality":"municipality",
    "muder":"murder",
    "mudering":"murdering",
    "muscial":"musical",
    "muscician":"musician",
    "muscicians":"musicians",
    "muhammadan":"muslim",
    "mohammedans":"muslims",
    "muscels":"mussels",
    "mutiliated":"mutilated",
    "myraid":"myriad",
    "mysef":"myself",
    "misterious":"mysterious",
    "misteryous":"mysterious",
    "mysterous":"mysterious",
    "mistery":"mystery",
    "naieve":"naive",
    "nmae":"name",
    "naploeon":"Napoleon",
    "napolean":"Napoleon",
    "napoleonian":"Napoleonic",
    "ansalisation":"nasalisation",
    "ansalization":"nasalization",
    "naturual":"natural",
    "naturaly":"naturally",
    "naturely":"naturally",
    "naturually":"naturally",
    "nazereth":"Nazareth",
    "neccesarily":"necessarily",
    "neccessarily":"necessarily",
    "necesarily":"necessarily",
    "nessasarily":"necessarily",
    "neccesary":"necessary",
    "neccessary":"necessary",
    "necesary":"necessary",
    "nessecary":"necessary",
    "necessiate":"necessitate",
    "neccessities":"necessities",
    "ened":"need",
    "neglible":"negligible",
    "negligable":"negligible",
    "negociate":"negotiate",
    "negociation":"negotiation",
    "negotation":"negotiation",
    "negociations":"negotiations",
    "neigborhood":"neighborhood",
    "neigbor":"neighbor",
    "neigborhood":"neighborhood",
    "neigboring":"neighboring",
    "neigbors":"neighbors",
    "neigbour":"neighbor",
    "neigbourhood":"neighborhood",
    "neigbouring":"neighboring",
    "neigbours":"neighbors",
    "neolitic":"neolithic",
    "nestin":"nesting",
    "neverthless":"nevertheless",
    "newyorker":"New Yorker",
    "foundland":"Newfoundland",
    "newletters":"newsletters",
    "enxt":"next",
    "nickle":"nickel",
    "neice":"niece",
    "nightfa;;":"nightfall",
    "nightime":"nighttime",
    "ninteenth":"nineteenth",
    "ninty":"ninety",
    "nineth":"ninth",
    "noone":"no one",
    "noncombatents":"noncombatants",
    "nontheless":"nonetheless",
    "unoperational":"nonoperational",
    "nonsence":"nonsense",
    "noth":"north",
    "northereastern":"northeastern",
    "norhern":"northern",
    "northen":"northern",
    "nothern":"northern",
    "nto":"not",
    "noteable":"notable",
    "notabley":"notably",
    "noteably":"notably",
    "noticable":"noticeable",
    "noticible":"noticeable",
    "noticably":"noticeably",
    "noticeing":"noticing",
    "noteriety":"notoriety",
    "notwhithstanding":"notwithstanding",
    "noveau":"nouveau",
    "novermber":"November",
    "november":"November",
    "nowe":"now",
    "nowdays":"nowadays",
    "nucular":"nuclear",
    "nuculear":"nuclear",
    "nuisanse":"nuisance",
    "nusance":"nuisance",
    "nullabour":"Nullarbor",
    "munbers":"numbers",
    "numberous":"numerous",
    "nuremburg":"Nuremberg",
    "nuturing":"nurturing",
    "nutritent":"nutrient",
    "nutritents":"nutrients",
    "obediance":"obedience",
    "obediant":"obedient",
    "obssessed":"obsessed",
    "obession":"obsession",
    "obstacal":"obstacle",
    "obstancles":"obstacles",
    "obstruced":"obstructed",
    "ocasion":"occasion",
    "ocassion":"occasion",
    "occaison":"occasion",
    "occassion":"occasion",
    "ocasional":"occasional",
    "ocassional":"occasional",
    "occassional":"occasional",
    "ocasionally":"occasionally",
    "ocasionaly":"occasionally",
    "ocassionally":"occasionally",
    "ocassionaly":"occasionally",
    "occassionally":"occasionally",
    "occassionaly":"occasionally",
    "occationally":"occasionally",
    "ocasioned":"occasioned",
    "ocassioned":"occasioned",
    "occassioned":"occasioned",
    "ocasions":"occasions",
    "ocassions":"occasions",
    "occassions":"occasions",
    "occour":"occur",
    "occurr":"occur",
    "ocurr":"occur",
    "occured":"occurred",
    "ocurred":"occurred",
    "occurance":"occurrence",
    "occurence":"occurrence",
    "occurrance":"occurrence",
    "ocurrance":"occurrence",
    "ocurrence":"occurrence",
    "occurances":"occurrences",
    "occurences":"occurrences",
    "occurrances":"occurrences",
    "occuring":"occurring",
    "octohedra":"octahedra",
    "octohedral":"octahedral",
    "octohedron":"octahedron",
    "october":"October",
    "ouevre":"oeuvre",
    "offred":"offered",
    "offereings":"offerings",
    "offcers":"officers",
    "offical":"official",
    "offcially":"officially",
    "offically":"officially",
    "officaly":"officially",
    "officialy":"officially",
    "officals":"officials",
    "oftenly":"often",
    "omlet":"omelet",
    "omlette":"omelet",
    "omision":"omission",
    "ommision":"omission",
    "omited":"omitted",
    "ommited":"omitted",
    "ommitted":"omitted",
    "omiting":"omitting",
    "ommiting":"omitting",
    "ommitting":"omitting",
    "omniverous":"omnivorous",
    "omniverously":"omnivorously",
    "onyl":"only",
    "oppenly":"openly",
    "openess":"openness",
    "opthalmic":"ophthalmic",
    "opthalmologist":"ophthalmologist",
    "opthamologist":"ophthalmologist",
    "opthalmology":"ophthalmology",
    "oppinion":"opinion",
    "oponent":"opponent",
    "opponant":"opponent",
    "oppononent":"opponent",
    "oportunity":"opportunity",
    "opprotunity":"opportunity",
    "opose":"oppose",
    "oppossed":"opposed",
    "oposite":"opposite",
    "oposition":"opposition",
    "oppositition":"opposition",
    "opression":"oppression",
    "opressive":"oppressive",
    "optomism":"optimism",
    "optmizations":"optimizations",
    "orded":"ordered",
    "oridinarily":"ordinarily",
    "organistion":"organization",
    "orginize":"organize",
    "organim":"organism",
    "organiztion":"organization",
    "orgin":"origin",
    "orginal":"original",
    "originall":"original",
    "origional":"original",
    "orginally":"originally",
    "origanaly":"originally",
    "originaly":"originally",
    "originially":"originally",
    "originnally":"originally",
    "orignally":"originally",
    "orignially":"originally",
    "otehr":"other",
    "oustanding":"outstanding",
    "overthere":"over there",
    "overshaddowed":"overshadowed",
    "overwelming":"overwhelming",
    "overwheliming":"overwhelming",
    "oxigen":"oxygen",
    "oximoron":"oxymoron",
    "peageant":"pageant",
    "paide":"paid",
    "payed":"paid",
    "paleolitic":"paleolithic",
    "palistian":"Palestinian",
    "palistinian":"Palestinian",
    "palistinians":"Palestinians",
    "pallete":"palette",
    "pamflet":"pamphlet",
    "pamplet":"pamphlet",
    "pantomine":"pantomime",
    "papanicalou":"Papanicolaou",
    "perade":"parade",
    "parrakeets":"parakeets",
    "paralel":"parallel",
    "paralell":"parallel",
    "parralel":"parallel",
    "parrallel":"parallel",
    "parrallell":"parallel",
    "paralelly":"parallelly",
    "paralely":"parallelly",
    "parallely":"parallelly",
    "parrallelly":"parallelly",
    "parrallely":"parallelly",
    "parellels":"parallels",
    "paraphenalia":"paraphernalia",
    "paranthesis":"parenthesis",
    "parliment":"parliament",
    "paliamentarian":"parliamentarian",
    "partialy":"partially",
    "parituclar":"particular",
    "particualr":"particular",
    "paticular":"particular",
    "particually":"particularly",
    "particuarly":"particularly",
    "particularily":"particularly",
    "particulary":"particularly",
    "pary":"party",
    "pased":"passed",
    "pasengers":"passengers",
    "passerbys":"passersby",
    "pasttime":"pastime",
    "pastural":"pastoral",
    "pattented":"patented",
    "paitience":"patience",
    "pavillion":"pavilion",
    "peacefuland":"peaceful and",
    "peculure":"peculiar",
    "pedestrain":"pedestrian",
    "perjorative":"pejorative",
    "peloponnes":"Peloponnesus",
    "penatly":"penalty",
    "penerator":"penetrator",
    "penisula":"peninsula",
    "penninsula":"peninsula",
    "pennisula":"peninsula",
    "pensinula":"peninsula",
    "penisular":"peninsular",
    "penninsular":"peninsular",
    "p0enis":"penis",
    "poenis":"penis",
    "pennyslvania":"Pennsylvania",
    "peopel":"people",
    "poeoples":"peoples",
    "percieve":"perceive",
    "percepted":"perceived",
    "percieved":"perceived",
    "precentage":"percentage",
    "perenially":"perennially",
    "perfomance":"performance",
    "performence":"performance",
    "peformed":"performed",
    "performes":"performed",
    "perfomers":"performers",
    "perhasp":"perhaps",
    "perheaps":"perhaps",
    "perhpas":"perhaps",
    "perphas": "perhaps",
    "persay": "per se",
    "preiod":"period",
    "preriod":"period",
    "peripathetic":"peripatetic",
    "perjery":"perjury",
    "permanant":"permanent",
    "permenant":"permanent",
    "permenantly":"permanently",
    "permissable":"permissible",
    "premission":"permission",
    "perpindicular":"perpendicular",
    "perseverence":"perseverance",
    "persistance":"persistence",
    "peristent":"persistent",
    "persistant":"persistent",
    "peronal":"personal",
    "perosnality":"personality",
    "personel":"personnel",
    "personell":"personnel",
    "personnell":"personnel",
    "prespective":"perspective",
    "pursuade":"persuade",
    "persuded":"persuaded",
    "pursuaded":"persuaded",
    "pursuades":"persuades",
    "pususading":"persuading",
    "pertubation":"perturbation",
    "pertubations":"perturbations",
    "preverse":"perverse",
    "pessiary":"pessary",
    "petetion":"petition",
    "pharoah":"Pharaoh",
    "phenonmena":"phenomena",
    "phenomenonal":"phenomenal",
    "phenomenonly":"phenomenally",
    "phenomenom":"phenomenon",
    "phenomonenon":"phenomenon",
    "phenomonon":"phenomenon",
    "feromone":"pheromone",
    "phillipine":"Philippine",
    "philipines":"Philippines",
    "phillipines":"Philippines",
    "phillippines":"Philippines",
    "philisopher":"philosopher",
    "philospher":"philosopher",
    "philisophical":"philosophical",
    "phylosophical":"philosophical",
    "phillosophically":"philosophically",
    "philosphies":"philosophies",
    "philisophy":"philosophy",
    "philosphy":"philosophy",
    "phonecian":"Phoenecian",
    "fonetic":"phonetic",
    "phongraph":"phonograph",
    "physicaly":"physically",
    "peice":"piece",
    "pilgrimmage":"pilgrimage",
    "pilgrimmages":"pilgrimages",
    "pinapple":"pineapple",
    "pinnaple":"pineapple",
    "pinoneered":"pioneered",
    "pich":"pitch",
    "palce":"place",
    "plagarism":"plagiarism",
    "plantiff":"plaintiff",
    "planed":"planned",
    "planation":"plantation",
    "plateu":"plateau",
    "plausable":"plausible",
    "playright":"playwright",
    "playwrite":"playwright",
    "playwrites":"playwrights",
    "pleasent":"pleasant",
    "plesant":"pleasant",
    "plebicite":"plebiscite",
    "peom":"poem",
    "peoms":"poems",
    "peotry":"poetry",
    "poety":"poetry",
    "progrom":"pogrom",
    "progroms":"pogroms",
    "poisin":"poison",
    "posion":"poison",
    "polical":"political",
    "poltical":"political",
    "politican":"politician",
    "politicans":"politicians",
    "polinator":"pollinator",
    "polinators":"pollinators",
    "polute":"pollute",
    "poluted":"polluted",
    "polutes":"pollutes",
    "poluting":"polluting",
    "polution":"pollution",
    "polyphonyic":"polyphonic",
    "polysaccaride":"polysaccharide",
    "polysaccharid":"polysaccharide",
    "pomegranite":"pomegranate",
    "populare":"popular",
    "populer":"popular",
    "popularaty":"popularity",
    "popoulation":"population",
    "poulations":"populations",
    "portait":"portrait",
    "potrait":"portrait",
    "portayed":"portrayed",
    "potrayed":"portrayed",
    "protrayed":"portrayed",
    "portraing":"portraying",
    "portugese":"Portuguese",
    "portuguease":"portuguese",
    "portugues":"Portuguese",
    "positon":"position",
    "possition":"position",
    "postion":"position",
    "postive":"positive",
    "posess":"possess",
    "posessed":"possessed",
    "posesses":"possesses",
    "posseses":"possesses",
    "possessess":"possesses",
    "posessing":"possessing",
    "possesing":"possessing",
    "posession":"possession",
    "possesion":"possession",
    "posessions":"possessions",
    "possiblities":"possibilities",
    "possibilty":"possibility",
    "possiblility":"possibility",
    "possiblilty":"possibility",
    "possiblity":"possibility",
    "possable":"possible",
    "possibile":"possible",
    "possably":"possibly",
    "posthomous":"posthumous",
    "potatos":"potatoes",
    "postdam":"Potsdam",
    "pwoer":"power",
    "poverful":"powerful",
    "poweful":"powerful",
    "powerfull":"powerful",
    "practial":"practical",
    "practially":"practically",
    "practicaly":"practically",
    "practicly":"practically",
    "pratice":"practice",
    "practicioner":"practitioner",
    "practioner":"practitioner",
    "practicioners":"practitioners",
    "practioners":"practitioners",
    "prairy":"prairie",
    "prarie":"prairie",
    "praries":"prairies",
    "preample":"preamble",
    "preceed":"precede",
    "preceeded":"preceded",
    "preceeds":"precedes",
    "preceeding":"preceding",
    "precice":"precise",
    "precisly":"precisely",
    "precurser":"precursor",
    "precedessor":"predecessor",
    "predecesors":"predecessors",
    "predicatble":"predictable",
    "predicitons":"predictions",
    "predomiantly":"predominately",
    "preminence":"preeminence",
    "preferrably":"preferably",
    "prefered":"preferred",
    "prefering":"preferring",
    "pregancies":"pregnancies",
    "premeire":"premiere",
    "premeired":"premiered",
    "premillenial":"premillennial",
    "premonasterians":"Premonstratensians",
    "preocupation":"preoccupation",
    "prepartion":"preparation",
    "preperation":"preparation",
    "preperations":"preparations",
    "prepatory":"preparatory",
    "prepair":"prepare",
    "perogative":"prerogative",
    "presense":"presence",
    "presedential":"presidential",
    "presidenital":"presidential",
    "presidental":"presidential",
    "presitgious":"prestigious",
    "prestigeous":"prestigious",
    "prestigous":"prestigious",
    "presumabely":"presumably",
    "presumibly":"presumably",
    "prevelant":"prevalent",
    "previvous":"previous",
    "priestood":"priesthood",
    "primarly":"primarily",
    "primative":"primitive",
    "primatively":"primitively",
    "primatives":"primitives",
    "primordal":"primordial",
    "pricipal":"principal",
    "priciple":"principle",
    "privte":"private",
    "privelege":"privilege",
    "privelige":"privilege",
    "privilage":"privilege",
    "priviledge":"privilege",
    "privledge":"privilege",
    "priveleged":"privileged",
    "priveliged":"privileged",
    "priveledges":"privileges",
    "priveleges":"privileges",
    "priveliges":"privileges",
    "privelleges":"privileges",
    "priviledges":"privileges",
    "probablistic":"probabilistic",
    "probabilaty":"probability",
    "probalibity":"probability",
    "probablly":"probably",
    "probaly":"probably",
    "probelm":"problem",
    "procedger":"procedure",
    "proceedure":"procedure",
    "procede":"proceed",
    "proceded":"proceeded",
    "proceding":"proceeding",
    "procedings":"proceedings",
    "procedes":"proceeds",
    "proccess":"process",
    "proces":"process",
    "proccessing":"processing",
    "processer":"processor",
    "proclamed":"proclaimed",
    "proclaming":"proclaiming",
    "proclaimation":"proclamation",
    "proclomation":"proclamation",
    "proffesed":"professed",
    "proffesion":"profession",
    "proffesional":"professional",
    "profesor":"professor",
    "professer":"professor",
    "proffesor":"professor",
    "profesion":"profusion",
    "programable":"programmable",
    "progessed":"progressed",
    "prohabition":"prohibition",
    "prologomena":"prolegomena",
    "preliferation":"proliferation",
    "profilic":"prolific",
    "prominance":"prominence",
    "prominant":"prominent",
    "prominantly":"prominently",
    "prominately":"prominently",
    "promiscous":"promiscuous",
    "promotted":"promoted",
    "pomotion":"promotion",
    "propmted":"prompted",
    "pronomial":"pronominal",
    "pronouced":"pronounced",
    "pronounched":"pronounced",
    "prouncements":"pronouncements",
    "pronounciation":"pronunciation",
    "propoganda":"propaganda",
    "propogate":"propagate",
    "propogates":"propagates",
    "propogation":"propagation",
    "propper":"proper",
    "propperly":"properly",
    "prophacy":"prophecy",
    "poportional":"proportional",
    "propotions":"proportions",
    "propostion":"proposition",
    "propietary":"proprietary",
    "proprietory":"proprietary",
    "proseletyzing":"proselytizing",
    "protaganist":"protagonist",
    "protoganist":"protagonist",
    "protaganists":"protagonists",
    "pretection":"protection",
    "protocal":"protocol",
    "protruberance":"protuberance",
    "protruberances":"protuberances",
    "proove":"prove",
    "prooved":"proved",
    "provded":"provided",
    "provicial":"provincial",
    "provinicial":"provincial",
    "provisiosn":"provision",
    "provisonal":"provisional",
    "provacative":"provocative",
    "proximty":"proximity",
    "psuedo":"pseudo",
    "pseudonyn":"pseudonym",
    "pseudononymous":"pseudonymous",
    "psyhic":"psychic",
    "pyscic":"psychic",
    "psycology":"psychology",
    "publically":"publicly",
    "publicaly":"publicly",
    "publisheed":"published",
    "oublisher":"publisher",
    "pblisher":"publisher",
    "pbulisher":"publisher",
    "piblisher":"publisher",
    "ppublisher":"publisher",
    "pubilsher":"publisher",
    "pubisher":"publisher",
    "publiaher":"publisher",
    "publicher":"publisher",
    "publihser":"publisher",
    "publisehr":"publisher",
    "publiser":"publisher",
    "publisger":"publisher",
    "publisherr":"publisher",
    "publishher":"publisher",
    "publishor":"publisher",
    "publishre":"publisher",
    "publissher":"publisher",
    "publlisher":"publisher",
    "publsiher":"publisher",
    "publusher":"publisher",
    "pulisher":"publisher",
    "puplisher":"publisher",
    "ublisher":"publisher",
    "pucini":"Puccini",
    "puertorrican":"Puerto Rican",
    "puertorricans":"Puerto Ricans",
    "pumkin":"pumpkin",
    "puchasing":"purchasing",
    "puritannical":"puritanical",
    "purpotedly":"purportedly",
    "purposedly":"purposely",
    "persue":"pursue",
    "persued":"pursued",
    "persuing":"pursuing",
    "persuit":"pursuit",
    "persuits":"pursuits",
    "puting":"putting",
    "quantaty":"quantity",
    "quantitiy":"quantity",
    "quarantaine":"quarantine",
    "queenland":"Queensland",
    "questonable":"questionable",
    "quicklyu":"quickly",
    "quinessential":"quintessential",
    "quitted":"quit",
    "qtuie":"quite",
    "qutie":"quite",
    "quizes":"quizzes",
    "rabinnical":"rabbinical",
    "radiactive":"radioactive",
    "repid":"rapid",
    "rarified":"rarefied",
    "radify":"ratify",
    "racaus":"raucous",
    "reched":"reached",
    "reacing":"reaching",
    "readmition":"readmission",
    "rela":"real",
    "relized":"realized",
    "realsitic":"realistic",
    "raelly":"really",
    "realy":"really",
    "realyl":"really",
    "relaly":"really",
    "rebllions":"rebellions",
    "rebounce":"rebound",
    "rebiulding":"rebuilding",
    "reacll":"recall",
    "receeded":"receded",
    "receeding":"receding",
    "reciept":"receipt",
    "recieve":"receive",
    "recieved":"received",
    "recived":"received",
    "receivedfrom":"received from",
    "reciever":"receiver",
    "recievers":"receivers",
    "recivership":"receivership",
    "recieves":"receives",
    "receving":"receiving",
    "recieving":"receiving",
    "rechargable":"rechargeable",
    "recepient":"recipient",
    "recipiant":"recipient",
    "recepients":"recipients",
    "reciepents":"recipients",
    "recipiants":"recipients",
    "recogise":"recognize",
    "recogize":"recognize",
    "reconized":"recognized",
    "reccomend":"recommend",
    "reccommend":"recommend",
    "recomend":"recommend",
    "reccomendations":"recommendations",
    "recommedations":"recommendations",
    "reccomended":"recommended",
    "reccommended":"recommended",
    "recomended":"recommended",
    "reccomending":"recommending",
    "reccommending":"recommending",
    "recomending":"recommending",
    "recomends":"recommends",
    "reconcilation":"reconciliation",
    "reconaissance":"reconnaissance",
    "reconnaisance":"reconnaissance",
    "reconnaissence":"reconnaissance",
    "recontructed":"reconstructed",
    "recrod":"record",
    "rocord":"record",
    "recordproducer":"record producer",
    "recrational":"recreational",
    "recuiting":"recruiting",
    "rucuperate":"recuperate",
    "recurrance":"recurrence",
    "reoccurrence":"recurrence",
    "reaccurring":"recurring",
    "reccuring":"recurring",
    "recuring":"recurring",
    "reedeming":"redeeming",
    "relected":"reelected",
    "revaluated":"reevaluated",
    "referece":"reference",
    "referemce":"reference",
    "referenece":"reference",
    "referrence":"reference",
    "refference":"reference",
    "refrence":"reference",
    "rference":"reference",
    "refereneced":"referenced",
    "refereces":"references",
    "referemces":"references",
    "referencs":"references",
    "refereneces":"references",
    "refernce":"references",
    "refernces":"references",
    "referrences":"references",
    "refrences":"references",
    "rferences":"references",
    "refedendum":"referendum",
    "referal":"referral",
    "refered":"referred",
    "reffered":"referred",
    "referiang":"referring",
    "refering":"referring",
    "reffering":"referring",
    "referrs":"refers",
    "refrers":"refers",
    "refect":"reflect",
    "refromist":"reformist",
    "refridgeration":"refrigeration",
    "refridgerator":"refrigerator",
    "refusla":"refusal",
    "irregardless":"regardless",
    "regardes":"regards",
    "regluar":"regular",
    "reguarly":"regularly",
    "regularily":"regularly",
    "regulaion":"regulation",
    "regulaotrs":"regulators",
    "rehersal":"rehearsal",
    "reigining":"reigning",
    "reicarnation":"reincarnation",
    "reenforced":"reinforced",
    "realtions":"relations",
    "relatiopnship":"relationship",
    "realitvely":"relatively",
    "relativly":"relatively",
    "relitavely":"relatively",
    "releses":"releases",
    "relevence":"relevance",
    "relevent":"relevant",
    "reliablity":"reliability",
    "relient":"reliant",
    "releive":"relieve",
    "releived":"relieved",
    "releiver":"reliever",
    "religeous":"religious",
    "religous":"religious",
    "religously":"religiously",
    "relinqushment":"relinquishment",
    "remaing":"remaining",
    "remeber":"remember",
    "rememberance":"remembrance",
    "remembrence":"remembrance",
    "remenicent":"reminiscent",
    "reminescent":"reminiscent",
    "reminscent":"reminiscent",
    "reminsicent":"reminiscent",
    "remenant":"remnant",
    "reminent":"remnant",
    "renedered":"rende",
    "rendevous":"rendezvous",
    "rendezous":"rendezvous",
    "renewl":"renewal",
    "rennovate":"renovate",
    "rennovated":"renovated",
    "rennovating":"renovating",
    "rennovation":"renovation",
    "reknown":"renown",
    "reknowned":"renowned",
    "rentors":"renters",
    "reorganision":"reorganization",
    "reorganizion":"reorganization",
    "repeteadly":"repeatedly",
    "repentence":"repentance",
    "repentent":"repentant",
    "reprtoire":"repertoire",
    "repatition":"repetition",
    "repeition":"repetition",
    "repetion":"repetition",
    "reptition":"repetition",
    "relpacement":"replacement",
    "reportadly":"reportedly",
    "represantative":"representative",
    "representive":"representative",
    "representives":"representatives",
    "reproducable":"reproducible",
    "recquired":"required",
    "requred":"required",
    "requirment":"requirement",
    "reasearch":"research",
    "resembelance":"resemblance",
    "resemblence":"resemblance",
    "ressemblance":"resemblance",
    "ressemblence":"resemblance",
    "ressemble":"resemble",
    "ressembled":"resembled",
    "resembes":"resembles",
    "ressembling":"resembling",
    "resevoir":"reservoir",
    "recide":"reside",
    "recided":"resided",
    "recident":"resident",
    "residental":"residential",
    "recidents":"residents",
    "reciding":"residing",
    "resignement":"resignment",
    "resistence":"resistance",
    "resistent":"resistant",
    "resistable":"resistible",
    "repectively":"respectively",
    "repsectively":"respectively",
    "respectivly":"respectively",
    "reponse":"response",
    "responce":"response",
    "responibilities":"responsibilities",
    "responsibilites":"responsibilities",
    "responsiblities":"responsibilities",
    "responnsibilty":"responsibility",
    "responsability":"responsibility",
    "responsiblity":"responsibility",
    "reponsible":"responsible",
    "responisble":"responsible",
    "responsibile":"responsible",
    "resaurant":"restaurant",
    "restarant":"restaurant",
    "restaraunt":"restaurant",
    "restauraunt":"restaurant",
    "resteraunt":"restaurant",
    "resturant":"restaurant",
    "resturaunt":"restaurant",
    "restarants":"restaurants",
    "restaraunts":"restaurants",
    "resteraunts":"restaurants",
    "resturants":"restaurants",
    "resturaunts":"restaurants",
    "restaraunteur":"restaurateur",
    "restaraunteurs":"restaurateurs",
    "restauranteurs":"restaurateurs",
    "restauration":"restoration",
    "restraunt":"restraint",
    "resticted":"restricted",
    "ressurect":"resurrect",
    "ressurected":"resurrected",
    "resssurecting":"resurrecting",
    "resurecting":"resurrecting",
    "ressurection":"resurrection",
    "ressurrection":"resurrection",
    "retalitated":"retaliated",
    "retalitation":"retaliation",
    "retreive":"retrieve",
    "returnd":"returned",
    "reveral":"reversal",
    "reversable":"reversible",
    "reveiw":"review",
    "revolutionar":"revolutionary",
    "rewriet":"rewrite",
    "rewitten":"rewritten",
    "rhymme":"rhyme",
    "rhythem":"rhythm",
    "rhythim":"rhythm",
    "rythem":"rhythm",
    "rythim":"rhythm",
    "rythm":"rhythm",
    "rhytmic":"rhythmic",
    "rythmic":"rhythmic",
    "rythyms":"rhythms",
    "rediculous":"ridiculous",
    "rigourous":"rigorous",
    "rigeur":"rigor",
    "rigueur":"rigor",
    "rininging":"ringing",
    "rockerfeller":"Rockefeller",
    "rococco":"rococo",
    "roomate":"roommate",
    "rised":"rose",
    "rougly":"roughly",
    "rudimentatry":"rudimentary",
    "rulle":"rule",
    "runing":"running",
    "runnung":"running",
    "russina":"Russian",
    "russion":"Russian",
    "sacrafice":"sacrifice",
    "sacrifical":"sacrificial",
    "sacreligious":"sacrilegious",
    "saftey":"safety",
    "safty":"safety",
    "salery":"salary",
    "smae":"same",
    "santioned":"sanctioned",
    "sanctionning":"sanctioning",
    "sandwhich":"sandwich",
    "sanhedrim":"Sanhedrin",
    "satelite":"satellite",
    "sattelite":"satellite",
    "satelites":"satellites",
    "sattelites":"satellites",
    "satric":"satiric",
    "satrical":"satirical",
    "satrically":"satirically",
    "satisfactority":"satisfactorily",
    "saterday":"Saturday",
    "saturday":"Saturday",
    "saterdays":"Saturdays",
    "sotyr":"satyr",
    "saveing":"saving",
    "saxaphone":"saxophone",
    "sasy":"says",
    "syas":"says",
    "scaleable":"scalable",
    "scandanavia":"Scandinavia",
    "scaricity":"scarcity",
    "scavanged":"scavenged",
    "senarios":"scenarios",
    "schedual":"schedule",
    "scholarhip":"scholarship",
    "scholarstic":"scholastic",
    "scince":"science",
    "scinece":"science",
    "scientfic":"scientific",
    "scientifc":"scientific",
    "scientis":"scientist",
    "screenwrighter":"screenwriter",
    "scirpt":"script",
    "scoll":"scroll",
    "scrutinity":"scrutiny",
    "scuptures":"sculptures",
    "seach":"search",
    "seached":"searched",
    "seaches":"searches",
    "secceeded":"seceded",
    "secratary":"secretary",
    "secretery":"secretary",
    "seing":"seeing",
    "segementation":"segmentation",
    "seguoys":"segues",
    "sieze":"seize",
    "siezed":"seized",
    "siezing":"seizing",
    "siezure":"seizure",
    "siezures":"seizures",
    "seldomly":"seldom",
    "seinor":"senior",
    "sence":"sense",
    "senstive":"sensitive",
    "seperate":"separate",
    "seperated":"separated",
    "seperately":"separately",
    "seperates":"separates",
    "seperating":"separating",
    "seperation":"separation",
    "seperatism":"separatism",
    "seperatist":"separatist",
    "september":"September",
    "sepulchure":"sepulcher",
    "sepulcre":"sepulcher",
    "sargant":"sergeant",
    "sargeant":"sergeant",
    "sergent":"sergeant",
    "sevice":"service",
    "settelement":"settlement",
    "settlment":"settlement",
    "severeal":"several",
    "severley":"severely",
    "severly":"severely",
    "shadasloo":"shadaloo",
    "shadoloo":"shadaloo",
    "shaddow":"shadow",
    "shamen":"shaman",
    "sheat":"sheath",
    "sherif":"sheriff",
    "sheild":"shield",
    "shineing":"shining",
    "shiped":"shipped",
    "shiping":"shipping",
    "shopkeeepers":"shopkeepers",
    "shortwhile":"short while",
    "shorly":"shortly",
    "shoudl":"should",
    "shoudln":"should",
    "shouldnt":"shouldn't",
    "sohw":"show",
    "shreak":"shriek",
    "shrinked":"shrunk",
    "sedereal":"sidereal",
    "sideral":"sidereal",
    "seige":"siege",
    "signitories":"signatories",
    "signitory":"signatory",
    "siginificant":"significant",
    "signficant":"significant",
    "signficiant":"significant",
    "signifigant":"significant",
    "signifantly":"significantly",
    "significently":"significantly",
    "signifigantly":"significantly",
    "signfies":"signifies",
    "similiar":"similar",
    "simmilar":"similar",
    "similiarity":"similarity",
    "similarily":"similarly",
    "similiarly":"similarly",
    "simplier":"simpler",
    "simpley":"simply",
    "simultanous":"simultaneous",
    "simultanously":"simultaneously",
    "sicne":"since",
    "sincerley":"sincerely",
    "sinse":"sines",
    "singsog":"singsong",
    "sixtin":"Sistine",
    "skagerak":"Skagerrak",
    "skateing":"skating",
    "slaugterhouses":"slaughterhouses",
    "slighly":"slightly",
    "slowy":"slowly",
    "smealting":"smelting",
    "sneeks":"sneaks",
    "snese":"sneeze",
    "socalism":"socialism",
    "socities":"societies",
    "sofware":"software",
    "moil":"soil",
    "soilders":"soldiers",
    "soliders":"soldiers",
    "soley":"solely",
    "soliliquy":"soliloquy",
    "solatary":"solitary",
    "soluable":"soluble",
    "smoe":"some",
    "soem":"some",
    "somene":"someone",
    "somtimes":"sometimes",
    "somwhere":"somewhere",
    "sophicated":"sophisticated",
    "suphisticated":"sophisticated",
    "sophmore":"sophomore",
    "sorceror":"sorcerer",
    "saught":"sought",
    "soudn":"sound",
    "soudns":"sounds",
    "sountrack":"soundtrack",
    "suop":"soup",
    "sourth":"south",
    "sourthern":"southern",
    "souvenier":"souvenir",
    "souveniers":"souvenirs",
    "soverign":"sovereign",
    "sovereignity":"sovereignty",
    "soverignity":"sovereignty",
    "soverignty":"sovereignty",
    "soveits":"soviets",
    "spoace":"space",
    "spainish":"Spanish",
    "speciallized":"specialized",
    "speices":"species",
    "specfic":"specific",
    "specif":"specific",
    "specifiying":"specifying",
    "speciman":"specimen",
    "spectauclar":"spectacular",
    "spectaulars":"spectaculars",
    "spectum":"spectrum",
    "speach":"speech",
    "sprech":"speech",
    "sppeches":"speeches",
    "spermatozoan":"spermatozoon",
    "spriritual":"spiritual",
    "spritual":"spiritual",
    "spendour":"splendor",
    "sponser":"sponsor",
    "sponsered":"sponsored",
    "sponzored":"sponsored",
    "spontanous":"spontaneous",
    "spoonfulls":"spoonfuls",
    "spred":"spread",
    "sqaure":"square",
    "stablility":"stability",
    "stainlees":"stainless",
    "standars":"standards",
    "strat":"start",
    "statment":"statement",
    "statememts":"statements",
    "stateman":"statesman",
    "staion":"station",
    "sterotypes":"stereotypes",
    "steriods":"steroids",
    "stiring":"stirring",
    "stirrs":"stirs",
    "stomache":"stomach",
    "stpo":"stop",
    "storeis":"stories",
    "storise":"stories",
    "sotry":"story",
    "stopry":"story",
    "stoyr":"story",
    "stroy":"story",
    "strnad":"strand",
    "stange":"strange",
    "startegic":"strategic",
    "stratagically":"strategically",
    "startegies":"strategies",
    "stradegies":"strategies",
    "startegy":"strategy",
    "stradegy":"strategy",
    "streemlining":"streamlining",
    "stregth":"strength",
    "strenght":"strength",
    "strenghen":"strengthen",
    "strenghten":"strengthen",
    "strenghened":"strengthened",
    "strenghtened":"strengthened",
    "strengtened":"strengthened",
    "strenghening":"strengthening",
    "strenghtening":"strengthening",
    "strenous":"strenuous",
    "strictist":"strictest",
    "strikely":"strikingly",
    "stingent":"stringent",
    "stong":"strong",
    "stornegst":"strongest",
    "structual":"structural",
    "stucture":"structure",
    "sturcture":"structure",
    "stuctured":"structured",
    "stuggling":"struggling",
    "stubborness":"stubbornness",
    "studdy":"study",
    "studing":"studying",
    "stlye":"style",
    "sytle":"style",
    "stilus":"stylus",
    "subcatagories":"subcategories",
    "subcatagory":"subcategory",
    "subconsiously":"subconsciously",
    "subjudgation":"subjugation",
    "submachne":"submachine",
    "sepina":"subpoena",
    "subsquent":"subsequent",
    "subsquently":"subsequently",
    "subsidary":"subsidiary",
    "subsiduary":"subsidiary",
    "subpecies":"subspecies",
    "substace":"substance",
    "subtances":"substances",
    "substancial":"substantial",
    "substatial":"substantial",
    "substituded":"substituted",
    "subterranian":"subterranean",
    "substract":"subtract",
    "substracted":"subtracted",
    "substracting":"subtracting",
    "substraction":"subtraction",
    "substracts":"subtracts",
    "suburburban":"suburban",
    "seceed":"succeed",
    "suceed":"succeed",
    "seceeded":"succeeded",
    "succceeded":"succeeded",
    "succedded":"succeeded",
    "succeded":"succeeded",
    "suceeded":"succeeded",
    "suceeding":"succeeding",
    "succeds":"succeeds",
    "suceeds":"succeeds",
    "succsess":"success",
    "sucess":"success",
    "succcesses":"successes",
    "sucesses":"successes",
    "succesful":"successful",
    "successfull":"successful",
    "succsessfull":"successful",
    "sucesful":"successful",
    "sucessful":"successful",
    "sucessfull":"successful",
    "succesfully":"successfully",
    "succesfuly":"successfully",
    "successully":"successfully",
    "sucesfully":"successfully",
    "sucesfuly":"successfully",
    "sucessfully":"successfully",
    "sucessfuly":"successfully",
    "succesion":"succession",
    "sucesion":"succession",
    "sucession":"succession",
    "succesive":"successive",
    "sucessive":"successive",
    "sucessor":"successor",
    "sucessot":"successor",
    "sufferred":"suffered",
    "sufferring":"suffering",
    "sufficent":"sufficient",
    "sufficently":"sufficiently",
    "sufferage":"suffrage",
    "sucidial":"suicidal",
    "sucide":"suicide",
    "sumary":"summary",
    "sunday":"Sunday",
    "sunglases":"sunglasses",
    "superintendant":"superintendent",
    "superceeded":"superseded",
    "surplanted":"supplanted",
    "suplimented":"supplemented",
    "supplamented":"supplemented",
    "suppliementing":"supplementing",
    "suppy":"supply",
    "wupport":"support",
    "supose":"suppose",
    "suposed":"supposed",
    "suppoed":"supposed",
    "suposedly":"supposedly",
    "supposingly":"supposedly",
    "suposes":"supposes",
    "suposing":"supposing",
    "supress":"suppress",
    "surpress":"suppress",
    "supressed":"suppressed",
    "surpressed":"suppressed",
    "supresses":"suppresses",
    "supressing":"suppressing",
    "surfce":"surface",
    "surley":"surly",
    "suprise":"surprise",
    "suprize":"surprise",
    "surprize":"surprise",
    "suprised":"surprised",
    "suprized":"surprised",
    "surprized":"surprised",
    "suprising":"surprising",
    "suprizing":"surprising",
    "surprizing":"surprising",
    "suprisingly":"surprisingly",
    "suprizingly":"surprisingly",
    "surprizingly":"surprisingly",
    "surrundering":"surrendering",
    "surrepetitious":"surreptitious",
    "surreptious":"surreptitious",
    "surrepetitiously":"surreptitiously",
    "surreptiously":"surreptitiously",
    "suround":"surround",
    "surounded":"surrounded",
    "surrended":"surrounded",
    "surronded":"surrounded",
    "surrouded":"surrounded",
    "sorrounding":"surrounding",
    "surounding":"surrounding",
    "surrouding":"surrounding",
    "suroundings":"surroundings",
    "surounds":"surrounds",
    "surveill":"surveil",
    "surveilence":"surveillance",
    "surveyer":"surveyor",
    "survivied":"survived",
    "surviver":"survivor",
    "survivers":"survivors",
    "suseptable":"susceptible",
    "suseptible":"susceptible",
    "suspention":"suspension",
    "swaer":"swear",
    "swaers":"swears",
    "swepth":"swept",
    "swiming":"swimming",
    "symettric":"symmetric",
    "symmetral":"symmetric",
    "symetrical":"symmetrical",
    "symetrically":"symmetrically",
    "symmetricaly":"symmetrically",
    "symetry":"symmetry",
    "synphony":"symphony",
    "sypmtoms":"symptoms",
    "synagouge":"synagogue",
    "syncronization":"synchronization",
    "synonomous":"synonymous",
    "synonymns":"synonyms",
    "syphyllis":"syphilis",
    "syrap":"syrup",
    "sytem":"system",
    "sysmatically":"systematically",
    "tkae":"take",
    "tkaes":"takes",
    "tkaing":"taking",
    "talekd":"talked",
    "tlaking":"talking",
    "targetted":"targeted",
    "targetting":"targeting",
    "tast":"taste",
    "tattooes":"tattoos",
    "teached":"taught",
    "taxanomic":"taxonomic",
    "taxanomy":"taxonomy",
    "techician":"technician",
    "technitian":"technician",
    "techicians":"technicians",
    "techiniques":"techniques",
    "technnology":"technology",
    "technolgy":"technology",
    "telphony":"telephony",
    "telelevision":"television",
    "televsion":"television",
    "temperment":"temperament",
    "temparate":"temperate",
    "temerature":"temperature",
    "tempertaure":"temperature",
    "temperture":"temperature",
    "tempalte":"template",
    "tempaltes":"templates",
    "temperarily":"temporarily",
    "tepmorarily":"temporarily",
    "temprary":"temporary",
    "tendancies":"tendencies",
    "tendacy":"tendency",
    "tendancy":"tendency",
    "tennisplayer":"tennis player",
    "tenacle":"tentacle",
    "tenacles":"tentacles",
    "terrestial":"terrestrial",
    "terriories":"territories",
    "terriory":"territory",
    "territoy":"territory",
    "territorist":"terrorist",
    "terroist":"terrorist",
    "testiclular":"testicular",
    "tahn":"than",
    "thna":"than",
    "taht":"that",
    "tath":"that",
    "thast":"that",
    "thgat":"that",
    "thta":"that",
    "thyat":"that",
    "tyhat":"that",
    "teh":"the",
    "tghe":"the",
    "thge":"the",
    "tje":"the",
    "tjhe":"the",
    "theather":"theater",
    "theri":"their",
    "thier":"their",
    "themselfs":"themselves",
    "themslves":"themselves",
    "hten":"then",
    "thn":"then",
    "thne":"then",
    "htere":"there",
    "ther":"there",
    "therafter":"thereafter",
    "therby":"thereby",
    "theese":"these",
    "htey":"they",
    "tehy":"they",
    "tyhe":"they",
    "theyre":"they're",
    "theif":"thief",
    "theives":"thieves",
    "hting":"thing",
    "thign":"thing",
    "thnig":"thing",
    "thigns":"things",
    "thigsn":"things",
    "thnigs":"things",
    "htikn":"think",
    "htink":"think",
    "thikn":"think",
    "thiunk":"think",
    "tihkn":"think",
    "thikning":"thinking",
    "thikns":"thinks",
    "thrid":"third",
    "htis":"this",
    "thsi":"this",
    "tihs":"this",
    "throrough":"thorough",
    "throughly":"thoroughly",
    "ethose":"those",
    "thsoe":"those",
    "threatend":"threatened",
    "threatning":"threatening",
    "threee":"three",
    "threshhold":"threshold",
    "thru":"through",
    "thoughout":"throughout",
    "througout":"throughout",
    "thursday":"Thursday",
    "tiem":"time",
    "timne":"time",
    "tiome":"time",
    "tothe":"to the",
    "tabacco":"tobacco",
    "tobbaco":"tobacco",
    "todya":"today",
    "todays":"today's",
    "toghether":"together",
    "tolerence":"tolerance",
    "tolkein":"Tolkien",
    "tomatos":"tomatoes",
    "tommorow":"tomorrow",
    "tommorrow":"tomorrow",
    "tounge":"tongue",
    "tongiht":"tonight",
    "toke":"took",
    "tourch":"torch",
    "tormenters":"tormentors",
    "tornadoe":"tornado",
    "toriodal":"toroidal",
    "torpeados":"torpedoes",
    "torpedos":"torpedoes",
    "towrad":"toward",
    "towords":"towards",
    "twon":"town",
    "traditition":"tradition",
    "traditionnal":"traditional",
    "tradionally":"traditionally",
    "traditionaly":"traditionally",
    "tradtionally":"traditionally",
    "trafic":"traffic",
    "trafficed":"trafficked",
    "trafficing":"trafficking",
    "transcendance":"transcendence",
    "trancendent":"transcendent",
    "transcendant":"transcendent",
    "transcendentational":"transcendental",
    "trancending":"transcending",
    "transending":"transcending",
    "transcripting":"transcribing",
    "transfered":"transferred",
    "transfering":"transferring",
    "tranform":"transform",
    "transformaton":"transformation",
    "tranformed":"transformed",
    "transistion":"transition",
    "translater":"translator",
    "translaters":"translators",
    "transmissable":"transmissible",
    "transporation":"transportation",
    "transesxuals":"transsexuals",
    "tremelo":"tremolo",
    "tremelos":"tremolos",
    "triguered":"triggered",
    "triology":"trilogy",
    "troling":"trolling",
    "toubles":"troubles",
    "troup":"troupe",
    "troups":"troupes",
    "truely":"truly",
    "tust":"trust",
    "trustworthyness":"trustworthiness",
    "tuscon":"Tucson",
    "tuesday":"Tuesday",
    "turnk":"turnkey",
    "twelth":"twelfth",
    "twpo":"two",
    "typcial":"typical",
    "typicaly":"typically",
    "tyranies":"tyrannies",
    "tyrranies":"tyrannies",
    "tyrany":"tyranny",
    "tyrrany":"tyranny",
    "ubiquitious":"ubiquitous",
    "ukranian":"Ukrainian",
    "ultimely":"ultimately",
    "unacompanied":"unaccompanied",
    "unanymous":"unanimous",
    "unathorised":"unauthorized",
    "unathorized":"unauthorized",
    "unavailible":"unavailable",
    "unballance":"unbalance",
    "unbeknowst":"unbeknownst",
    "unbeleivable":"unbelievable",
    "uncertainity":"uncertainty",
    "unchallengable":"unchallengeable",
    "unchangable":"unchangeable",
    "uncompetive":"uncompetitive",
    "unconcious":"unconscious",
    "unconciousness":"unconsciousness",
    "uncontitutional":"unconstitutional",
    "unconvential":"unconventional",
    "undecideable":"undecidable",
    "indefineable":"undefinable",
    "undreground":"underground",
    "understoon":"understood",
    "undesireable":"undesirable",
    "undetecable":"undetectable",
    "undoubtely":"undoubtedly",
    "unforgetable":"unforgettable",
    "unforgiveable":"unforgivable",
    "unforetunately":"unfortunately",
    "unfortunatley":"unfortunately",
    "unfortunatly":"unfortunately",
    "unfourtunately":"unfortunately",
    "unahppy":"unhappy",
    "unilatreal":"unilateral",
    "unilateraly":"unilaterally",
    "unilatreally":"unilaterally",
    "unihabited":"uninhabited",
    "uninterruped":"uninterrupted",
    "uninterupted":"uninterrupted",
    "unitesstates":"UnitedStates",
    "univeral":"universal",
    "univeristies":"universities",
    "univesities":"universities",
    "univeristy":"university",
    "univerity":"university",
    "universtiy":"university",
    "univesity":"university",
    "unviersity":"university",
    "unkown":"unknown",
    "unlikey":"unlikely",
    "unmanouverable":"unmaneuverable",
    "unmistakeably":"unmistakably",
    "unneccesarily":"unnecessarily",
    "unneccessarily":"unnecessarily",
    "unnecesarily":"unnecessarily",
    "uneccesary":"unnecessary",
    "unecessary":"unnecessary",
    "unneccesary":"unnecessary",
    "unneccessary":"unnecessary",
    "unnecesary":"unnecessary",
    "unoticeable":"unnoticeable",
    "inofficial":"unofficial",
    "unoffical":"unofficial",
    "unplesant":"unpleasant",
    "unprecendented":"unprecedented",
    "unprecidented":"unprecedented",
    "unrepentent":"unrepentant",
    "unrepetant":"unrepentant",
    "unrepetent":"unrepentant",
    "unsubstanciated":"unsubstantiated",
    "unsuccesful":"unsuccessful",
    "unsuccessfull":"unsuccessful",
    "unsucesful":"unsuccessful",
    "unsucessful":"unsuccessful",
    "unsucessfull":"unsuccessful",
    "unsuccesfully":"unsuccessfully",
    "unsucesfuly":"unsuccessfully",
    "unsucessfully":"unsuccessfully",
    "unsuprised":"unsurprised",
    "unsuprized":"unsurprised",
    "unsurprized":"unsurprised",
    "unsuprising":"unsurprising",
    "unsuprizing":"unsurprising",
    "unsurprizing":"unsurprising",
    "unsuprisingly":"unsurprisingly",
    "unsuprizingly":"unsurprisingly",
    "unsurprizingly":"unsurprisingly",
    "untill":"until",
    "untranslateable":"untranslatable",
    "unuseable":"unusable",
    "unusuable":"unusable",
    "unwarrented":"unwarranted",
    "unweildly":"unwieldy",
    "unwieldly":"unwieldy",
    "upto":"up to",
    "tjpanishad":"upanishad",
    "upcomming":"upcoming",
    "upgradded":"upgraded",
    "apon":"upon",
    "useage":"usage",
    "uise":"use",
    "unsed":"used",
    "usefull":"useful",
    "usefuly":"usefully",
    "useing":"using",
    "usally":"usually",
    "usualy":"usually",
    "ususally":"usually",
    "vaccum":"vacuum",
    "vaccume":"vacuum",
    "vaguaries":"vagaries",
    "vailidty":"validity",
    "valetta":"valletta",
    "valuble":"valuable",
    "valueable":"valuable",
    "varient":"variant",
    "varations":"variations",
    "vaieties":"varieties",
    "varities":"varieties",
    "variey":"variety",
    "varity":"variety",
    "vreity":"variety",
    "vriety":"variety",
    "varing":"varying",
    "vasall":"vassal",
    "vasalls":"vassals",
    "vegitable":"vegetable",
    "vegtable":"vegetable",
    "vegitables":"vegetables",
    "vegatarian":"vegetarian",
    "vehicule":"vehicle",
    "vengance":"vengeance",
    "vengence":"vengeance",
    "venemous":"venomous",
    "meranda":"veranda",
    "verfication":"verification",
    "vermillion":"vermilion",
    "versitilaty":"versatility",
    "versitlity":"versatility",
    "verison":"version",
    "verisons":"versions",
    "veyr":"very",
    "vrey":"very",
    "vyer":"very",
    "vyre":"very",
    "vacinity":"vicinity",
    "vincinity":"vicinity",
    "vitories":"victories",
    "wiew":"view",
    "vigilence":"vigilance",
    "vigourous":"vigorous",
    "vigeur":"vigor",
    "vigueur":"vigor",
    "villification":"vilification",
    "villify":"vilify",
    "villian":"villain",
    "villin":"villi",
    "violentce":"violence",
    "virutal":"virtual",
    "virtualy":"virtually",
    "virutally":"virtually",
    "visable":"visible",
    "visably":"visibly",
    "visting":"visiting",
    "vistors":"visitors",
    "volcanoe":"volcano",
    "voleyball":"volleyball",
    "volumne":"volume",
    "volontary":"voluntary",
    "volonteer":"volunteer",
    "volounteer":"volunteer",
    "volonteered":"volunteered",
    "volounteered":"volunteered",
    "volonteering":"volunteering",
    "volounteering":"volunteering",
    "volonteers":"volunteers",
    "volounteers":"volunteers",
    "vulnerablility":"vulnerability",
    "watn":"want",
    "whant":"want",
    "wnat":"want",
    "wnated":"wanted",
    "whants":"wants",
    "wnats":"wants",
    "wardobe":"wardrobe",
    "warrent":"warrant",
    "warantee":"warranty",
    "warrriors":"warriors",
    "wass":"was",
    "weas":"was",
    "wasnt":"wasn't",
    "wayword":"wayward",
    "weaponary":"weaponry",
    "mear":"wear",
    "wendsay":"Wednesday",
    "wensday":"Wednesday",
    "wednesday":"Wednesday",
    "wierd":"weird",
    "vell":"well",
    "waht":"what",
    "whta":"what",
    "wehn":"when",
    "whn":"when",
    "wereabouts":"whereabouts",
    "wheras":"whereas",
    "wherease":"whereas",
    "whereever":"wherever",
    "whther":"whether",
    "hwihc":"which",
    "whcih":"which",
    "whic":"which",
    "whihc":"which",
    "whlch":"which",
    "wich":"which",
    "hwile":"while",
    "hwole":"whole",
    "wohle":"whole",
    "wholey":"wholly",
    "wholy":"wholly",
    "widesread":"widespread",
    "weild":"wield",
    "weilded":"wielded",
    "wief":"wife",
    "iwll":"will",
    "wille":"will",
    "wiull":"will",
    "willingless":"willingness",
    "iwth":"with",
    "whith":"with",
    "wih":"with",
    "wiht":"with",
    "withh":"with",
    "witht":"with",
    "witn":"with",
    "wtih":"with",
    "withdrawl":"withdrawal",
    "witheld":"withheld",
    "withold":"withhold",
    "withing":"within",
    "wonderfull":"wonderful",
    "owrk":"work",
    "wokr":"work",
    "wrok":"work",
    "wokring":"working",
    "wroking":"working",
    "workststion":"workstation",
    "worls":"world",
    "wordlwide":"worldwide",
    "worstened":"worsened",
    "owudl":"would",
    "woudl":"would",
    "wresters":"wrestlers",
    "rwite":"write",
    "wriet":"write",
    "wirting":"writing",
    "writen":"written",
    "wroet":"wrote",
    "xenophoby":"xenophobia",
    "yatch":"yacht",
    "yaching":"yachting",
    "eyar":"year",
    "yaer":"year",
    "yearm":"year",
    "yera":"year",
    "yaerly":"yearly",
    "eyars":"years",
    "eyasr":"years",
    "yaers":"years",
    "yeasr":"years",
    "yeras":"years",
    "yersa":"years",
    "yementite":"Yemenite",
    "yeild":"yield",
    "yeilding":"yielding",
    "ytou":"you",
    "yuo":"you",
    "youself":"yourself",
    "youseff":"yousef",
    "yotube":"youtube",
    "zeebra":"zebra",
    "sionist":"Zionist",
    "sionists":"Zionists",
    "Ameria":"America",
    "UnitedStates":"United States",
    "abbout":"about",
    "abotu":"about",
    "abouta":"about a",
    "aboutit":"about it",
    "aboutthe":"about the",
    "abscence":"absence",
    "accesories":"accessories",
    "accidant":"accident",
    "accordingto":"according to",
    "acn":"can",
    "acomodate":"accommodate",
    "actualyl":"actually",
    "additinal":"additional",
    "adequite":"adequate",
    "advanage":"advantage",
    "affraid":"afraid",
    "afterthe":"after the",
    "agreemeent":"agreement",
    "agreemeents":"agreements",
    "agreemnet":"agreement",
    "agreemnets":"agreements",
    "allwasy":"always",
    "allwyas":"always",
    "almots":"almost",
    "alraedy":"already",
    "alreday":"already",
    "alwats":"always",
    "alway":"always",
    "amde":"made",
    "amkes":"makes",
    "andone":"and one",
    "andteh":"and the",
    "andthe":"and the",
    "anothe":"another",
    "apparrent":"apparent",
    "appeares":"appears",
    "applyed":"applied",
    "appointiment":"appointment",
    "approrpiate":"appropriate",
    "approrpriate":"appropriate",
    "aquisitions":"acquisitions",
    "arond":"around",
    "asdvertising":"advertising",
    "assistent":"assistant",
    "asthe":"as the",
    "atention":"attention",
    "atmospher":"atmosphere",
    "attentioin":"attention",
    "atthe":"at the",
    "audiance":"audience",
    "availalbe":"available",
    "aywa":"away",
    "balence":"balance",
    "ballance":"balance",
    "becaus":"because",
    "becausea":"because a",
    "becauseof":"because of",
    "becausethe":"because the",
    "becauseyou":"because you",
    "becuse":"because",
    "beginining":"beginning",
    "beleiev":"believe",
    "beleieve":"believe",
    "beutiful":"beautiful",
    "boxs":"boxes",
    "brodcast":"broadcast",
    "butthe":"but the",
    "bve":"be",
    "caharcter":"character",
    "calcullated":"calculated",
    "candidtae":"candidate",
    "candidtaes":"candidates",
    "categiory":"category",
    "challanges":"challenges",
    "chaneg":"change",
    "chanegs":"changes",
    "changeing":"changing",
    "changng":"changing",
    "charecter":"character",
    "charector":"character",
    "chekc":"check",
    "chnage":"change",
    "cieling":"ceiling",
    "claered":"cleared",
    "cliant":"client",
    "cna":"can",
    "colection":"collection",
    "comanies":"companies",
    "comapnies":"companies",
    "comapny":"company",
    "combintation":"combination",
    "commadn":"command",
    "committy":"committee",
    "comntain":"contain",
    "comntains":"contains",
    "compair":"compare",
    "compleated":"completed",
    "compleatly":"completely",
    "compleatness":"completeness",
    "completly":"completely",
    "completness":"completeness",
    "composate":"composite",
    "comtain":"contain",
    "comtains":"contains",
    "comunicate":"communicate",
    "comunity":"community",
    "condolances":"condolences",
    "conferance":"conference",
    "confirmmation":"confirmation",
    "considerit":"considerate",
    "considerite":"considerate",
    "conspiricy":"conspiracy",
    "consultent":"consultant",
    "convertable":"convertible",
    "cooparate":"cooperate",
    "cooporate":"cooperate",
    "corproation":"corporation",
    "corproations":"corporations",
    "corruptable":"corruptible",
    "cotten":"cotton",
    "couldnt":"couldn't",
    "couldthe":"could the",
    "ctaegory":"category",
    "cusotmer":"customer",
    "cusotmers":"customers",
    "cutsomer":"customer",
    "cutsomers":"customers",
    "danceing":"dancing",
    "dcument":"document",
    "deatils":"details",
    "decisons":"decisions",
    "deptartment":"department",
    "desicion":"decision",
    "desicions":"decisions",
    "desision":"decision",
    "desisions":"decisions",
    "develeoprs":"developers",
    "devellop":"develop",
    "develloped":"developed",
    "develloper":"developer",
    "devellopers":"developers",
    "develloping":"developing",
    "devellopment":"development",
    "devellopments":"developments",
    "devellops":"develop",
    "developements":"developments",
    "developor":"developer",
    "developors":"developers",
    "diaplay":"display",
    "didint":"didn't",
    "didnot":"did not",
    "difefrent":"different",
    "diferences":"differences",
    "differance":"difference",
    "differances":"differences",
    "differant":"different",
    "differemt":"different",
    "directer":"director",
    "directers":"directors",
    "directiosn":"direction",
    "discoverd":"discovered",
    "disign":"design",
    "dispaly":"display",
    "dissonent":"dissonant",
    "distribusion":"distribution",
    "divsion":"division",
    "docuement":"documents",
    "docuemnt":"document",
    "documetn":"document",
    "documnet":"document",
    "documnets":"documents",
    "doese":"does",
    "doimg":"doing",
    "doind":"doing",
    "dollers":"dollars",
    "dont":"don't",
    "driveing":"driving",
    "efort":"effort",
    "eforts":"efforts",
    "ehr":"her",
    "enought":"enough",
    "equivalant":"equivalent",
    "especally":"especially",
    "especialyl":"especially",
    "espesially":"especially",
    "exchagne":"exchange",
    "exchagnes":"exchanges",
    "excitment":"excitement",
    "exhcange":"exchange",
    "exhcanges":"exchanges",
    "experienc":"experience",
    "exprience":"experience",
    "exprienced":"experienced",
    "eyt":"yet",
    "faeture":"feature",
    "faetures":"features",
    "familair":"familiar",
    "familar":"familiar",
    "fammiliar":"familiar",
    "feild":"field",
    "feilds":"fields",
    "finalyl":"finally",
    "follwo":"follow",
    "fora":"for a",
    "forthe":"for the",
    "forwrd":"forward",
    "forwrds":"forwards",
    "fowards":"forwards",
    "freinds":"friends",
    "frmo":"from",
    "fromthe":"from the",
    "furneral":"funeral",
    "fwe":"few",
    "gemeral":"general",
    "geting":"getting",
    "gettin":"getting",
    "gievn":"given",
    "giveing":"giving",
    "gloabl":"global",
    "gruop":"group",
    "gruops":"groups",
    "guidlines":"guidelines",
    "hadbeen":"had been",
    "hapens":"happens",
    "hasbeen":"has been",
    "havebeen":"have been",
    "haveing":"having",
    "hda":"had",
    "hearign":"hearing",
    "herat":"heart",
    "hesaid":"he said",
    "hewas":"he was",
    "hge":"he",
    "hlep":"help",
    "hsa":"has",
    "hsi":"his",
    "hte":"the",
    "htese":"these",
    "httpL":"http:",
    "hwich":"which",
    "idae":"idea",
    "identofy":"identify",
    "ihs":"his",
    "imediate":"immediate",
    "imediatly":"immediately",
    "importent":"important",
    "importnat":"important",
    "impossable":"impossible",
    "improvemnt":"improvement",
    "improvment":"improvement",
    "indecate":"indicate",
    "indenpendence":"independence",
    "indenpendent":"independent",
    "indepedent":"independent",
    "influance":"influence",
    "informatoin":"information",
    "instaleld":"installed",
    "insted":"instead",
    "inteh":"in the",
    "interum":"interim",
    "inthe":"in the",
    "inwhich":"in which",
    "isthe":"is the",
    "itis":"it is",
    "ititial":"initial",
    "itnerest":"interest",
    "itnerested":"interested",
    "itneresting":"interesting",
    "itnerests":"interests",
    "itwas":"it was",
    "jugment":"judgment",
    "knowldge":"knowledge",
    "knwon":"known",
    "konwn":"known",
    "lastyear":"last year",
    "learnign":"learning",
    "librarry":"library",
    "librery":"library",
    "lieutenent":"lieutenant",
    "liev":"live",
    "likly":"likely",
    "litttle":"little",
    "liveing":"living",
    "lookign":"looking",
    "makeing":"making",
    "mantain":"maintain",
    "merchent":"merchant",
    "mesage":"message",
    "mesages":"messages",
    "mispellings":"misspellings",
    "mysefl":"myself",
    "myu":"my",
    "necassarily":"necessarily",
    "necassary":"necessary",
    "negotiaing":"negotiating",
    "nothign":"nothing",
    "nver":"never",
    "nwe":"new",
    "nwo":"now",
    "ocur":"occur",
    "oeprator":"operator",
    "ofits":"of its",
    "ofthe":"of the",
    "ohter":"other",
    "oneof":"one of",
    "onepoint":"one point",
    "onthe":"on the",
    "oppasite":"opposite",
    "opperation":"operation",
    "oppertunity":"opportunity",
    "opposate":"opposite",
    "opposible":"opposable",
    "opposit":"opposite",
    "oppotunities":"opportunities",
    "oppotunity":"opportunity",
    "orginization":"organization",
    "orginized":"organized",
    "otu":"out",
    "outof":"out of",
    "overthe":"over the",
    "owuld":"would",
    "oxident":"oxidant",
    "papaer":"paper",
    "partof":"part of",
    "paymetn":"payment",
    "paymetns":"payments",
    "pciture":"picture",
    "peices":"pieces",
    "peolpe":"people",
    "percentof":"percent of",
    "percentto":"percent to",
    "perminent":"permanent",
    "personalyl":"personally",
    "poeple":"people",
    "porblem":"problem",
    "porblems":"problems",
    "porvide":"provide",
    "postition":"position",
    "potentialy":"potentially",
    "pregnent":"pregnant",
    "presance":"presence",
    "probelms":"problems",
    "psoition":"position",
    "ptogress":"progress",
    "quater":"quarter",
    "quaters":"quarters",
    "quesion":"question",
    "quesions":"questions",
    "questioms":"questions",
    "questiosn":"questions",
    "questoin":"question",
    "quetion":"question",
    "quetions":"questions",
    "receieve":"receive",
    "recomendation":"recommendation",
    "recomendations":"recommendations",
    "reconize":"recognize",
    "reluctent":"reluctant",
    "reommend":"recommend",
    "representativs":"representatives",
    "represetned":"represented",
    "represnt":"represent",
    "reserach":"research",
    "resollution":"resolution",
    "resorces":"resources",
    "respomd":"respond",
    "respomse":"response",
    "responsable":"responsible",
    "restuarant":"restaurant",
    "reult":"result",
    "reveiwing":"reviewing",
    "rumers":"rumors",
    "saidhe":"said he",
    "saidit":"said it",
    "saidthat":"said that",
    "saidthe":"said the",
    "scedule":"schedule",
    "sceduled":"scheduled",
    "sectino":"section",
    "seh":"she",
    "selectoin":"selection",
    "sentance":"sentence",
    "separeate":"separate",
    "sercumstances":"circumstances",
    "shcool":"school",
    "shesaid":"she said",
    "shouldent":"shouldn't",
    "showinf":"showing",
    "signifacnt":"significant",
    "simalar":"similar",
    "simpyl":"simply",
    "sincerly":"sincerely",
    "sitll":"still",
    "soical":"social",
    "somethign":"something",
    "someting":"something",
    "somewaht":"somewhat",
    "somthing":"something",
    "specificaly":"specifically",
    "specificalyl":"specifically",
    "statments":"statements",
    "stnad":"stand",
    "strentgh":"strength",
    "struggel":"struggle",
    "strugle":"struggle",
    "studnet":"student",
    "successfuly":"successfully",
    "successfulyl":"successfully",
    "sufficiant":"sufficient",
    "suppossed":"supposed",
    "talkign":"talking",
    "tecnical":"technical",
    "termoil":"turmoil",
    "tghis":"this",
    "thansk":"thanks",
    "thats":"that's",
    "thatthe":"that the",
    "thecompany":"the company",
    "thefirst":"the first",
    "thegovernment":"the government",
    "thenew":"the new",
    "thesame":"the same",
    "thetwo":"the two",
    "theyll":"they'll",
    "theyve":"they've",
    "thisyear":"this year",
    "tiogether":"together",
    "togehter":"together",
    "tomorow":"tomorrow",
    "tonihgt":"tonight",
    "totaly":"totally",
    "totalyl":"totally",
    "traditionalyl":"traditionally",
    "truley":"truly",
    "tryed":"tried",
    "tthe":"the",
    "udnerstand":"understand",
    "understnad":"understand",
    "unliek":"unlike",
    "unpleasently":"unpleasantly",
    "untilll":"until",
    "usualyl":"usually",
    "virtualyl":"virtually",
    "vulnerible":"vulnerable",
    "werre":"were",
    "wherre":"where",
    "wihch":"which",
    "willbe":"will be",
    "windoes":"windows",
    "witha":"with a",
    "withe":"with",
    "withthe":"with the",
    "woh":"who",
    "wouldbe":"would be",
    "wouldnt":"wouldn't",
    "writting":"writing",
    "wrod":"word",
    "wuould":"would",
    "wya":"way",
    "yoiu":"you",
    "youare":"you are",
    "youve":"you've",
    "yuor":"your",
    "againstt he":"against the",
    "andt he":"and the",
    "aren;t":"aren't",
    "arn't":"aren't",
    "askt he":"ask the",
    "byt he":"by the",
    "can't of been":"can't have been",
    "can;t":"can't",
    "company;s":"company's",
    "coudln't":"couldn't",
    "coudn't":"couldn't",
    "could of been":"could have been",
    "could of had":"could have had",
    "couldn;t":"couldn't",
    "didn;t":"didn't",
    "do'nt":"don't",
    "doe snot":"does not",
    "doens't":"doesn't",
    "doesn;t":"doesn't",
    "don't no":"don't know",
    "don;t":"don't",
    "dosn't":"doesn't",
    "fromt he":"from the",
    "hadn;t":"hadn't",
    "hasn;t":"hasn't",
    "haven;t":"haven't",
    "he;ll":"he'll",
    "here;s":"here's",
    "htp:":"http:",
    "http:":"http://",
    "i snot":"is not",
    "I\"m":"I'm",
    "I;d":"I'd",
    "I;ll":"I'll",
    "iits the":"it's the",
    "int he":"in the",
    "isn;t":"isn't",
    "it snot":"it's not",
    "it' snot":"it's not",
    "it;ll":"it'll",
    "it;s":"it's",
    "its a":"it's a",
    "its the":"it's the",
    "let's him":"lets him",
    "let's it":"lets it",
    "let;s":"let's",
    "may of been":"may have been",
    "may of had":"may have had",
    "might of been":"might have been",
    "might of had":"might have had",
    "must of been":"must have been",
    "must of had":"must have had",
    "oft he":"of the",
    "ont he":"on the",
    "saidt he":"said the",
    "she;ll":"she'll",
    "shoudln't":"shouldn't",
    "should of been":"should have been",
    "should of had":"should have had",
    "shouldn;t":"shouldn't",
    "sot hat":"so that",
    "tellt he":"tell the",
    "thatt he":"that the",
    "their are":"there are",
    "their is":"there is",
    "there's is":"theirs is",
    "they're are":"there are",
    "they're is":"there is",
    "they;l":"they'll",
    "they;ll":"they'll",
    "they;r":"they're",
    "they;re":"they're",
    "they;v":"they've",
    "they;ve":"they've",
    "toldt he":"told the",
    "tot he":"to the",
    "undert he":"under the",
    "wa snot":"was not",
    "we;d":"we'd",
    "we;ll":"we'll",
    "we;re":"we're",
    "we;ve":"we've",
    "wern't":"weren't",
    "what;s":"what's",
    "whent he":"when the",
    "where;s":"where's",
    "whicht he":"which the",
    "who;s":"who's",
    "who;ve":"who've",
    "will of been":"will have been",
    "will of had":"will have had",
    "witht he":"with the",
    "wo'nt":"won't",
    "won;t":"won't",
    "woudln't":"wouldn't",
    "would of been":"would have been",
    "would of had":"would have had",
    "wouldn;t":"wouldn't",
    "you're own":"your own",
    "your my":"you're my",
    "you;d":"you'd",
    "you;re":"you're",
    "your a":"you're a",
    "your an":"you're an",
    "your her":"you're her",
    "your here":"you're here",
    "your his":"you're his",
    "your the":"you're the",
    "your their":"you're their",
    "your your":"you're your",
        "o'reily":"O'Reilly",
    "oreily":"O'Reilly",
    "tristar":"Tri-Star",
    "ot":"to",
    "fo":"of",
    "htat":"that",
    "yoru":"your",
    "tehre":"there",
    "ta":"at",
    "etcetera":"et cetera",
        "arent":"aren't",
    "couldve":"could've",
    "could;ve":"could've",
    "hadnt":"hadn't",
    "havent":"haven't",
    "hed":"he'd",
    "he;d":"he'd",
    "hes":"he's",
    "he;s":"he's",
    "howd":"how'd",
    "how;d":"how'd",
    "howll":"how'll",
    "how;ll":"how'll",
    "hows":"how's",
    "how;s":"how's",
    "Id":"I'd",
    "I;m":"I'm",
    "I;ve":"I've",
    "itd":"it'd",
    "it;d":"it'd",
    "itll":"it'll",
    "maam":"ma'am",
    "ma;am":"ma'am",
    "mightnt":"mightn't",
    "mightn;t":"mightn't",
    "mightve":"might've",
    "might;ve":"might've",
    "mustnt":"mustn't",
    "mustn;t":"mustn't",
    "mustve":"must've",
    "must;ve":"must've",
    "neednt":"needn't",
    "needn;t":"needn't",
    "oclock":"o'clock",
    "o;clock":"o'clock",
    "shant":"shan't",
    "shan;t":"shan't",
    "she;d":"she'd",
    "shes":"she's",
    "she;s":"she's",
    "shouldve":"should've",
    "should;ve":"should've",
    "that;s":"that's",
    "thatll":"that'll",
    "that;ll":"that'll",
    "thatd":"that'd",
    "that;d":"that'd",
    "thered":"there'd",
    "there;d":"there'd",
    "theres":"there's",
    "there;s":"there's",
    "theyd":"they'd",
    "they;d":"they'd",
    "wasn;t":"wasn't",
    "wed":"we'd",
    "weve":"we've",
    "werent":"weren't",
    "weren;t":"weren't",
    "whatll":"what'll",
    "what;ll":"what'll",
    "whatre":"what're",
    "what;re":"what're",
    "whats":"what's",
    "whatve":"what've",
    "what;ve":"what've",
    "whens":"when's",
    "when;s":"when's",
    "whend ":"when'd ",
    "when;d ":"when'd ",
    "whenll":"when'll",
    "when;ll":"when'll",
    "whered":"where'd",
    "where;d":"where'd",
    "wherell":"where'll",
    "where;ll":"where'll",
    "wheres":"where's",
    "whereve":"where've",
    "where;ve":"where've",
    "whod":"who'd",
    "who;d":"who'd",
    "wholl":"who'll",
    "who;ll":"who'll",
    "who;re":"who're",
    "whos":"who's",
    "whove":"who've",
    "whyd":"why'd",
    "why;d":"why'd",
    "whyll":"why'll",
    "why;ll":"why'll",
    "whyre":"why're",
    "why;re":"why're",
    "whys":"why's",
    "why;s":"why's",
    "wont":"won't",
    "wouldve":"would've",
    "would;ve":"would've",
    "youd":"you'd",
    "youll":"you'll",
    "you;ll":"you'll",
    "youre":"you're",
    "you;ve":"you've",
    "ok":"okay",
    "OK":"okay",
    "o.k":"okay",
    "O.k":"okay",
    "yea":"yeah",
    "yepp":"yep",
    "ostracising":"ostracizing",
    "feminising":"feminizing",
    "conceptualised":"conceptualized",
    "accessorised":"accessorized",
    "idealised":"idealized",
    "conceptualises":"conceptualizes",
    "idealises":"idealizes",
    "accessorises":"accessorizes",
    "gaolbreak":"jailbreak",
    "criminalises":"criminalizes",
    "oxidise":"oxidize",
    "secularised":"secularized",
    "humanised":"humanized",
    "breathalysing":"breathalyzing",
    "institutionalised":"institutionalized",
    "characterises":"characterizes",
    "specialising":"specializing",
    "politicising":"politicizing",
    "characterised":"characterized",
    "syphoning":"siphoning",
    "humanises":"humanizes",
    "denationalise":"denationalize",
    "homoeopaths":"homeopaths",
    "appal":"appall",
    "battleaxe":"battleax",
    "homoeopathy":"homeopathy",
    "pummelled":"pummel",
    "precancelation":"precancellation",
    "rancour":"rancor",
    "institutionalises":"institutionalizes",
    "subsidising":"subsidizing",
    "globalising":"globalizing",
    "naturalise":"naturalize",
    "unauthorised":"unauthorized",
    "favoured":"favored",
    "phoney":"phony",
    "calibres":"calibers",
    "catalysed":"catalyzed",
    "bannister":"banister",
    "tenderise":"tenderize",
    "marginalised":"marginalized",
    "colourful":"colorful",
    "catalyses":"catalyzes",
    "faecal":"fecal",
    "minibusses":"minibuses",
    "sulphurous":"sulfurous",
    "socialises":"socializes",
    "sodomised":"sodomized",
    "socialised":"socialized",
    "jeopardising":"jeopardizing",
    "licences":"licenses",
    "specialise":"specialize",
    "ploughed":"plowed",
    "marginalises":"marginalizes",
    "enrol":"enroll",
    "licenced":"licensed",
    "snowploughs":"snowplows",
    "paralysing":"paralyzing",
    "digitises":"digitizes",
    "visualised":"visualized",
    "internationalisation":"internationalization",
    "haemorrhoids":"hemorrhoids",
    "verbalise":"verbalize",
    "flavour":"flavor",
    "visualises":"visualizes",
    "summarising":"summarizing",
    "millimetres":"millimeters",
    "criticise":"criticize",
    "humourless":"humorless",
    "deputising":"deputizing",
    "busses":"buses",
    "archaeological":"archeological",
    "sympathise":"sympathize",
    "compartmentalise":"compartmentalize",
    "remould":"remold",
    "formalised":"formalized",
    "canalises":"canalizes",
    "neighbours":"neighbors",
    "rationalise":"rationalize",
    "formalises":"formalizes",
    "canalised":"canalized",
    "imperilling":"imperiling",
    "tranquillity":"tranquility",
    "discolours":"discolors",
    "moulder":"molder",
    "canalise":"canalize",
    "liquidisers":"liquidizers",
    "moulded":"molded",
    "chequered":"checkered",
    "stigmatise":"stigmatize",
    "italicise":"italicize",
    "jeopardises":"jeopardizes",
    "instals":"installs",
    "jeopardised":"jeopardized",
    "urbanise":"urbanize",
    "immunising":"immunizing",
    "behaviourists":"behaviorists",
    "oesophaguses":"esophaguses",
    "urbanising":"urbanizing",
    "systematised":"systematized",
    "chiselling":"chiseling",
    "moisturisers":"moisturizers",
    "systematises":"systematizes",
    "finalise":"finalize",
    "equalised":"equalized",
    "publicises":"publicizes",
    "utilise":"utilize",
    "publicised":"publicized",
    "compartmentalising":"compartmentalizing",
    "equaliser":"equalizer",
    "equalises":"equalizes",
    "accouterments":"accoutrements",
    "capitalise":"capitalize",
    "endeavoured":"endeavored",
    "gynaecologist":"gynecologist",
    "sterilisation":"sterilization",
    "archaeology":"archeology",
    "foetal":"fetal",
    "woollen":"woolen",
    "epaulettes":"epaulets",
    "demoralises":"demoralizes",
    "greyness":"grayness",
    "clamour":"clamor",
    "paederast":"pederast",
    "vocalised":"vocalized",
    "antagonise":"antagonize",
    "circularise":"circularize",
    "hybridises":"hybridizes",
    "ionised":"ionized",
    "remoulds":"remolds",
    "pasteurising":"pasteurizing",
    "vocalises":"vocalizes",
    "ioniser":"ionizer",
    "ionises":"ionizes",
    "hybridised":"hybridized",
    "smouldering":"smoldering",
    "centimetre":"centimeter",
    "generalised":"generalized",
    "draughtier":"draftier",
    "unionise":"unionize",
    "sentimentalising":"sentimentalizing",
    "centralising":"centralizing",
    "drivelled":"driveled",
    "idealising":"idealizing",
    "colourless":"colorless",
    "sceptre":"scepter",
    "rumour":"rumor",
    "editorialises":"editorializes",
    "collectivised":"collectivized",
    "armoured":"armored",
    "editorialised":"editorialized",
    "armourer":"armorer",
    "collectivises":"collectivizes",
    "hybridising":"hybridizing",
    "spiralling":"spiraling",
    "stabiliser":"stabilizer",
    "stabilises":"stabilizes",
    "extemporisation":"extemporization",
    "practising":"practicing",
    "defences":"defenses",
    "stabilised":"stabilized",
    "internalise":"internalize",
    "idolised":"idolized",
    "multicoloured":"multicolored",
    "idolises":"idolizes",
    "paederasts":"pederasts",
    "generalises":"generalizes",
    "systematisation":"systematization",
    "mesmerises":"mesmerizes",
    "secularise":"secularize",
    "urbanises":"urbanizes",
    "millilitres":"milliliters",
    "urbanised":"urbanized",
    "popularise":"popularize",
    "metabolises":"metabolizes",
    "sterilising":"sterilizing",
    "behaviourist":"behaviorist",
    "metabolised":"metabolized",
    "fibreglass":"fiberglass",
    "behaviourism":"behaviorism",
    "decentralises":"decentralizes",
    "baptises":"baptizes",
    "motorised":"motorized",
    "revolutionise":"revolutionize",
    "vocalisation":"vocalization",
    "serialising":"serializing",
    "baptised":"baptized",
    "enthral":"enthrall",
    "magnetising":"magnetizing",
    "decentralised":"decentralized",
    "praesidium":"presidium",
    "tranquillisers":"tranquilizers",
    "centred":"centered",
    "chimaera":"chimera",
    "palaeontology":"paleontology",
    "initialising":"initializing",
    "enthrals":"enthralls",
    "sulphur":"sulfur",
    "fossilised":"fossilized",
    "regularised":"regularized",
    "yodelling":"yodeling",
    "ploughman":"plowman",
    "fraternisation":"fraternization",
    "glueing":"gluing",
    "milligrammes":"milligrams",
    "exorcise":"exorcize",
    "filleting":"fileting",
    "contextualise":"contextualize",
    "fossilises":"fossilizes",
    "jeopardise":"jeopardize",
    "mitres":"miters",
    "disorganised":"disorganized",
    "customise":"customize",
    "mobilising":"mobilizing",
    "yoghourt":"yogurt",
    "institutionalise":"institutionalize",
    "penalise":"penalize",
    "rationalisation":"rationalization",
    "miniaturise":"miniaturize",
    "signalled":"signaled",
    "mobilised":"mobilized",
    "ploughshare":"plowshare",
    "mobilises":"mobilizes",
    "paralyses":"paralyzes",
    "amphitheatre":"amphitheater",
    "idealisation":"idealization",
    "pzazz":"pizzazz",
    "professionalising":"professionalizing",
    "analogue":"analog",
    "groyne":"groin",
    "draughtsman":"draftsman",
    "satirising":"satirizing",
    "deodorises":"deodorizes",
    "bevelled":"beveled",
    "belaboured":"belabored",
    "traumatising":"traumatizing",
    "aetiology":"etiology",
    "tantalising":"tantalizing",
    "humanise":"humanize",
    "paedophiles":"pedophiles",
    "liberalising":"liberalizing",
    "scandalises":"scandalizes",
    "pedestrianising":"pedestrianizing",
    "commercialised":"commercialized",
    "memorialising":"memorializing",
    "vandalised":"vandalized",
    "theorising":"theorizing",
    "hospitalising":"hospitalizing",
    "commercialises":"commercializes",
    "vandalises":"vandalizes",
    "palaeolithic":"paleolithic",
    "cruellest":"cruelest",
    "globalise":"globalize",
    "homoeopathic":"homeopathic",
    "liquidises":"liquidizes",
    "liquidiser":"liquidizer",
    "catalogue":"catalog",
    "liquidised":"liquidized",
    "philosophised":"philosophized",
    "visualise":"visualize",
    "favourably":"favorably",
    "philosophises":"philosophizes",
    "travellers":"travelers",
    "fraternise":"fraternize",
    "moisturises":"moisturizes",
    "civilised":"civilized",
    "sanitise":"sanitize",
    "sympathises":"sympathizes",
    "civilises":"civilizes",
    "moisturised":"moisturized",
    "agonise":"agonize",
    "sympathised":"sympathized",
    "sodomise":"sodomize",
    "minimises":"minimizes",
    "honouring":"honoring",
    "archaeologically":"archeologically",
    "minimised":"minimized",
    "succours":"succors",
    "organisational":"organizational",
    "memorise":"memorize",
    "flavourless":"flavorless",
    "destabilised":"destabilized",
    "recognises":"recognizes",
    "criticised":"criticized",
    "dehumanises":"dehumanizes",
    "recognised":"recognized",
    "destabilises":"destabilizes",
    "dehumanised":"dehumanized",
    "criticises":"criticizes",
    "appetisingly":"appetizingly",
    "criminalised":"criminalized",
    "harboured":"harbored",
    "armoury":"armory",
    "anaesthetists":"anesthetists",
    "encyclopaedic":"encyclopedic",
    "encyclopaedia":"encyclopedia",
    "demonises":"demonizes",
    "demobilising":"demobilizing",
    "organisers":"organizers",
    "mesmerising":"mesmerizing",
    "demonised":"demonized",
    "aeroplane":"airplane",
    "mechanising":"mechanizing",
    "baulked":"balked",
    "signalising":"signalizing",
    "crueller":"crueler",
    "unravelled":"unraveled",
    "propagandised":"propagandized",
    "manoeuvring":"maneuvering",
    "propagandises":"propagandizes",
    "splendour":"splendor",
    "demoralise":"demoralize",
    "serialisation":"serialization",
    "unsavoury":"unsavory",
    "authorise":"authorize",
    "snivelling":"sniveling",
    "emphasise":"emphasize",
    "internationalising":"internationalizing",
    "watercolours":"watercolors",
    "nationalisation":"nationalization",
    "ravelled":"raveled",
    "paediatrician":"pediatrician",
    "homoeopath":"homeopath",
    "tunnelling":"tunneling",
    "paralysed":"paralyzed",
    "armourers":"armorers",
    "digitised":"digitized",
    "centres":"centers",
    "centigrammes":"centigrams",
    "penalises":"penalizes",
    "gaolers":"jailers",
    "passivising":"passivizing",
    "sermonises":"sermonizes",
    "prioritising":"prioritizing",
    "feminised":"feminized",
    "greys":"grays",
    "sermonised":"sermonized",
    "harmonise":"harmonize",
    "lustre":"luster",
    "deodorised":"deodorized",
    "exorcises":"exorcizes",
    "watercolour":"watercolor",
    "initialise":"initialize",
    "anglicising":"anglicizing",
    "exorcised":"exorcized",
    "realisations":"realizations",
    "cosies":"cozies",
    "cosier":"cozier",
    "caramelise":"caramelize",
    "belabour":"belabor",
    "haemoglobin":"hemoglobin",
    "parcelled":"parceled",
    "scrutinised":"scrutinized",
    "cancelled":"canceled",
    "odours":"odors",
    "scrutinises":"scrutinizes",
    "goitres":"goiters",
    "pedestrianisation":"pedestrianization",
    "destabilising":"destabilizing",
    "esthetics":"aesthetics",
    "honoured":"honored",
    "shrivelled":"shriveled",
    "sensitising":"sensitizing",
    "millilitre":"milliliter",
    "sensationalise":"sensationalize",
    "moralises":"moralizes",
    "moralised":"moralized",
    "yodelled":"yodeled",
    "gryphons":"griffins",
    "tyres":"tires",
    "sulphides":"sulfides",
    "neutralising":"neutralizing",
    "rationalisations":"rationalizations",
    "miniaturisation":"miniaturization",
    "energises":"energizes",
    "factorising":"factorizing",
    "libellous":"libelous",
    "unrecognisable":"unrecognizable",
    "energised":"energized",
    "ghettoised":"ghettoized",
    "internalisation":"internalization",
    "gaoling":"jailing",
    "travelogues":"travelogs",
    "philtre":"filter",
    "saltpetre":"saltpeter",
    "reconnoitring":"reconnoitering",
    "bedevilling":"bedeviling",
    "metabolise":"metabolize",
    "ghettoises":"ghettoizes",
    "belabours":"belabors",
    "manoeuvred":"maneuvered",
    "catalyse":"catalyze",
    "manoeuvrable":"maneuverable",
    "analyse":"analyze",
    "centilitres":"centiliters",
    "manoeuvres":"maneuvers",
    "anaesthetic":"anesthetic",
    "colourants":"colorants",
    "conceptualising":"conceptualizing",
    "normalising":"normalizing",
    "individualised":"individualized",
    "remoulding":"remolding",
    "nationalising":"nationalizing",
    "individualises":"individualizes",
    "paediatrics":"pediatrics",
    "tonne":"ton",
    "flavoursome":"flavorsome",
    "unravelling":"unraveling",
    "meagre":"meager",
    "regularisation":"regularization",
    "liberalise":"liberalize",
    "polarisation":"polarization",
    "unorganised":"unorganized",
    "familiarised":"familiarized",
    "oestrogen":"estrogen",
    "familiarises":"familiarizes",
    "outmanoeuvre":"outmaneuver",
    "mediaeval":"medieval",
    "ritualised":"ritualized",
    "vaporising":"vaporizing",
    "sabres":"sabers",
    "discolouring":"discoloring",
    "stigmatisation":"stigmatization",
    "anaesthetises":"anesthetizes",
    "moustaches":"mustaches",
    "esthete":"aesthete",
    "moustached":"mustached",
    "demoralising":"demoralizing",
    "characterising":"characterizing",
    "calibre":"caliber",
    "crystallise":"crystallize",
    "psychoanalysing":"psychoanalyzing",
    "dehumanise":"dehumanize",
    "rationalises":"rationalizes",
    "gambolled":"gamboled",
    "rationalised":"rationalized",
    "privatisations":"privatizations",
    "summarises":"summarizes",
    "idealise":"idealize",
    "ionise":"ionize",
    "pencilled":"penciled",
    "synchronisation":"synchronization",
    "summarised":"summarized",
    "sceptical":"skeptical",
    "internationalises":"internationalizes",
    "colourizes":"colorizes",
    "mobilise":"mobilize",
    "radicalised":"radicalized",
    "internationalised":"internationalized",
    "colourized":"colorized",
    "homogenise":"homogenize",
    "cannibalising":"cannibalizing",
    "sterilise":"sterilize",
    "anaesthetise":"anesthetize",
    "vulgarises":"vulgarizes",
    "desensitising":"desensitizing",
    "anaesthetist":"anesthetist",
    "diarrhoea":"diarrhea",
    "waggon":"wagon",
    "hospitalises":"hospitalizes",
    "generalisations":"generalizations",
    "hospitalised":"hospitalized",
    "radicalises":"radicalizes",
    "professionalise":"professionalize",
    "cosy":"cozy",
    "swivelled":"swiveled",
    "draughtiest":"draftiest",
    "demobilisation":"demobilization",
    "favour":"favor",
    "bowdlerises":"bowdlerizes",
    "amortising":"amortizing",
    "bowdlerised":"bowdlerized",
    "externalisations":"externalizations",
    "honour":"honor",
    "gaolbirds":"jailbirds",
    "editorialising":"editorializing",
    "philosophising":"philosophizing",
    "magnetise":"magnetize",
    "odour":"odor",
    "ravelling":"raveling",
    "gryphon":"griffin",
    "maximising":"maximizing",
    "enrols":"enrolls",
    "eulogise":"eulogize",
    "humour":"humor",
    "customises":"customizes",
    "breathalysers":"breathalyzers",
    "customised":"customized",
    "humouring":"humoring",
    "instal":"install",
    "sensitise":"sensitize",
    "remodelled":"remodeled",
    "glamorised":"glamorized",
    "destabilisation":"destabilization",
    "vigour":"vigor",
    "glamorises":"glamorizes",
    "particularising":"particularizing",
    "untrammelled":"untrammeled",
    "snorkelling":"snorkeling",
    "maximise":"maximize",
    "sensitises":"sensitizes",
    "pretences":"pretenses",
    "archaeologists":"archeologists",
    "marginalisation":"marginalization",
    "emphasising":"emphasizing",
    "modernised":"modernized",
    "socialisation":"socialization",
    "immunise":"immunize",
    "visualisations":"visualizations",
    "moulted":"molted",
    "modernises":"modernizes",
    "extemporising":"extemporizing",
    "fantasised":"fantasized",
    "romanticise":"romanticize",
    "paediatricians":"pediatricians",
    "plagiarising":"plagiarizing",
    "litre":"liter",
    "cavilling":"caviling",
    "civilise":"civilize",
    "systematising":"systematizing",
    "recognisance":"recognizance",
    "proselytising":"proselytizing",
    "carbonises":"carbonizes",
    "depersonalises":"depersonalizes",
    "toxaemia":"toxemia",
    "liberalisation":"liberalization",
    "neighbourliness":"neighborliness",
    "depersonalised":"depersonalized",
    "carbonised":"carbonized",
    "anglicise":"anglicize",
    "generalise":"generalize",
    "waggons":"wagons",
    "passivise":"passivize",
    "pulverised":"pulverized",
    "dishonoured":"dishonored",
    "patronise":"patronize",
    "uncivilised":"uncivilized",
    "pulverises":"pulverizes",
    "sensationalising":"sensationalizing",
    "maximisation":"maximization",
    "neighbourhoods":"neighborhoods",
    "counsellor":"counselor",
    "itemise":"itemize",
    "quarrelled":"quarreled",
    "moralise":"moralize",
    "savoury":"savory",
    "rumoured":"rumored",
    "organisation":"organization",
    "epitomise":"epitomize",
    "councillor":"councilor",
    "odourless":"odorless",
    "idolise":"idolize",
    "discoloured":"discolored",
    "fictionalise":"fictionalize",
    "clamoured":"clamored",
    "hypothesise":"hypothesize",
    "externalise":"externalize",
    "realise":"realize",
    "lionise":"lionize",
    "ostracises":"ostracizes",
    "sulphates":"sulfates",
    "haematological":"hematological",
    "ostracised":"ostracized",
    "colourize":"colorize",
    "neighbourhood":"neighborhood",
    "moisturising":"moisturizing",
    "monopolisation":"monopolization",
    "agonises":"agonizes",
    "immobilisation":"immobilization",
    "agonised":"agonized",
    "esthetes":"aesthetes",
    "encyclopaedias":"encyclopedias",
    "penalising":"penalizing",
    "aerogrammes":"aerograms",
    "worshipper":"worshiper",
    "cannibalised":"cannibalized",
    "industrialises":"industrializes",
    "apologising":"apologizing",
    "industrialised":"industrialized",
    "cannibalises":"cannibalizes",
    "crystallisation":"crystallization",
    "canalising":"canalizing",
    "biassing":"biasing",
    "spiralled":"spiraled",
    "unionising":"unionizing",
    "anaesthetising":"anesthetizing",
    "agonising":"agonizing",
    "professionalises":"professionalizes",
    "dramatised":"dramatized",
    "squirrelled":"squirreled",
    "modernise":"modernize",
    "reorganising":"reorganizing",
    "immortalises":"immortalizes",
    "gaolbird":"jailbird",
    "dramatises":"dramatizes",
    "professionalised":"professionalized",
    "immortalised":"immortalized",
    "savouries":"savories",
    "cosiest":"coziest",
    "clamouring":"clamoring",
    "optimise":"optimize",
    "grammes":"grams",
    "victimising":"victimizing",
    "modelled":"modeled",
    "standardises":"standardizes",
    "distils":"distills",
    "fertilisation":"fertilization",
    "modeller":"modeler",
    "disorganisation":"disorganization",
    "scandalised":"scandalized",
    "homogenising":"homogenizing",
    "miniaturises":"miniaturizes",
    "denationalised":"denationalized",
    "miniaturised":"miniaturized",
    "clarinettists":"clarinetists",
    "denationalises":"denationalizes",
    "palaeontologist":"paleontologist",
    "sanitising":"sanitizing",
    "edoema":"edema",
    "authorising":"authorizing",
    "tasselled":"tasseled",
    "theatre":"theater",
    "temporises":"temporizes",
    "temporised":"temporized",
    "amortise":"amortize",
    "lionising":"lionizing",
    "greyish":"grayish",
    "formalising":"formalizing",
    "depersonalising":"depersonalizing",
    "pharmacopoeias":"pharmacopeias",
    "axe":"ax",
    "centrefold":"centerfold",
    "propagandise":"propagandize",
    "vulgarised":"vulgarized",
    "marshalled":"marshaled",
    "amortisation":"amortization",
    "arbour":"arbor",
    "fervour":"fervor",
    "stencilling":"stenciling",
    "chiselled":"chiseled",
    "demonising":"demonizing",
    "solemnised":"solemnized",
    "fibre":"fiber",
    "sterilised":"sterilized",
    "swivelling":"swiveling",
    "manoeuvre":"maneuver",
    "armouries":"armories",
    "sterilises":"sterilizes",
    "steriliser":"sterilizer",
    "belabouring":"belaboring",
    "dishonourable":"dishonorable",
    "arbours":"arbors",
    "anaesthetics":"anesthetics",
    "bougainvillaea":"bougainvillea",
    "savours":"savors",
    "circularising":"circularizing",
    "honours":"honors",
    "dishonourably":"dishonorably",
    "mouldings":"moldings",
    "immunisation":"immunization",
    "miniaturising":"miniaturizing",
    "democratises":"democratizes",
    "signalise":"signalize",
    "immobilising":"immobilizing",
    "ploughmen":"plowmen",
    "democratised":"democratized",
    "neutralise":"neutralize",
    "stabilisers":"stabilizers",
    "proselytiser":"proselytizer",
    "homogenises":"homogenizes",
    "behoves":"behooves",
    "behoved":"behooved",
    "homogenised":"homogenized",
    "harmonised":"harmonized",
    "immortalising":"immortalizing",
    "recognisably":"recognizably",
    "sodomising":"sodomizing",
    "colours":"colors",
    "recognisable":"recognizable",
    "harmonises":"harmonizes",
    "solemnises":"solemnizes",
    "woollies":"woolies",
    "draughtsmanship":"draftsmanship",
    "mouldier":"moldier",
    "centralise":"centralize",
    "rumours":"rumors",
    "militarises":"militarizes",
    "foetus":"fetus",
    "centrepieces":"centerpieces",
    "scrutinise":"scrutinize",
    "militarised":"militarized",
    "victimises":"victimizes",
    "nationalises":"nationalizes",
    "nationalised":"nationalized",
    "rivalled":"rivaled",
    "stigmatising":"stigmatizing",
    "generalisation":"generalization",
    "harbouring":"harboring",
    "tricolours":"tricolors",
    "theorises":"theorizes",
    "centralises":"centralizes",
    "vulgarising":"vulgarizing",
    "pencilling":"penciling",
    "palaeontologists":"paleontologists",
    "centralised":"centralized",
    "theorised":"theorized",
    "centrepiece":"centerpiece",
    "millimetre":"millimeter",
    "practises":"practices",
    "sensationalised":"sensationalized",
    "sensationalises":"sensationalizes",
    "practised":"practiced",
    "categorising":"categorizing",
    "synthesises":"synthesizes",
    "chimaeras":"chimeras",
    "sentimentalised":"sentimentalized",
    "oxidising":"oxidizing",
    "acclimatises":"acclimatizes",
    "decriminalising":"decriminalizing",
    "paedophilia":"pedophilia",
    "sentimentalises":"sentimentalizes",
    "cancelations":"cancellations",
    "serialisations":"serializations",
    "theatregoers":"theatergoers",
    "acclimatised":"acclimatized",
    "serialise":"serialize",
    "apologised":"apologized",
    "demilitarises":"demilitarizes",
    "pretence":"pretense",
    "syphoned":"siphoned",
    "civilising":"civilizing",
    "apologises":"apologizes",
    "bowdlerise":"bowdlerize",
    "decriminalisation":"decriminalization",
    "demilitarised":"demilitarized",
    "discolour":"discolor",
    "aluminium":"aluminum",
    "systematise":"systematize",
    "memorialise":"memorialize",
    "centrefolds":"centerfolds",
    "litres":"liters",
    "funnelled":"funneled",
    "micrometres":"micrometers",
    "bastardises":"bastardizes",
    "immobilises":"immobilizes",
    "immobiliser":"immobilizer",
    "mouldered":"moldered",
    "dialled":"dialed",
    "mouldering":"moldering",
    "parlours":"parlors",
    "immobilised":"immobilized",
    "bastardised":"bastardized",
    "vandalise":"vandalize",
    "fraternises":"fraternizes",
    "legitimises":"legitimizes",
    "vocalise":"vocalize",
    "fraternised":"fraternized",
    "pummelling":"pummeled",
    "legitimised":"legitimized",
    "omelette":"omelet",
    "politicisation":"politicization",
    "synthesiser":"synthesizer",
    "draughtswomen":"draftswomen",
    "aerogramme":"aerogram",
    "remodelling":"remodeling",
    "synthesised":"synthesized",
    "womanising":"womanizing",
    "connexions":"connections",
    "criminalise":"criminalize",
    "circularised":"circularized",
    "armour":"armor",
    "plagiarised":"plagiarized",
    "callisthenics":"calisthenics",
    "internalising":"internalizing",
    "behavioural":"behavioral",
    "colonise":"colonize",
    "plagiarises":"plagiarizes",
    "circularises":"circularizes",
    "individualising":"individualizing",
    "authorised":"authorized",
    "dramatisation":"dramatization",
    "feminise":"feminize",
    "aeroplanes":"airplanes",
    "cauterising":"cauterizing",
    "offence":"offense",
    "symbolise":"symbolize",
    "standardise":"standardize",
    "romanticising":"romanticizing",
    "pressurisation":"pressurization",
    "legalised":"legalized",
    "penalised":"penalized",
    "neutralisation":"neutralization",
    "harmonising":"harmonizing",
    "institutionalisation":"institutionalization",
    "disfavour":"disfavor",
    "legalises":"legalizes",
    "travelogue":"travelog",
    "smouldered":"smoldered",
    "westernising":"westernizing",
    "fulfil":"fulfill",
    "jewellery":"jewelry",
    "jewellers":"jewelers",
    "neutralised":"neutralized",
    "videodisc":"videodisk",
    "amortisable":"amortizable",
    "crystallised":"crystallized",
    "neutralises":"neutralizes",
    "moulders":"molders",
    "solemnise":"solemnize",
    "formalisation":"formalization",
    "defenceless":"defenseless",
    "decentralise":"decentralize",
    "liquidising":"liquidizing",
    "psychoanalysed":"psychoanalyzed",
    "tumour":"tumor",
    "patronising":"patronizing",
    "aeon":"eon",
    "vandalising":"vandalizing",
    "localise":"localize",
    "proselytisers":"proselytizers",
    "hypnotise":"hypnotize",
    "sympathiser":"sympathizer",
    "councillors":"councilors",
    "stabilisation":"stabilization",
    "parcelling":"parceling",
    "libelling":"libeling",
    "eulogises":"eulogizes",
    "trivialises":"trivializes",
    "decentralising":"decentralizing",
    "endeavouring":"endeavoring",
    "normalised":"normalized",
    "tantalisingly":"tantalizingly",
    "trivialised":"trivialized",
    "oesophagus":"esophagus",
    "fertilise":"fertilize",
    "labelling":"labeling",
    "normalises":"normalizes",
    "pasteurisation":"pasteurization",
    "oxidised":"oxidized",
    "westernisation":"westernization",
    "minimise":"minimize",
    "synthesise":"synthesize",
    "oxidises":"oxidizes",
    "fictionalises":"fictionalizes",
    "vulgarisation":"vulgarization",
    "panelled":"paneled",
    "tantalises":"tantalizes",
    "victimisation":"victimization",
    "tantalised":"tantalized",
    "computerising":"computerizing",
    "empathises":"empathizes",
    "demonise":"demonize",
    "accouter":"accoutre",
    "hypothesises":"hypothesizes",
    "legalising":"legalizing",
    "immobilise":"immobilize",
    "organised":"organized",
    "synchronised":"synchronized",
    "marvellously":"marvelously",
    "splendours":"splendors",
    "itemised":"itemized",
    "towelling":"toweling",
    "biassed":"biased",
    "initialled":"initialed",
    "initialling":"initialing",
    "epicentres":"epicenters",
    "gaols":"jails",
    "esthetic":"aesthetic",
    "carolled":"caroled",
    "utilises":"utilizes",
    "dishonour":"dishonor",
    "epitomising":"epitomizing",
    "recognise":"recognize",
    "realising":"realizing",
    "caramelising":"caramelizing",
    "clangour":"clangor",
    "personalising":"personalizing",
    "recognising":"recognizing",
    "signalling":"signaling",
    "editorialise":"editorialize",
    "levelling":"leveling",
    "bejewelled":"bejeweled",
    "revellers":"revelers",
    "unionisation":"unionization",
    "legitimise":"legitimize",
    "panellists":"panelists",
    "tranquillising":"tranquilizing",
    "sceptically":"skeptically",
    "dehumanising":"dehumanizing",
    "specialised":"specialized",
    "regularise":"regularize",
    "popularisation":"popularization",
    "coloured":"colored",
    "antagonised":"antagonized",
    "marvellous":"marvelous",
    "ageing":"aging",
    "caesareans":"cesareans",
    "legalisation":"legalization",
    "antagonises":"antagonizes",
    "bastardising":"bastardizing",
    "programme":"program",
    "honourably":"honorably",
    "mesmerised":"mesmerized",
    "idolising":"idolizing",
    "honourable":"honorable",
    "crystallises":"crystallizes",
    "paralyse":"paralyze",
    "defence":"defense",
    "proselytise":"proselytize",
    "cudgelled":"cudgeled",
    "specialises":"specializes",
    "outmanoeuvred":"outmaneuvered",
    "dramatise":"dramatize",
    "behaviour":"behavior",
    "favourable":"favorable",
    "deodorise":"deodorize",
    "outmanoeuvres":"outmaneuvers",
    "acclimatising":"acclimatizing",
    "familiarising":"familiarizing",
    "cancellable":"cancelable",
    "coloureds":"coloreds",
    "mouldy":"moldy",
    "haematologists":"hematologists",
    "moulds":"molds",
    "computerise":"computerize",
    "haemophilia":"hemophilia",
    "reveller":"reveler",
    "synthesisers":"synthesizers",
    "stabilising":"stabilizing",
    "utilisation":"utilization",
    "almanacks":"almanacs",
    "revelled":"reveled",
    "baulks":"balks",
    "epaulette":"epaulet",
    "flavouring":"flavoring",
    "theorise":"theorize",
    "colonisers":"colonizers",
    "theatregoer":"theatergoer",
    "cannibalise":"cannibalize",
    "ploughshares":"plowshares",
    "draughts":"drafts",
    "democratisation":"democratization",
    "draughty":"drafty",
    "plagiarise":"plagiarize",
    "solemnising":"solemnizing",
    "revitalising":"revitalizing",
    "sulphide":"sulfide",
    "vapours":"vapors",
    "dialling":"dialing",
    "haemorrhaging":"hemorrhaging",
    "subsidisation":"subsidization",
    "itemising":"itemizing",
    "sympathisers":"sympathizers",
    "publicise":"publicize",
    "demoralisation":"demoralization",
    "cosily":"cozily",
    "ploughs":"plows",
    "secularising":"secularizing",
    "gaolbreaks":"jailbreaks",
    "revitalise":"revitalize",
    "mould":"mold",
    "epitomised":"epitomized",
    "denationalisation":"denationalization",
    "haematologist":"hematologist",
    "baulking":"balking",
    "breathalysed":"breathalyzed",
    "moult":"molt",
    "epitomises":"epitomizes",
    "amortised":"amortized",
    "breathalyser":"breathalyzer",
    "breathalyses":"breathalyzes",
    "randomised":"randomized",
    "womanise":"womanize",
    "amortisations":"amortizations",
    "spectre":"specter",
    "randomises":"randomizes",
    "snivelled":"sniveled",
    "baptising":"baptizing",
    "hypnotising":"hypnotizing",
    "backpedalled":"backpedaled",
    "proselytised":"proselytized",
    "proselytises":"proselytizes",
    "aggrandisement":"aggrandizement",
    "labours":"labors",
    "rhapsodise":"rhapsodize",
    "travelling":"traveling",
    "micrometre":"micrometer",
    "revolutionises":"revolutionizes",
    "sulphate":"sulfate",
    "overemphasise":"overemphasize",
    "reconnoitres":"reconnoiters",
    "tyrannise":"tyrannize",
    "impanelling":"impaneling",
    "reconnoitred":"reconnoitered",
    "empathising":"empathizing",
    "sermonising":"sermonizing",
    "initialised":"initialized",
    "catalogues":"catalogs",
    "synchronises":"synchronizes",
    "organises":"organizes",
    "organiser":"organizer",
    "initialises":"initializes",
    "fertilisers":"fertilizers",
    "fictionalised":"fictionalized",
    "familiarisation":"familiarization",
    "catalogued":"cataloged",
    "reorganises":"reorganizes",
    "callipers":"calipers",
    "reorganised":"reorganized",
    "candour":"candor",
    "revolutionised":"revolutionized",
    "cudgelling":"cudgeling",
    "breathalyse":"breathalyze",
    "primaeval":"primeval",
    "ionisation":"ionization",
    "stigmatises":"stigmatizes",
    "colonises":"colonizes",
    "coloniser":"colonizer",
    "stigmatised":"stigmatized",
    "organising":"organizing",
    "colonised":"colonized",
    "secularises":"secularizes",
    "panellist":"panelist",
    "tenderising":"tenderizing",
    "amortises":"amortizes",
    "sheikh":"sheik",
    "polarise":"polarize",
    "licencing":"licensing",
    "intellectualise":"intellectualize",
    "harbours":"harbors",
    "symbolised":"symbolized",
    "symbolises":"symbolizes",
    "fantasising":"fantasizing",
    "subsidise":"subsidize",
    "succoured":"succored",
    "vaporises":"vaporizes",
    "hypothesising":"hypothesizing",
    "standardising":"standardizing",
    "vaporised":"vaporized",
    "tyrannising":"tyrannizing",
    "deputise":"deputize",
    "realises":"realizes",
    "traumatise":"traumatize",
    "reorganisations":"reorganizations",
    "gruelling":"grueling",
    "subsidisers":"subsidizers",
    "revelling":"reveling",
    "contextualised":"contextualized",
    "fossilising":"fossilizing",
    "organisations":"organizations",
    "draughtboards":"draftboards",
    "reorganisation":"reorganization",
    "contextualises":"contextualizes",
    "louvred":"louvered",
    "evangelised":"evangelized",
    "evangelises":"evangelizes",
    "hospitalise":"hospitalize",
    "louvres":"louvers",
    "towelled":"toweled",
    "anglicises":"anglicizes",
    "popularising":"popularizing",
    "foetid":"fetid",
    "snorkelled":"snorkeled",
    "yoghourts":"yogurts",
    "anglicised":"anglicized",
    "trialling":"trialing",
    "artefacts":"artifacts",
    "naturalising":"naturalizing",
    "smoulder":"smolder",
    "generalising":"generalizing",
    "personalised":"personalized",
    "serialises":"serializes",
    "sentimentalise":"sentimentalize",
    "womanised":"womanized",
    "monopolise":"monopolize",
    "ionisers":"ionizers",
    "satirises":"satirizes",
    "metabolising":"metabolizing",
    "womaniser":"womanizer",
    "womanises":"womanizes",
    "fillet":"filet",
    "personalise":"personalize",
    "canonising":"canonizing",
    "satirised":"satirized",
    "esthetically":"aesthetically",
    "moulting":"molting",
    "criticising":"criticizing",
    "extemporise":"extemporize",
    "politicises":"politicizes",
    "militarising":"militarizing",
    "vulgarise":"vulgarize",
    "sanitises":"sanitizes",
    "milligramme":"milligram",
    "reorganise":"reorganize",
    "politicised":"politicized",
    "sepulchres":"sepulchers",
    "duelled":"dueled",
    "sanitised":"sanitized",
    "temporise":"temporize",
    "tunnelled":"tunneled",
    "impanelled":"impaneled",
    "pressurising":"pressurizing",
    "goitre":"goiter",
    "standardised":"standardized",
    "randomising":"randomizing",
    "standardisation":"standardization",
    "archaeologist":"archeologist",
    "woollens":"woolens",
    "haemophiliac":"hemophiliac",
    "vulcanised":"vulcanized",
    "grey":"gray",
    "flavours":"flavors",
    "internationalise":"internationalize",
    "aeons":"eons",
    "remoulded":"remolded",
    "cancelling":"canceling",
    "drivelling":"driveling",
    "internalises":"internalizes",
    "moults":"molts",
    "analogues":"analogs",
    "internalised":"internalized",
    "dehumanisation":"dehumanization",
    "regularises":"regularizes",
    "technicolour":"technicolor",
    "trivialise":"trivialize",
    "rivalling":"rivaling",
    "humoured":"humored",
    "oxidisation":"oxidization",
    "favouring":"favoring",
    "psychoanalyse":"psychoanalyze",
    "subsidised":"subsidized",
    "cataloguing":"cataloging",
    "harbour":"harbor",
    "fibres":"fibers",
    "connexion":"connection",
    "subsidiser":"subsidizer",
    "publicising":"publicizing",
    "personalises":"personalizes",
    "instalment":"installment",
    "appals":"appalls",
    "organise":"organize",
    "magnetises":"magnetizes",
    "counselling":"counseling",
    "fillets":"filets",
    "modelling":"modeling",
    "magnetised":"magnetized",
    "orthopaedics":"orthopedics",
    "symbolising":"symbolizing",
    "lionises":"lionizes",
    "compartmentalised":"compartmentalized",
    "lionised":"lionized",
    "rigour":"rigor",
    "compartmentalises":"compartmentalizes",
    "socialise":"socialize",
    "moustache":"mustache",
    "sombre":"somber",
    "omelettes":"omelets",
    "marginalise":"marginalize",
    "rationalising":"rationalizing",
    "smoulders":"smolders",
    "lacklustre":"lackluster",
    "pyjamas":"pajamas",
    "anaesthesia":"anesthesia",
    "desensitised":"desensitized",
    "misdemeanour":"misdemeanor",
    "liberalises":"liberalizes",
    "kilogramme":"kilogram",
    "pouffe":"pouf",
    "greyed":"grayed",
    "dishonouring":"dishonoring",
    "liberalised":"liberalized",
    "desensitises":"desensitizes",
    "brutalised":"brutalized",
    "grovelled":"groveled",
    "signalised":"signalized",
    "fulfilment":"fulfillment",
    "signalises":"signalizes",
    "ardour":"ardor",
    "brutalises":"brutalizes",
    "prioritised":"prioritized",
    "globalised":"globalized",
    "panelling":"paneling",
    "contextualising":"contextualizing",
    "mesmerise":"mesmerize",
    "naturalised":"naturalized",
    "globalises":"globalizes",
    "prioritises":"prioritizes",
    "theatres":"theaters",
    "trivialising":"trivializing",
    "ionising":"ionizing",
    "stencilled":"stenciled",
    "endeavour":"endeavor",
    "marshalling":"marshaling",
    "unionised":"unionized",
    "collectivise":"collectivize",
    "terrorising":"terrorizing",
    "unionises":"unionizes",
    "galvanising":"galvanizing",
    "behove":"behoove",
    "centigramme":"centigram",
    "brutalise":"brutalize",
    "likeable":"likable",
    "labour":"labor",
    "feminises":"feminizes",
    "synthesising":"synthesizing",
    "dramatisations":"dramatizations",
    "cavilled":"caviled",
    "squirrelling":"squirreling",
    "characterise":"characterize",
    "dramatising":"dramatizing",
    "judgement":"judgment",
    "reconnoitre":"reconnoiter",
    "appetiser":"appetizer",
    "vapour":"vapor",
    "gynaecology":"gynecology",
    "almanack":"almanac",
    "particularise":"particularize",
    "summarise":"summarize",
    "channelled":"channeled",
    "radicalise":"radicalize",
    "bevvies":"bevies",
    "lionisation":"lionization",
    "pedalled":"pedaled",
    "metres":"meters",
    "criminalising":"criminalizing",
    "glamorise":"glamorize",
    "amphitheatres":"amphitheaters",
    "carbonising":"carbonizing",
    "transistorised":"transistorized",
    "equalisers":"equalizers",
    "privatises":"privatizes",
    "paedophile":"pedophile",
    "pulverising":"pulverizing",
    "evangelising":"evangelizing",
    "analysing":"analyzing",
    "greying":"graying",
    "leukaemia":"leukemia",
    "evangelise":"evangelize",
    "draughtswoman":"draftswoman",
    "secularisation":"secularization",
    "gonorrhoea":"gonorrhea",
    "italicising":"italicizing",
    "legalise":"legalize",
    "libelled":"libeled",
    "gramme":"gram",
    "realisation":"realization",
    "mobilisation":"mobilization",
    "desensitisation":"desensitization",
    "privatised":"privatized",
    "worshipped":"worshiped",
    "scandalising":"scandalizing",
    "manoeuvrings":"maneuverings",
    "fraternising":"fraternizing",
    "desensitise":"desensitize",
    "instalments":"installments",
    "patronises":"patronizes",
    "patronised":"patronized",
    "syphon":"siphon",
    "maximised":"maximized",
    "misbehaviour":"misbehavior",
    "polarises":"polarizes",
    "commercialise":"commercialize",
    "savoured":"savored",
    "maximises":"maximizes",
    "haematology":"hematology",
    "polarised":"polarized",
    "canonise":"canonize",
    "gynaecological":"gynecological",
    "formalise":"formalize",
    "nationalise":"nationalize",
    "demilitarisation":"demilitarization",
    "manoeuvrability":"maneuverability",
    "computerises":"computerizes",
    "fictionalisations":"fictionalizations",
    "bannisters":"banisters",
    "clamours":"clamors",
    "computerised":"computerized",
    "faeces":"feces",
    "antagonising":"antagonizing",
    "realisable":"realizable",
    "favourite":"favorite",
    "galvanised":"galvanized",
    "bowdlerising":"bowdlerizing",
    "galvanises":"galvanizes",
    "propagandising":"propagandizing",
    "utilised":"utilized",
    "neighbouring":"neighboring",
    "hospitalisation":"hospitalization",
    "visualising":"visualizing",
    "temporising":"temporizing",
    "tantalise":"tantalize",
    "kilometre":"kilometer",
    "deodorising":"deodorizing",
    "naturalises":"naturalizes",
    "extemporised":"extemporized",
    "overemphasising":"overemphasizing",
    "tumours":"tumors",
    "extemporises":"extemporizes",
    "legitimising":"legitimizing",
    "pedalling":"pedaling",
    "memorialises":"memorializes",
    "praesidiums":"presidiums",
    "tricolour":"tricolor",
    "demilitarising":"demilitarizing",
    "memorialised":"memorialized",
    "traumatises":"traumatizes",
    "neighbourly":"neighborly",
    "duelling":"dueling",
    "glamorising":"glamorizing",
    "traumatised":"traumatized",
    "materialise":"materialize",
    "counselled":"counseled",
    "materialises":"materializes",
    "underutilised":"underutilized",
    "chequebooks":"checkbooks",
    "moulding":"molding",
    "materialised":"materialized",
    "serialised":"serialized",
    "fantasises":"fantasizes",
    "visualisation":"visualization",
    "fossilisation":"fossilization",
    "enamoured":"enamored",
    "randomise":"randomize",
    "sepulchre":"sepulcher",
    "worshipping":"worshiping",
    "revitalised":"revitalized",
    "revitalises":"revitalizes",
    "flavourings":"flavorings",
    "scepticism":"skepticism",
    "flavoured":"flavored",
    "misdemeanours":"misdemeanors",
    "succouring":"succoring",
    "licence":"license",
    "catalysing":"catalyzing",
    "bingeing":"binging",
    "metre":"meter",
    "harmonisation":"harmonization",
    "decriminalise":"decriminalize",
    "victimised":"victimized",
    "cauterise":"cauterize",
    "materialising":"materializing",
    "levellers":"levelers",
    "enamelling":"enameling",
    "sceptics":"skeptics",
    "rhapsodised":"rhapsodized",
    "laboured":"labored",
    "labourer":"laborer",
    "labelled":"labeled",
    "rhapsodises":"rhapsodizes",
    "unequalled":"unequaled",
    "unrivalled":"unrivaled",
    "fulfils":"fulfills",
    "womanisers":"womanizers",
    "videodiscs":"videodisks",
    "prioritise":"prioritize",
    "ghettoise":"ghettoize",
    "synchronise":"synchronize",
    "marginalising":"marginalizing",
    "optimised":"optimized",
    "nationalisations":"nationalizations",
    "parlour":"parlor",
    "optimises":"optimizes",
    "specialisations":"specializations",
    "specialisation":"specialization",
    "factorise":"factorize",
    "annualised":"annualized",
    "chequebook":"checkbook",
    "bevvy":"bevy",
    "militarise":"militarize",
    "denationalising":"denationalizing",
    "fossilise":"fossilize",
    "italicised":"italicized",
    "favourites":"favorites",
    "italicises":"italicizes",
    "moisturise":"moisturize",
    "overemphasised":"overemphasized",
    "categorise":"categorize",
    "minimising":"minimizing",
    "offences":"offenses",
    "overemphasises":"overemphasizes",
    "finalising":"finalizing",
    "flautist":"flutist",
    "equalise":"equalize",
    "carolling":"caroling",
    "crenellated":"crenelated",
    "cauterised":"cauterized",
    "emphasised":"emphasized",
    "cauterises":"cauterizes",
    "dishevelled":"disheveled",
    "emphasises":"emphasizes",
    "stabilise":"stabilize",
    "shrivelling":"shriveling",
    "kilometres":"kilometers",
    "demobilises":"demobilizes",
    "gaoled":"jailed",
    "utilisable":"utilizable",
    "moralising":"moralizing",
    "gaoler":"jailer",
    "immortalise":"immortalize",
    "draughtboard":"draftboard",
    "demobilised":"demobilized",
    "memorising":"memorizing",
    "immunised":"immunized",
    "externalises":"externalizes",
    "privatisation":"privatization",
    "baulk":"balk",
    "sceptres":"scepters",
    "pasteurise":"pasteurize",
    "passivisation":"passivization",
    "externalised":"externalized",
    "immunises":"immunizes",
    "programmes":"programs",
    "saviours":"saviors",
    "pasteurised":"pasteurized",
    "vaporisation":"vaporization",
    "gravelled":"graveled",
    "behaviours":"behaviors",
    "favours":"favors",
    "pasteurises":"pasteurizes",
    "passivised":"passivized",
    "sterilisations":"sterilizations",
    "marvelled":"marveled",
    "pharmacopoeia":"pharmacopeia",
    "bastardise":"bastardize",
    "sodomises":"sodomizes",
    "chilli":"chili",
    "equalisation":"equalization",
    "pouffes":"poufs",
    "externalisation":"externalization",
    "prioritisation":"prioritization",
    "modernising":"modernizing",
    "subsidises":"subsidizes",
    "instils":"instills",
    "energising":"energizing",
    "fertilises":"fertilizes",
    "fertiliser":"fertilizer",
    "savour":"savor",
    "privatise":"privatize",
    "fertilised":"fertilized",
    "demoralised":"demoralized",
    "favouritism":"favoritism",
    "cyphers":"ciphers",
    "marvelling":"marveling",
    "draughtsmen":"draftsmen",
    "philosophise":"philosophize",
    "traveller":"traveler",
    "funnelling":"funneling",
    "anaemia":"anemia",
    "anaemic":"anemic",
    "privatising":"privatizing",
    "travelled":"traveled",
    "eulogised":"eulogized",
    "apologise":"apologize",
    "vocalising":"vocalizing",
    "inflexion":"inflection",
    "plough":"plow",
    "misspelt":"misspelled",
    "popularises":"popularizes",
    "capitalised":"capitalized",
    "accessorising":"accessorizing",
    "labourers":"laborers",
    "humours":"humors",
    "savouring":"savoring",
    "popularised":"popularized",
    "acclimatisation":"acclimatization",
    "capitalises":"capitalizes",
    "labouring":"laboring",
    "leveller":"leveler",
    "capitalising":"capitalizing",
    "hybridise":"hybridize",
    "rhapsodising":"rhapsodizing",
    "crystallising":"crystallizing",
    "levelled":"leveled",
    "mechanise":"mechanize",
    "trialled":"trialed",
    "synchronising":"synchronizing",
    "centre":"center",
    "familiarise":"familiarize",
    "imperilled":"imperiled",
    "brutalising":"brutalizing",
    "liquidise":"liquidize",
    "energise":"energize",
    "instil":"instill",
    "centimetres":"centimeters",
    "disembowelled":"disemboweled",
    "bougainvillaeas":"bougainvilleas",
    "acclimatise":"acclimatize",
    "tranquillise":"tranquilize",
    "grovelling":"groveling",
    "industrialise":"industrialize",
    "fertilising":"fertilizing",
    "colourfully":"colorfully",
    "woolly":"wooly",
    "economise":"economize",
    "haemorrhages":"hemorrhages",
    "passivises":"passivizes",
    "materialisation":"materialization",
    "haemorrhaged":"hemorrhaged",
    "succour":"succor",
    "rigours":"rigors",
    "finalises":"finalizes",
    "dishonours":"dishonors",
    "pressurised":"pressurized",
    "enamelled":"enameled",
    "sensitised":"sensitized",
    "finalised":"finalized",
    "digitise":"digitize",
    "democratising":"democratizing",
    "pressurises":"pressurizes",
    "romanticised":"romanticized",
    "verbalises":"verbalizes",
    "decentralisation":"decentralization",
    "romanticises":"romanticizes",
    "verbalised":"verbalized",
    "categorises":"categorizes",
    "scandalise":"scandalize",
    "refuelling":"refueling",
    "categorised":"categorized",
    "filleted":"fileted",
    "gynaecologists":"gynecologists",
    "economising":"economizing",
    "industrialising":"industrializing",
    "pulverise":"pulverize",
    "empathise":"empathize",
    "mechanised":"mechanized",
    "bedevilled":"bedeviled",
    "westernise":"westernize",
    "hypnotises":"hypnotizes",
    "shovelling":"shoveling",
    "vaporise":"vaporize",
    "mechanises":"mechanizes",
    "tyre":"tire",
    "hypnotised":"hypnotized",
    "globalisation":"globalization",
    "jewelled":"jeweled",
    "eulogising":"eulogizing",
    "jeweller":"jeweler",
    "refuelled":"refueled",
    "syphons":"siphons",
    "centilitre":"centiliter",
    "utilising":"utilizing",
    "inflexions":"inflections",
    "sympathising":"sympathizing",
    "accessorise":"accessorize",
    "deputised":"deputized",
    "colonisation":"colonization",
    "snowplough":"snowplow",
    "distil":"distill",
    "deputises":"deputizes",
    "groynes":"groins",
    "normalisation":"normalization",
    "sermonise":"sermonize",
    "authorises":"authorizes",
    "weaselled":"weaseled",
    "outmanoeuvring":"outmaneuvering",
    "haemorrhage":"hemorrhage",
    "agonisingly":"agonizingly",
    "externalising":"externalizing",
    "vocalisations":"vocalizations",
    "localising":"localizing",
    "neighbour":"neighbor",
    "haemophiliacs":"hemophiliacs",
    "hypothesised":"hypothesized",
    "appetising":"appetizing",
    "economised":"economized",
    "cypher":"cipher",
    "canonises":"canonizes",
    "moisturiser":"moisturizer",
    "philtres":"filters",
    "canonised":"canonized",
    "economises":"economizes",
    "monopolised":"monopolized",
    "empathised":"empathized",
    "fictionalising":"fictionalizing",
    "terrorises":"terrorizes",
    "caramelised":"caramelized",
    "monopolises":"monopolizes",
    "professionalisation":"professionalization",
    "caramelises":"caramelizes",
    "terrorised":"terrorized",
    "exorcising":"exorcizing",
    "valour":"valor",
    "terrorise":"terrorize",
    "appetisers":"appetizers",
    "caesarean":"cesarean",
    "moustachioed":"mustachioed",
    "colouring":"coloring",
    "politicise":"politicize",
    "verbalising":"verbalizing",
    "ghettoising":"ghettoizing",
    "colour":"color",
    "factorises":"factorizes",
    "pyjama":"pajama",
    "factorised":"factorized",
    "pedestrianise":"pedestrianize",
    "realised":"realized",
    "memorises":"memorizes",
    "orthopaedic":"orthopedic",
    "pressurise":"pressurize",
    "immobilisers":"immobilizers",
    "memorised":"memorized",
    "radicalising":"radicalizing",
    "urbanisation":"urbanization",
    "modellers":"modelers",
    "optimising":"optimizing",
    "collectivising":"collectivizing",
    "mitre":"miter",
    "practise":"practice",
    "mechanisation":"mechanization",
    "normalise":"normalize",
    "itemises":"itemizes",
    "sterilisers":"sterilizers",
    "digitising":"digitizing",
    "calliper":"caliper",
    "depersonalise":"depersonalize",
    "colonising":"colonizing",
    "counsellors":"counselors",
    "colourant":"colorant",
    "particularises":"particularizes",
    "shovelled":"shoveled",
    "tyrannises":"tyrannizes",
    "fantasise":"fantasize",
    "particularised":"particularized",
    "spectres":"specters",
    "tyrannised":"tyrannized",
    "ostracise":"ostracize",
    "pedestrianises":"pedestrianizes",
    "naturalisation":"naturalization",
    "revolutionising":"revolutionizing",
    "pedestrianised":"pedestrianized",
    "clarinettist":"clarinetist",
    "tranquillised":"tranquilized",
    "epicentre":"epicenter",
    "analysed":"analyzed",
    "paediatric":"pediatric",
    "individualise":"individualize",
    "anaesthetised":"anesthetized",
    "channelling":"channeling",
    "tenderises":"tenderizes",
    "colourizing":"colorizing",
    "cancelation":"cancellation",
    "intellectualising":"intellectualizing",
    "tenderised":"tenderized",
    "artefact":"artifact",
    "localised":"localized",
    "unfavourable":"unfavorable",
    "humanising":"humanizing",
    "fictionalisation":"fictionalization",
    "demobilise":"demobilize",
    "backpedalling":"backpedaling",
    "localises":"localizes",
    "flautists":"flutists",
    "unfavourably":"unfavorably",
    "quarrelling":"quarreling",
    "endeavours":"endeavors",
    "patronisingly":"patronizingly",
    "demeanour":"demeanor",
    "tranquillises":"tranquilizes",
    "sabre":"saber",
    "polarising":"polarizing",
    "gambolling":"gamboling",
    "customising":"customizing",
    "foetuses":"fetuses",
    "sceptic":"skeptic",
    "institutionalising":"institutionalizing",
    "demilitarise":"demilitarize",
    "finalisation":"finalization",
    "kilogrammes":"kilograms",
    "unrecognised":"unrecognized",
    "intellectualised":"intellectualized",
    "regularising":"regularizing",
    "baptise":"baptize",
    "weaselling":"weaseling",
    "intellectualises":"intellectualizes",
    "cosiness":"coziness",
    "commercialising":"commercializing",
    "conceptualise":"conceptualize",
    "ploughing":"plowing",
    "destabilise":"destabilize",
    "democratise":"democratize",
    "westernised":"westernized",
    "satirise":"satirize",
    "saviour":"savior",
    "westernises":"westernizes",
    "gipsies":"gypsies",
    "disembowelling":"disemboweling",
    "victimise":"victimize",
    "scrutinising":"scrutinizing",
    "draught":"draft",
    "decriminalises":"decriminalizes",
    "socialising":"socializing",
    "equalising":"equalizing",
    "tranquilliser":"tranquilizer",
    "decriminalised":"decriminalized",
    "monopolising":"monopolizing",
    "mouldiest":"moldiest",
    "carbonise":"carbonize",
    "galvanise":"galvanize",
    "pulverisation":"pulverization",
    "gruellingly":"gruelingly",
    "tonnes":"tons",
    "bussing":"busing",
    "louver":"louvre",
    "yupp":"yup",
    "taht's":"that's",
    "somehting":"something",
    "intersting":"interesting",
    "im":"I'm",
    "acutally":"actually",
    "aroudn":"around",
    "aobut":"about",
    "litle":"little",
    "mena":"mean",
    "phoen":"phone",
    "tlak":"talk",
    "thye":"they",
    "thoguht":"thought",
    "whne":"when",
    "soemthing":"something",
    "startd":"started",
    "tehm":"them",
    "anyting":"anything",
    "oen":"one",
    "kidn":"kind",
    "your'e":"you're",
    "workign":"working",
    "tehy're":"they're",
    "iwht":"with",
    "hwo":"how",
    "htem":"them",
    "worht":"worth",
    "aprt":"part",
    "quesitons":"questions",
    "oyu":"you",
    "everythign":"everything",
    "mcuh":"much",
    "oculd":"could",
    "coupel":"couple",
    "everyhting":"everything",
    "doen":"done",
    "giong":"going",
    "expereince":"experience",
    "odn't":"don't",
    "copule":"couple",
    "alos":"also",
    "dont'":"don't",
    "ocme":"come",
    "probalby":"probably",
    "palces":"places",
    "anotehr":"another",
    "osmething":"something",
    "paretns":"parents",
    "quesiton":"question",
    "rahter":"rather",
    "sayign":"saying",
    "epople":"people",
    "opportunites":"opportunities",
    "invovled":"involved",
    "managemnt":"management",
    "yourslef":"yourself",
    "rihgt":"right",
    "eyah":"yeah",
    "ther's":"there's",
    "theyr'e":"they're",
    "whoel":"whole",
    "thy're":"they're",
    "wehre":"where",
    "thorugh":"through",
    "wer'e":"we're",
    "differnce":"difference",
    "tehse":"these",
    "actaully":"actually",
    "compnay":"company",
    "busienss":"business",
    "htey're":"they're",
    "busines":"business",
    "sometiems":"sometimes",
    "thoguhts":"thoughts",
    "peope":"people",
    "runnign":"running",
    "mabye":"maybe",
    "msot":"most",
    "nubmer":"number",
    "organzation":"organization",
    "eprson":"person",
    "kidns":"kinds",
    "oru":"our",
    "I\"ve":"I've",
    "I'ts":"It's",
    "interst":"interest",
    "millenials":"millennials",
    "insdie":"inside",
    "mintues":"minutes",
    "listend":"listened",
    "situtation":"situation",
    "rgiht":"right",
    "qustion":"question",
    "osme":"some",
    "rigth":"right",
    "soembody":"somebody",
    "studetns":"students",
    "shold":"should",
    "specifiy":"specify",
    "studnets":"students",
    "htose":"those",
    "htinking":"thinking",
    "tihnk":"think",
    "htings":"things",
    "they'er":"they're",
    "Tehre's":"There's",
    "thse":"these",
    "tat's":"that's",
    "Tha'ts":"That's",
    "competitve":"competitive",
    "compeltely":"completely",
    "btu":"but",
    "calss":"class",
    "appraoch":"approach",
    "anythign":"anything",
    "anywehre":"anywhere",
    "bleive":"believe",
    "bcause":"because",
    "enoguh":"enough",
    "behidn":"behind",
    "excpet":"except",
    "happenign":"happening",
    "donw":"down",
    "ahven't":"haven't",
    "governemnt":"government",
    "fisrt":"first",
    "gusy":"guys",
    "facebook":"Facebook",
    "we'l":"we'll",
    "unusal":"unusual",
    "Yeha":"Yeah",
    "veiw":"view",
    "urself":"yourself",
    "wnet":"went",
    "waht's":"what's",
    "wahtever":"whatever",
    "throguh":"through",
    "tyring":"trying",
    "tehn":"then",
    "htye":"they",
    "themsleves":"themselves",
    "hwat":"what",
    "takling":"talking",
    "makign":"making",
    "tihngs":"things",
    "imporant":"important",
    "mnay":"many",
    "indian":"Indian",
    "intersted":"interested",
    "motnhs":"months",
    "indivudal":"individual",
    "opportunties":"opportunities",
    "Oaky":"Okay",
    "mornign":"morning",
    "netowrk":"network",
    "amtter":"matter",
    "simlar":"similar",
    "realted":"related",
    "somethng":"something",
    "I,ve":"I've",
    "hsould":"should",
    "pcitures":"pictures",
    "somehwere":"somewhere",
    "pelase":"please",
    "progarm":"program",
    "amoutn":"amount",
    "reachign":"reaching",
    "appreicate":"appreciate",
    "abck":"back",
    "becasuse":"because",
    "converstaion":"conversation",
    "alrady":"already",
    "coems":"comes",
    "comon":"common",
    "becaue":"because",
    "beign":"being",
    "chnge":"change",
    "beofre":"before",
    "curent":"current",
    "differnet":"different",
    "hleped":"helped",
    "emplyee":"employee",
    "friedn":"friend",
    "ahrd":"hard",
    "hosue":"house",
    "frineds":"friends",
    "ugys":"guys",
    "direciton":"direction",
    "experince":"experience",
    "ogod":"good",
    "fmaily":"family",
    "michael":"Michael",
    "james":"James",
    "robert":"Robert",
    "william":"William",
    "thomas":"Thomas",
    "david":"David",
    "christopher":"Christopher",
    "charles":"Charles",
    "richard":"Richard",
    "daniel":"Daniel",
    "anthony":"Anthony",
    "paul":"Paul",
    "donald":"Donald",
    "matthew":"Matthew",
    "kenneth":"Kenneth",
    "steven":"Steven",
    "andrew":"Andrew",
    "kevin":"Kevin",
    "joshua":"Joshua",
    "edward":"Edward",
    "george":"George",
    "ronald":"Ronald",
    "jason":"Jason",
    "jeffrey":"Jeffrey",
    "brian":"Brian",
    "ryan":"Ryan",
    "jacob":"Jacob",
    "nicholas":"Nicholas",
    "gary":"Gary",
    "stephen":"Stephen",
    "eric":"Eric",
    "larry":"Larry",
    "jonathan":"Jonathan",
    "justin":"Justin",
    "scott":"Scott",
    "brandon":"Brandon",
    "benjamin":"Benjamin",
    "gregory":"Gregory",
    "samuel":"Samuel",
    "patrick":"Patrick",
    "raymond":"Raymond",
    "alex":"Alex",
    "dennis":"Dennis",
    "douglas":"Douglas",
    "tyler":"Tyler",
    "aaron":"Aaron",
    "adam":"Adam",
    "zachary":"Zachary",
    "nathan":"Nathan",
    "jose":"Jose",
    "harold":"Harold",
    "arthur":"Arthur",
    "kyle":"Kyle",
    "gerald":"Gerald",
    "walter":"Walter",
    "jeremy":"Jeremy",
    "lawrence":"Lawrence",
    "christian":"Christian",
    "sean":"Sean",
    "keith":"Keith",
    "austin":"Austin",
    "jesse":"Jesse",
    "bryan":"Bryan",
    "billy":"Billy",
    "bruce":"Bruce",
    "jordan":"Jordan",
    "noah":"Noah",
    "ethan":"Ethan",
    "eugene":"Eugene",
    "dylan":"Dylan",
    "roy":"Roy",
    "juan":"Juan",
    "russell":"Russell",
    "gabriel":"Gabriel",
    "wayne":"Wayne",
    "philip":"Philip",
    "vincent":"Vincent",
    "logan":"Logan",
    "johnny":"Johnny",
    "mary":"Mary",
    "patricia":"Patricia",
    "elizabeth":"Elizabeth",
    "alan":"Alan",
    "jennifer":"Jennifer",
    "linda":"Linda",
    "barbara":"Barbara",
    "margaret":"Margaret",
    "susan":"Susan",
    "jessica":"Jessica",
    "nancy":"Nancy",
    "sarah":"Sarah",
    "lisa":"Lisa",
    "dorothy":"Dorothy",
    "ashley":"Ashley",
    "sandra":"Sandra",
    "karen":"Karen",
    "kimberly":"Kimberly",
    "amanda":"Amanda",
    "michelle":"Michelle",
    "helen":"Helen",
    "melissa":"Melissa",
    "stephanie":"Stephanie",
    "deborah":"Deborah",
    "laura":"Laura",
    "rebecca":"Rebecca",
    "cynthia":"Cynthia",
    "sharon":"Sharon",
    "kathleen":"Kathleen",
    "emily":"Emily",
    "shirley":"Shirley",
    "angela":"Angela",
    "amy":"Amy",
    "ruth":"Ruth",
    "brenda":"Brenda",
    "pamela":"Pamela",
    "nicole":"Nicole",
    "virginia":"Virginia",
    "catherine":"Catherine",
    "katherine":"Katherine",
    "christine":"Christine",
    "anna":"Anna",
    "samantha":"Samantha",
    "janet":"Janet",
    "rachel":"Rachel",
    "carolyn":"Carolyn",
    "maria":"Maria",
    "debra":"Debra",
    "diane":"Diane",
    "emma":"Emma",
    "joyce":"Joyce",
    "frances":"Frances",
    "joan":"Joan",
    "evelyn":"Evelyn",
    "victoria":"Victoria",
    "christina":"Christina",
    "martha":"Martha",
    "julie":"Julie",
    "judith":"Judith",
    "megan":"Megan",
    "lauren":"Lauren",
    "andrea":"Andrea",
    "cheryl":"Cheryl",
    "doris":"Doris",
    "alice":"Alice",
    "jacqueline":"Jacqueline",
    "ann":"Ann",
    "kathryn":"Kathryn",
    "gloria":"Gloria",
    "hannah":"Hannah",
    "teresa":"Teresa",
    "marie":"Marie",
    "olivia":"Olivia",
    "judy":"Judy",
    "sara":"Sara",
    "julia":"Julia",
    "theresa":"Theresa",
    "janice":"Janice",
    "beverly":"Beverly",
    "marilyn":"Marilyn",
    "denise":"Denise",
    "danielle":"Danielle",
    "diana":"Diana",
    "brittany":"Brittany",
    "madison":"Madison",
    "abigail":"Abigail",
    "natalie":"Natalie",
    "lori":"Lori",
    "alexis":"Alexis",
    "kayla":"Kayla",
    "accountign":"accounting",
    "actign":"acting",
    "addign":"adding",
    "advertisign":"advertising",
    "allowign":"allowing",
    "anythign":"anything",
    "askign":"asking",
    "backign":"backing",
    "bankign":"banking",
    "bearign":"bearing",
    "becomign":"becoming",
    "beginnign":"beginning",
    "beign":"being",
    "bindign":"binding",
    "borign":"boring",
    "breakign":"breaking",
    "breathign":"breathing",
    "brign":"bring",
    "bringign":"bringing",
    "buildign":"building",
    "burnign":"burning",
    "buyign":"buying",
    "callign":"calling",
    "cant":"can't",
    "carryign":"carrying",
    "causign":"causing",
    "ceilign":"ceiling",
    "changign":"changing",
    "cleanign":"cleaning",
    "closign":"closing",
    "clothign":"clothing",
    "comign":"coming",
    "concernign":"concerning",
    "considerign":"considering",
    "containign":"containing",
    "continuign":"continuing",
    "coverign":"covering",
    "creatign":"creating",
    "crossign":"crossing",
    "cuttign":"cutting",
    "darlign":"darling",
    "dealign":"dealing",
    "developign":"developing",
    "doign":"doing",
    "drawign":"drawing",
    "drinkign":"drinking",
    "drivign":"driving",
    "durign":"during",
    "eatign":"eating",
    "endign":"ending",
    "engineerign":"engineering",
    "evenign":"evening",
    "everythign":"everything",
    "excitign":"exciting",
    "existign":"existing",
    "facign":"facing",
    "fallign":"falling",
    "feelign":"feeling",
    "fightign":"fighting",
    "findign":"finding",
    "fishign":"fishing",
    "fittign":"fitting",
    "flipside":"flip side",
    "flyign":"flying",
    "followign":"following",
    "fuckign":"fucking",
    "fulltime":"full-time",
    "fundign":"funding",
    "gatherign":"gathering",
    "gettign":"getting",
    "givign":"giving",
    "goign":"going",
    "growign":"growing",
    "handlign":"handling",
    "hangign":"hanging",
    "happenign":"happening",
    "havign":"having",
    "headign":"heading",
    "hearign":"hearing",
    "helpign":"helping",
    "holdign":"holding",
    "hopign":"hoping",
    "housign":"housing",
    "huntign":"hunting",
    "includign":"including",
    "increasign":"increasing",
    "interestign":"interesting",
    "interpretor":"interpreter",
    "involvign":"involving",
    "keepign":"keeping",
    "kign":"king",
    "killign":"killing",
    "knowign":"knowing",
    "landign":"landing",
    "leadign":"leading",
    "learnign":"learning",
    "leavign":"leaving",
    "listenign":"listening",
    "livign":"living",
    "lookign":"looking",
    "losign":"losing",
    "lyign":"lying",
    "makign":"making",
    "managign":"managing",
    "manufacturign":"manufacturing",
    "marketign":"marketing",
    "meanign":"meaning",
    "meetign":"meeting",
    "missign":"missing",
    "cant":"can't",
    "monitorign":"monitoring",
    "mornign":"morning",
    "movign":"moving",
    "nothign":"nothing",
    "nursign":"nursing",
    "offerign":"offering",
    "openign":"opening",
    "operatign":"operating",
    "outstandign":"outstanding",
    "paintign":"painting",
    "passign":"passing",
    "payign":"paying",
    "plannign":"planning",
    "playign":"playing",
    "printign":"printing",
    "proceedign":"proceeding",
    "processign":"processing",
    "producign":"producing",
    "providign":"providing",
    "publishign":"publishing",
    "puttign":"putting",
    "racign":"racing",
    "raisign":"raising",
    "ratign":"rating",
    "reachign":"reaching",
    "readign":"reading",
    "receivign":"receiving",
    "recordign":"recording",
    "reducign":"reducing",
    "relatign":"relating",
    "remainign":"remaining",
    "reportign":"reporting",
    "resultign":"resulting",
    "returnign":"returning",
    "ridign":"riding",
    "risign":"rising",
    "rulign":"ruling",
    "runnign":"running",
    "sailign":"sailing",
    "savign":"saving",
    "sayign":"saying",
    "seeign":"seeing",
    "seekign":"seeking",
    "sellign":"selling",
    "servign":"serving",
    "settign":"setting",
    "shootign":"shooting",
    "shoppign":"shopping",
    "showign":"showing",
    "sittign":"sitting",
    "smokign":"smoking",
    "somethign":"something",
    "speakign":"speaking",
    "spendign":"spending",
    "sprign":"spring",
    "standign":"standing",
    "startign":"starting",
    "stayign":"staying",
    "sterlign":"sterling",
    "strign":"string",
    "sufferign":"suffering",
    "supportign":"supporting",
    "surprisign":"surprising",
    "surroundign":"surrounding",
    "swign":"swing",
    "swimmign":"swimming",
    "takign":"taking",
    "talkign":"talking",
    "teachign":"teaching",
    "tellign":"telling",
    "testign":"testing",
    "thees":"these",
    "thign":"thing",
    "thinkign":"thinking",
    "timign":"timing",
    "tradign":"trading",
    "trainign":"training",
    "travellign":"traveling",
    "tryign":"trying",
    "turnign":"turning",
    "uhh":"uh",
    "uhm":"um",
    "umm":"um",
    "understandign":"understanding",
    "undertakign":"undertaking",
    "usign":"using",
    "visitign":"visiting",
    "waitign":"waiting",
    "walkign":"walking",
    "warnign":"warning",
    "washign":"washing",
    "watchign":"watching",
    "wearign":"wearing",
    "weddign":"wedding",
    "willign":"willing",
    "winnign":"winning",
    "woah":"whoa",
    "workign":"working",
    "writign":"writing",
    "moreso":"more so",
    "english":"English",
    "american":"American",
    "america":"America" ,
    "alright":"all right",
    "erally":"really",
    "wehther":"whether",
    "opiod":"opioid",
    "opiods":"opioids",
    "medicare":"Medicare",
    "medicaid":"Medicaid",
    "muslim":"Muslim",
    "cambera":"Canberra",
    "canbera":"Canberra",
    "youtube":"YouTube",
    "linkedin":"LinkedIn",
    "heres":"here's",
    "ok":"okay",
    "cos":"'cause",
    "cuz":"'cause",
    "psychoanalyses":"psychoanalyzes",
    "glamor":"glamour",
    "vmware":"VMware"
}/*parser:end*/;

window.revEditor.NonVerbatimAutoCorrectList =
/*parser-contraction:begin*/{
    "gonna":"going to",
    "wanna":"want to",
    "cuz":"because",
    "coz":"because",
    "cos":"because",
    "'cause":"because",
    "cus":"because",
    "'em":"them",
    "doin":"doing",
    "goin":"going",
    "alright":"all right",
    "gotta":"got to",
    "kinda":"kind of",
    "sorta":"sort of",
    "dunno":"don't know",
    "lemme":"let me",
    "gimme":"give me",
    "mm-hmm":"mm-hmm",
    "mm-mm":"mm-mm",
    "uh-huh":"uh-huh",
    "uh-uh":"uh-uh",
    "mhm":"mm-hmm",
    "mmhmm":"mm-hmm",
    "mmhm":"mm-hmm",
    "mhmm":"mm-hmm",
    "uhuh":"uh-uh",
    "shoulda":"should have",
    "outta":"out of",
    "cmon":"come on",
    "oughta":"ought to",
    "needa":"need to",
    "whatcha":"what are you",
    "hafta":"have to"
}/*parser-contraction:end*/;
